<template>
  <div>
    <div v-if="isLoading" class="loading-mask">
      <div class="spinner-border text-light" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="page-container wrap">
      <main id="page-main">
        <div class="page-content article-main">
          <div v-show="pageStage === 0" style="max-width: 800px; margin: 0 auto">
            <div class="article-top">
              <div class="article-title text-center">
                個人資料蒐集聲明暨同意書
              </div>
            </div>
            <div class="article-wrap">
              <div class="article-content">
                <p class="template-block">
                  國教署學務校安組網站系統（以下簡稱「本系統」）依據「個人資料保護法」第八條第一項規定，向台端告知下列事項。當您簽署本同意書時，表示您已閱讀、瞭解並同意本同意書之所有內容。若您未滿二十歲，應於您的法定代理人閱讀、瞭解並同意本同意書之所有內容，本系統始得蒐集、處理、利用個人資料，並遵守以下所有規範。
                </p>
                <p class="template-block">一、 個人資料之蒐集目的</p>
                <p class="template-block">
                  1.
                  本系統依據教育部高級中等學校學生新世紀領導人才培育計畫辦理，為辦理報名資審查與後續相關事宜所必需蒐集您的個人資料。
                </p>
                <p class="template-block">
                  2.
                  本表單所蒐集您的個人資料類別，包括姓名、出生年月日、國民身分證統一編號、聯絡方式等。
                </p>
                <p class="template-block">
                  3.
                  本系統利用您的個人資料之地區為臺灣地區，使用期間為即日起本系統就台端所填具之資料(含申請時填寫或繳交之資料)，於報名期間內依個人資料保護法、相關法令於各項業務範圍內進行處理及利用。利用之方式為書面、電子、網際網路或其它適當方式。
                </p>
                <p class="template-block">二、 個人資料之使用方式：</p>
                <p class="template-block">
                  1.
                  本系統依據教育部國民及學前教育暑【個人資料隱私權宣告與說明】，且遵循「個人資料保護法」與相關法令之規範下，蒐集、處理及利用您的個人資料。
                </p>
                <p class="template-block">
                  2.
                  請務必提供正確、最新及完整的個人資料，若個人資料有誤或不完整，您將可能損失相關權益。
                </p>
                <p class="template-block">
                  3.
                  您可向本校所蒐集之您的個人資料，進行查詢或閱覽、製給複製本、要求補充或更正。
                </p>
                <p class="template-block">
                  4.
                  您可要求本校停止蒐集、處理或利用您的個人資料，或是要求刪除您的個人資料，但若為本系統執行職務或業務所必須者，得拒絕之。
                </p>
                <p class="template-block">
                  5.
                  若您行使上述權利，而導致權益受損時，本系統將不負相關賠償責任。如您對上述事項
                  有疑議時，請參考本系統【個人資料隱私權宣告與說明】之個人資料保護聯絡窗口聯絡
                  方式與本系統承辦人聯繫。
                </p>
                <p class="template-block">
                  6.
                  當您的個人資料使用方式與原先蒐集的目的不同時，本系統會在使用前先徵求您的書面同意，您可以拒絕本校利用您的個人資料，但可能導致您的權益受損。
                </p>
                <p class="template-block">
                  三、
                  個人資料之保護您的個人資料受到本系統【個人資料隱私權宣告與說明】之保護及規範。倘若發生違反「個人資料保護法」規定或因天災、事變或其他不可抗力之因素，導致您的個人資料被竊取、洩漏、竄改、遭其他侵害者，本系統將於查明後以電話、信函、電子郵件或網站公告等方法，擇適當方式通知您。
                </p>
                <p class="template-block">四、 同意書之效力：</p>
                <p class="template-block">
                  1.
                  本系統保留隨時修改本同意書規範之權利，並將修訂後之規範公告於網站，不另作個別通知。如果您不同意修改的內容，請直接與系統承辦窗口聯繫。否則將視為您已同意並接受本同意書之增訂或修改內容。
                </p>
                <p class="template-block">
                  2.
                  您自本同意書取得的任何建議或資訊，無論是書面或口頭形式，除非本同意書條款有明確規定，均不構成本同意條款以外之任何保證。
                </p>
                <p class="template-block">
                  經本系統向您告知上開事項，當您勾選並親自簽章後，即視為您已詳閱並了解本同意書內容，且同意遵守所有事項。
                </p>
              </div>
            </div>
            <div class="col-12 text-center">
              <label class="checkbox-text">
                <input type="checkbox" style="height: auto;" v-model="isAgree" />
                我已閱讀並同意</label>
            </div>
            <div class="btn-lg w-100 text-center">
              <button v-show="isAgree" type="button" @click="nextStage(null)" class="btn btn-lg">
                下一頁
              </button>
            </div>
          </div>
          <div v-show="pageStage === 1" style="max-width: 800px; margin: 0 auto">
            <div class="article-top">
              <div class="article-title text-center">報名資料 補充說明</div>
            </div>
            <div class="article-wrap">
              <div class="article-content">
                <div class="template-block" style="white-space: pre-wrap">
                  {{ activity.signupIllustration }}
                </div>
              </div>
            </div>

            <div class="btn-lg w-100 text-center">
              <button type="button" @click="nextStage(null)" class="btn btn-lg">
                下一頁
              </button>
            </div>
          </div>
          <form ref="formStage1" @submit.prevent v-show="pageStage === 2">
            <div class="article-top">
              <div class="article-title">
                {{ activity.title }}
              </div>
            </div>
            <div class="article-wrap">
              <div class="article-content">
                <div class="template-block">
                  <div class="from-block">
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_identity_no" class="name text-right"><span class="color-r1">❋</span>
                            身分證字號：</label>
                          <input type="text" ref="idNo" id="data_identity_no" v-model="formData.idNo"
                            @change="clearError('idNo')" maxlength="10" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.idNo">
                            {{ errors.idNo }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_name" class="name text-right"><span class="color-r1">❋</span> 姓名：</label>
                          <input type="text" id="data_name" v-model="formData.name" @change="clearError('name')"
                            required />
                          <div class="field-error name" style="text-align: end" v-if="errors.name">
                            {{ errors.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_blood" class="name text-right"><span class="color-r1">❋</span> 血型：</label>
                          <select id="data_blood" v-model="formData.bloodType" @change="clearError('bloodType')"
                            required>
                            <option value="">請選擇</option>
                            <option value="A">A型</option>
                            <option value="B">B型</option>
                            <option value="AB">AB型</option>
                            <option value="O">O型</option>
                            <option value="未檢測">未檢測</option>
                          </select>
                          <div class="field-error name" style="text-align: end" v-if="errors.bloodType">
                            {{ errors.bloodType }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_sex" class="name text-right"><span class="color-r1">❋</span> 性別：</label>
                          <select id="data_sex" v-model="formData.gender" @change="clearError('gender')" required>
                            <option value="">請選擇</option>
                            <option value="生理男">生理男</option>
                            <option value="生理女">生理女</option>
                          </select>
                          <div class="field-error name" style="text-align: end" v-if="errors.gender">
                            {{ errors.gender }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_birthday" class="name text-right"><span class="color-r1">❋</span>
                            出生日期：</label>
                          <input class="datepicker" type="date" id="data_birthday" v-model="formData.birthDate"
                            @change="clearError('birthDate')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.birthDate">
                            {{ errors.birthDate }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="photoFile" class="name text-right"><span class="color-r1">❋</span>
                            上傳證件照：<br />(請上傳一年內2吋證件照，僅能上傳 JPG, PNG，單檔最大 50MB)</label>
                          <label for="photoFile" class="btn-default">選擇檔案</label>
                          <input type="file" accept="image/*" id="photoFile" @change="onFileChange($event, 'photoFile')"
                            style="display: none" />
                          <span style="vertical-align: top" ref="photoFile" tabindex="0" for="" class="name">
                            {{
                              formData.photoFile
                                ? formData.photoFile.name
                                : "尚未選擇檔案"
                            }}
                            <button type="button" class="close" aria-label="Close" @click="
                              removeFile('photoFile', 'deletePhotoFile')
                              ">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </span>
                          <div class="field-error name" style="text-align: end" v-if="errors.photoFile">
                            {{ errors.photoFile }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_city" class="name text-right"><span class="color-r1">❋</span>
                            學校所在縣市：</label>
                          <select id="data_city" v-model="formData.schoolCounty"
                            @change="clearError('schoolCounty'); clearSchoolNameValue()" required>
                            <option value="">請選擇</option>
                            <option value="臺北市">臺北市</option>
                            <option value="新北市">新北市</option>
                            <option value="基隆市">基隆市</option>
                            <option value="桃園市">桃園市</option>
                            <option value="新竹市">新竹市</option>
                            <option value="新竹縣">新竹縣</option>
                            <option value="苗栗縣">苗栗縣</option>
                            <option value="臺中市">臺中市</option>
                            <option value="彰化縣">彰化縣</option>
                            <option value="南投縣">南投縣</option>
                            <option value="雲林縣">雲林縣</option>
                            <option value="嘉義市">嘉義市</option>
                            <option value="嘉義縣">嘉義縣</option>
                            <option value="臺南市">臺南市</option>
                            <option value="高雄市">高雄市</option>
                            <option value="屏東縣">屏東縣</option>
                            <option value="宜蘭縣">宜蘭縣</option>
                            <option value="花蓮縣">花蓮縣</option>
                            <option value="臺東縣">臺東縣</option>
                            <option value="澎湖縣">澎湖縣</option>
                            <option value="金門縣">金門縣</option>
                            <option value="連江縣">連江縣</option>
                          </select>
                          <div class="field-error name" style="text-align: end" v-if="errors.schoolCounty">
                            {{ errors.schoolCounty }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-12">
                        <div class="input-row">
                          <label for="data_school" class="name text-right"><span class="color-r1">❋</span>
                            學校名稱(全稱)：</label>
                          <v-select ref="schoolSelector" @input="onSchoolSelected" v-model="formData.schoolName"
                            :options="autoCompleteSuggestions.filter(i => i.county == formData.schoolCounty).map(i => i.schoolName)">
                            <template #no-options>
                              <div class="text-muted p-2">沒有符合的學校</div>
                            </template>
                          </v-select>
                          <div class="field-error name" style="text-align: end" v-if="errors.schoolName">
                            {{ errors.schoolName }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_grade" class="name text-right"><span class="color-r1">❋</span> 年級：</label>
                          <select id="data_grade" v-model="formData.grade" @change="clearError('grade')" required>
                            <!-- <option value="">請選擇</option> -->
                            <option value="1">1</option>
                            <!-- <option value="2">2</option> -->
                            <!-- <option value="3">3</option> -->
                          </select>
                          <div class="field-error name" style="text-align: end" v-if="errors.grade">
                            {{ errors.grade }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_class" class="name text-right"><span class="color-r1">❋</span> 班級：</label>
                          <input type="text" id="data_class" v-model="formData.className"
                            @change="clearError('className')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.className">
                            {{ errors.className }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_city" class="name text-right"><span class="color-r1">❋</span> 學校型態：</label>
                          <select id="data_city" v-model="formData.schoolType" @change="clearError('schoolType')"
                            required>
                            <option value="">請選擇</option>
                            <option value="普通型高中(普高)">普通型高中(普高)</option>
                            <option value="技術型高中(高職)">技術型高中(高職)</option>
                            <option value="綜合高中學術學程">綜合高中學術學程</option>
                            <option value="綜合高中專門學程">綜合高中專門學程</option>
                            <option value="非學校型態實驗教育">非學校型態實驗教育</option>
                          </select>
                          <div class="field-error name" style="text-align: end" v-if="errors.schoolType">
                            {{ errors.schoolType }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6" v-if="showDepartmentField">
                        <div class="input-row">
                          <label for="data_department" class="name text-right"><span class="color-r1">❋</span>
                            科系：</label>
                          <input type="text" id="data_department" v-model="formData.schoolTrack"
                            @change="clearError('schoolTrack')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.schoolTrack">
                            {{ errors.schoolTrack }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6" v-else-if="showProgramField">
                        <div class="input-row">
                          <label for="data_program" class="name text-right"><span class="color-r1">❋</span> 學程：</label>
                          <input type="text" id="data_program" v-model="formData.schoolTrack"
                            @change="clearError('schoolTrack')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.schoolTrack">
                            {{ errors.schoolTrack }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_diet" class="name text-right"><span class="color-r1">❋</span> 飲食習慣：</label>
                          <select id="data_diet" v-model="formData.diet" @change="clearError('diet')" required>
                            <option value="">請選擇</option>
                            <option value="葷">葷</option>
                            <option value="素">素</option>
                            <option value="蛋奶素">蛋奶素</option>
                            <option value="其他">其他</option>
                          </select>
                          <div class="field-error name" style="text-align: end" v-if="errors.diet">
                            {{ errors.diet }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6" v-show="formData.diet === '其他'">
                        <div class="input-row">
                          <label for="data_job2" class="name text-right"><span class="color-r1">❋</span>
                            其他飲食習慣：</label>
                          <input ref="otherDiet" type="text" v-model="formData.otherDiet"
                            @change="clearError('otherDiet')" id="data_job2" class="input-lg" placeholder="請輸入飲食習慣" />
                          <div class="field-error name" style="text-align: end" v-if="errors.otherDiet">
                            {{ errors.otherDiet }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_telephone" class="name text-right"><span class="color-r1">❋</span>
                            聯絡電話(住家)：</label>
                          <input type="text" id="data_telephone" v-model="formData.homePhone"
                            @change="clearError('homePhone')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.homePhone">
                            {{ errors.homePhone }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_phone" class="name text-right"><span class="color-r1">❋</span>
                            聯絡電話(手機)：</label>
                          <input type="text" id="data_phone" v-model="formData.cellPhone"
                            @change="clearError('cellPhone')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.cellPhone">
                            {{ errors.cellPhone }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-12">
                        <div class="input-row">
                          <label for="data_email" class="name text-right"><span class="color-r1">❋</span>
                            E-mail：</label>
                          <div class="email-verify-row" style="width: 70%
                          ;">
                            <input type="email" id="data_email" v-model="formData.email" @change="clearError('email')"
                              :disabled="isEmailInputLocked" required />
                            <button type="button" class="btn btn-sm email-verify-btn"
                              :class="{ 'email-verify-btn--success': isEmailVerified }"
                              :disabled="isEmailVerifyButtonDisabled" @click="requestEmailVerification">
                              {{ emailVerifyButtonText }}
                            </button>
                            <span v-if="emailVerifyCountdownText" class="email-verify-countdown">
                              {{ emailVerifyCountdownText }}
                            </span>
                          </div>
                          <div class="field-error name" style="text-align: end" v-if="errors.email">
                            {{ errors.email }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-12">
                        <div class="input-row">
                          <label class="name text-right"><span class="color-r1">❋</span> 通訊地址：</label>
                          <input type="text" style="width: 130px" v-model="formData.addressCode"
                            @input="validateAddressCode" @change="clearError('addressCode')" required placeholder="郵遞區號"
                            maxlength="6" />
                          <div class="field-error name" style="text-align: end" v-if="errors.addressCode">
                            {{ errors.addressCode }}
                          </div>
                          <input type="text" id="data_address" v-model="formData.address"
                            @change="clearError('address')" style="flex: 1" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.address">
                            {{ errors.address }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_name1" class="name text-right"><span class="color-r1">❋</span> 家長姓名：</label>
                          <input type="text" id="data_name1" v-model="formData.parentName"
                            @change="clearError('parentName')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.parentName">
                            {{ errors.parentName }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_relation" class="name text-right"><span class="color-r1">❋</span> 關係：</label>
                          <input type="text" id="data_relation" v-model="formData.parentRelation"
                            @change="clearError('parentRelation')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.parentRelation">
                            {{ errors.parentRelation }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_telephone1" class="name text-right"><span class="color-r1">❋</span>
                            家長聯絡電話(日)：</label>
                          <input type="text" id="data_telephone1" v-model="formData.parentPhoneDay"
                            @change="clearError('parentPhoneDay')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.parentPhoneDay">
                            {{ errors.parentPhoneDay }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_telephone2" class="name text-right"><span class="color-r1">❋</span>
                            家長聯絡電話(夜)：</label>
                          <input type="text" id="data_telephone2" v-model="formData.parentPhoneNight"
                            @change="clearError('parentPhoneNight')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.parentPhoneNight">
                            {{ errors.parentPhoneNight }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_name2" class="name text-right"><span class="color-r1">❋</span>
                            緊急聯絡人姓名：</label>
                          <input type="text" id="data_name2" v-model="formData.emergencyContactName"
                            @change="clearError('emergencyContactName')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.emergencyContactName">
                            {{ errors.emergencyContactName }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_relation1" class="name text-right"><span class="color-r1">❋</span>
                            關係：</label>
                          <input type="text" id="data_relation1" v-model="formData.emergencyContactRelation"
                            @change="clearError('emergencyContactRelation')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.emergencyContactRelation">
                            {{ errors.emergencyContactRelation }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_telephone3" class="name text-right"><span class="color-r1">❋</span>
                            緊急聯絡人聯絡電話(日)：</label>
                          <input type="text" id="data_telephone3" v-model="formData.emergencyContactPhoneDay"
                            @change="clearError('emergencyContactPhoneDay')" required />
                          <div class="field-error name" style="text-align: end" v-if="errors.emergencyContactPhoneDay">
                            {{ errors.emergencyContactPhoneDay }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_telephone4" class="name text-right"><span class="color-r1">❋</span>
                            緊急聯絡人聯絡電話(夜)：</label>
                          <input type="text" id="data_telephone4s" v-model="formData.emergencyContactPhoneNight"
                            @change="clearError('emergencyContactPhoneNight')" required />
                          <div class="field-error name" style="text-align: end"
                            v-if="errors.emergencyContactPhoneNight">
                            {{ errors.emergencyContactPhoneNight }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_job2" class="name text-right"><span class="color-r1">❋</span>
                            身分別：</label><select id="data_job1" data-relation="data_job2" data-relation-value="99"
                            v-model="formData.socialStatus" @change="clearError('socialStatus')" required>
                            <option value="">請選擇</option>
                            <option value="一般生">一般生</option>
                            <option value="原住民生">原住民生</option>
                            <option value="新住民生">新住民生</option>
                            <option value="身心障礙生">身心障礙生</option>
                            <option value="其他">其他(如境外生等)</option>
                          </select>
                          <div class="field-error name" style="text-align: end" v-if="errors.socialStatus">
                            {{ errors.socialStatus }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-6" v-show="formData.socialStatus === '其他'">
                        <div class="input-row">
                          <label for="data_job2" class="name text-right"><span class="color-r1">❋</span> 其他身分別：</label>
                          <input ref="otherSocialStatus" type="text" v-model="formData.otherSocialStatus"
                            @change="clearError('otherSocialStatus')" id="data_job2" class="input-lg"
                            placeholder="請輸入身分別" />
                          <div class="field-error name" style="text-align: end" v-if="errors.otherSocialStatus">
                            {{ errors.otherSocialStatus }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_transportation" class="name text-right"><span class="color-r1">❋</span>
                            交通補助：<br />本計畫補助低收/中低收入申請交通補助</label>
                          <select id="data_transportation" v-model="formData.transportation"
                            @change="clearError('transportation')" required>
                            <option value="">請選擇</option>
                            <option value="無">無</option>
                            <option value="需要">需要</option>
                          </select>
                          <div class="field-error name" style="text-align: end" v-if="errors.transportation">
                            {{ errors.transportation }}
                          </div>
                        </div>
                      </div>
                      <div v-show="formData.transportation === '需要'" class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="" class="name text-right"><span class="color-r1">❋</span>上傳交通補助檔案：<br />(單檔最大 50MB)</label>
                          <label for="transportationFile" class="btn-default">選擇檔案</label>
                          <input type="file" accept=".pdf,image/*" id="transportationFile"
                            @change="onFileChange($event, 'transportationFile')" style="display: none" />
                          <span style="vertical-align: top" tabindex="0" ref="transportationFile" for="" class="name">
                            {{
                              formData.transportationFile
                                ? formData.transportationFile.name
                                : "尚未選擇檔案"
                            }}
                            <button type="button" class="close" aria-label="Close" @click="
                              removeFile(
                                'transportationFile',
                                'deleteTransportationFile'
                              )
                              ">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </span>
                          <div class="field-error name" style="text-align: end" v-if="errors.transportationFile">
                            {{ errors.transportationFile }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-12">
                        <div class="input-row">
                          <label for="data_note" class="name text-right">
                            特殊需求與建議<br />(仍需視實際情況而定)：</label>
                          <textarea id="data_note" v-model="formData.specialNeeds" placeholder="請輸入特殊需求與建議"></textarea>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="input-row">
                          <label for="data_note" class="name text-right"><span class="color-r1">❋</span>
                            上傳同意書檔案：<br />
                            (請將上面資料填妥後，下載同意書檔案，完成簽名以後，將該檔案以PDF,
                            JPG, PNG格式上傳，單檔最大 50MB)</label>
                          <label for="agreementFile" class="btn-default">選擇檔案</label>
                          <span style="vertical-align: top" tabindex="0" ref="agreementFile" for="" class="name">
                            {{
                              formData.agreementFile
                                ? formData.agreementFile.name
                                : "尚未選擇檔案"
                            }}
                            <button type="button" class="close" aria-label="Close" @click="
                              removeFile(
                                'agreementFile',
                                'deleteAgreementFile'
                              )
                              ">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </span>
                          <div class="field-error name" style="text-align: end" v-if="errors.agreementFile">
                            {{ errors.agreementFile }}
                          </div>
                          <label for="" class="name">
                            <button type="button" @click="downloadAgreement" style="
                                background: none;
                                border: none;
                                padding: 0;
                                cursor: pointer;
                                color: #1900fff3;
                                text-decoration: underline;
                              ">
                              下載同意書檔案
                            </button>
                          </label>
                          <input type="file" accept=".pdf,image/*" id="agreementFile"
                            @change="onFileChange($event, 'agreementFile')" style="display: none" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="btn-lg w-100 text-center">
                  <button v-if="showTempSaveButton" type="button" @click="saveTemp" class="btn btn-lg btn-secondary">
                    暫存
                  </button>
                  <button type="button" @click="nextStage('formStage1')" class="btn btn-lg">
                    儲存並前往下一頁
                  </button>
                </div>
              </div>
            </div>
          </form>
          <form ref="formStage2" @submit.prevent v-show="pageStage === 3">
            <div class="article-top">
              <div class="article-title">自傳</div>
            </div>
            <div class="article-wrap">
              <div class="article-content">
                <div class="template-block">
                  <div class="from-block">
                    <div class="row">
                      <div class="col-12">
                        <div class="input-row">
                          一、內容要求：含報名動機、自我人格特質分析、參加班級、社團幹部及學校自治組織或校(內)外公共事務關懷及參與等相關經驗及簡述成長過程(可依自由意願說明自己的多元文化認同如*族群、性別、宗教及資賦優異或身心障礙身分等對自我之影響)。<br />
                          二、格式要求：電腦打字，14號字，含標點符號至多1500字。<br />
                          族群之意涵包含閩、客、原、新等住民(族)(含平埔族群)。<br />
                          性別之意涵包括生理性別、性別特徵、性別特質、性別認同及性傾向。
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="input-row">
                          <label for="data_autobiography" class="name"><span class="color-r1">❋</span> 自傳內容：</label>
                          <textarea id="data_autobiography" style="height: 500px; width: 100%"
                            v-model="formData.autobiography" ref="autobiography" placeholder="請輸入自傳內容"
                            required></textarea>
                          <div class="">
                            目前字數：{{
                              formData.autobiography
                                ? formData.autobiography.length
                                : 0
                            }}
                            / 1500
                          </div>
                          <div class="field-error " v-if="errors.autobiography">
                            {{ errors.autobiography }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="btn-lg w-100 text-center">
                  <button @click="prevStage" class="btn btn-lg btn-r">
                    返回上一頁
                  </button>
                  <button v-if="showTempSaveButton" type="button" @click="saveTemp" class="btn btn-lg btn-secondary">
                    暫存
                  </button>
                  <button type="button" @click="nextStage('formStage2')" class="btn btn-lg">
                    儲存並前往下一頁
                  </button>
                </div>
              </div>
            </div>
          </form>
          <form ref="formStage3" @submit.prevent v-show="pageStage === 4">
            <div class="article-top">
              <div class="article-title">新世紀領導人才培育營推薦表</div>
            </div>
            <div class="article-wrap">
              <div class="article-content">
                <div class="template-block">
                  <div class="from-block">
                    <div class="row">
                      <div class="col-12">
                        <div class="input-row">
                          說明：本推薦表之目的在協助瞭解被推薦人是否具有領導人才相關特質，以作為被推薦人是否能參加新世紀領導人才培育營之參考。
                        </div>
                        <div class="input-row">
                          注意事項：<br />◆推薦人身分不拘(如教師、家長)，手寫或電腦打字皆可。<br />◆若另紙書寫，需釘於次頁，並於推薦信及本表簽章。
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_name" class="name text-right">
                            被推薦人姓名：</label>
                          <input type="text" id="data_name" v-model="formData.recommendationName" />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_relation" class="name text-right">
                            與被推薦人之關係：</label>
                          <input type="text" id="data_relation" v-model="formData.recommendationRelation" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_unit" class="name text-right">推薦人服務單位及職稱：</label>
                          <input type="text" id="data_unit" v-model="formData.recommendationUnit" />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="input-row">
                          <label for="data_date" class="name text-right">
                            日期：</label>
                          <input type="date" id="data_date" v-model="formData.recommendationDate" class="datepicker" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="input-row">
                          <textarea ref="recommendationContent" id="data_note" style="height: 500px; width: 100%"
                            placeholder="請輸入推薦表內容" v-model="formData.recommendationContent"></textarea>
                          <div class="field-error name" style="text-align: end" v-if="errors.recommendationContent">
                            {{ errors.recommendationContent }}
                          </div>
                          目前字數：{{ formData.recommendationContent.length }}
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="" style="display: inline-block">
                          <label for="data_note" class="name text-right">
                            上傳推薦表：<br />
                            (僅能上傳PDF, JPG, PNG，單檔最大 50MB)</label>
                          <label for="recommendationFile" class="btn-default">選擇檔案</label>
                          <span style="vertical-align: top" ref="recommendationFile" tabindex="0" for="" class="name">
                            {{
                              formData.recommendationFile
                                ? formData.recommendationFile.name
                                : "尚未選擇檔案"
                            }}

                            <button type="button" class="close" aria-label="Close" @click="
                              removeFile(
                                'recommendationFile',
                                'deleteRecommendationFile'
                              )
                              ">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </span>
                          <input type="file" accept=".pdf,image/*" id="recommendationFile"
                            @change="onFileChange($event, 'recommendationFile')" style="display: none" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="btn-lg w-100 text-center">
                  <button @click="prevStage" class="btn btn-lg btn-r">
                    返回上一頁
                  </button>
                  <button v-if="showTempSaveButton" type="button" @click="saveTemp" class="btn btn-lg btn-secondary">
                    暫存
                  </button>
                  <button type="button" @click="nextStage('formStage3')" class="btn btn-lg">
                    儲存並前往下一頁
                  </button>
                </div>
              </div>
            </div>
          </form>
          <form ref="formStage4" @submit.prevent v-show="pageStage === 5">
            <div class="article-top">
              <div class="article-title">多元表現及相關佐證資料</div>
            </div>
            <div class="article-wrap">
              <div class="article-content">
                <div class="template-block">
                  <div class="from-block">
                    <div class="row">
                      <div class="col-12 col-md-6 col-lg-3">
                        <label for="data_note" class="name text-right">
                          <span class="color-r1">❋</span> 上傳多元表現及相關佐證資料：<br />
                          因上傳欄位有限，如檔案超過上傳欄位數，請將多檔案合併後上傳<br />
                          (僅能上傳PDF, JPG, PNG，單檔最大 50MB)
                        </label>
                      </div>
                      <div class="col-12 col-md-6 col-lg-9">
                        <div class="">
                          <div class="row pl-2">
                            <label for="multiPerformanceFile1" class="btn-default col-6 col-lg-3">選擇檔案</label>
                            <span style="vertical-align: top" ref="multiPerformanceFile1" tabindex="0" for=""
                              class="name col-6 col-lg-3">
                              {{
                                formData.multiPerformanceFile1
                                  ? formData.multiPerformanceFile1.name
                                  : "尚未選擇檔案"
                              }}
                              <button type="button" class="close" aria-label="Close" @click="
                                removeFile(
                                  'multiPerformanceFile1',
                                  'deleteMultiPerformanceFile1'
                                )
                                ">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </span>
                            <input type="file" accept=".pdf,image/*" id="multiPerformanceFile1" @change="
                              onFileChange($event, 'multiPerformanceFile1')
                              " style="display: none" />
                            <div class="field-error name col-12" style="text-align: end"
                              v-if="errors.multiPerformanceFile1">
                              {{ errors.multiPerformanceFile1 }}
                            </div>
                          </div>
                          <div class="row  pl-2">
                            <label for="multiPerformanceFile2" class="btn-default col-6 col-lg-3">選擇檔案</label>
                            <span style="vertical-align: top" ref="multiPerformanceFile2" tabindex="0" for=""
                              class="name col-6 col-lg-3">
                              {{
                                formData.multiPerformanceFile2
                                  ? formData.multiPerformanceFile2.name
                                  : "尚未選擇檔案"
                              }}
                              <button type="button" class="close" aria-label="Close" @click="
                                removeFile(
                                  'multiPerformanceFile2',
                                  'deleteMultiPerformanceFile2'
                                )
                                ">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </span>
                            <input type="file" accept=".pdf,image/*" id="multiPerformanceFile2" @change="
                              onFileChange($event, 'multiPerformanceFile2')
                              " style="display: none" />
                          </div>
                          <div class="row  pl-2">
                            <label for="multiPerformanceFile3" class="btn-default col-6 col-lg-3">選擇檔案</label>
                            <span style="vertical-align: top" ref="multiPerformanceFile3" tabindex="0" for=""
                              class="name col-6 col-lg-3">
                              {{
                                formData.multiPerformanceFile3
                                  ? formData.multiPerformanceFile3.name
                                  : "尚未選擇檔案"
                              }}
                              <button type="button" class="close" aria-label="Close" @click="
                                removeFile(
                                  'multiPerformanceFile3',
                                  'deleteMultiPerformanceFile3'
                                )
                                ">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </span>
                            <input type="file" accept=".pdf,image/*" id="multiPerformanceFile3" @change="
                              onFileChange($event, 'multiPerformanceFile3')
                              " style="display: none" />
                          </div>
                          <div class="row pl-2">
                            <label for="multiPerformanceFile4" class="btn-default col-6 col-lg-3">選擇檔案</label>
                            <span style="vertical-align: top" ref="multiPerformanceFile4" tabindex="0" for=""
                              class="name col-6 col-lg-3">
                              {{
                                formData.multiPerformanceFile4
                                  ? formData.multiPerformanceFile4.name
                                  : "尚未選擇檔案"
                              }}
                              <button type="button" class="close" aria-label="Close" @click="
                                removeFile(
                                  'multiPerformanceFile4',
                                  'deleteMultiPerformanceFile4'
                                )
                                ">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </span>
                            <input type="file" accept=".pdf,image/*" id="multiPerformanceFile4" @change="
                              onFileChange($event, 'multiPerformanceFile4')
                              " style="display: none" />
                          </div>
                          <div class="row pl-2">
                            <label for="multiPerformanceFile5" class="btn-default col-6 col-lg-3">選擇檔案</label>
                            <span style="vertical-align: top" ref="multiPerformanceFile5" tabindex="0" for=""
                              class="name col-6 col-lg-3">
                              {{
                                formData.multiPerformanceFile5
                                  ? formData.multiPerformanceFile5.name
                                  : "尚未選擇檔案"
                              }}
                              <button type="button" class="close" aria-label="Close" @click="
                                removeFile(
                                  'multiPerformanceFile5',
                                  'deleteMultiPerformanceFile5'
                                )
                                ">
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </span>
                            <input type="file" accept=".pdf,image/*" id="multiPerformanceFile5" @change="
                              onFileChange($event, 'multiPerformanceFile5')
                              " style="display: none" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="btn-lg w-100 text-center">
                  <button @click="prevStage" class="btn btn-lg btn-r">
                    返回上一頁
                  </button>
                  <button v-if="showTempSaveButton" type="button" @click="saveTemp" class="btn btn-lg btn-secondary">
                    暫存
                  </button>
                  <button type="button" @click="nextStage('formStage4')" class="btn btn-lg">
                    預覽
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div v-show="pageStage === 6">
            <applicantView :formData="formData" />
            <div class="btn-lg w-100 text-center">
              <button @click="prevStage" class="btn btn-lg btn-r">
                返回上一頁
              </button>
              <button v-if="showTempSaveButton" type="button" @click="saveTemp" class="btn btn-lg btn-secondary">
                暫存
              </button>
              <button v-show="!isSupplementMode" type="button" @click="submit" class="btn btn-lg">
                送出報名
              </button>
              <button v-show="isSupplementMode" type="button" @click="supplement" class="btn btn-lg">
                送出補件
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import { computed } from "vue";
import applicantView from "./applicantView.vue";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import { watch } from "vue";

const MAX_UPLOAD_FILE_SIZE = 50 * 1024 * 1024;
const MAX_UPLOAD_FILE_SIZE_LABEL = "50MB";

export default {
  components: {
    applicantView,
    vSelect,
  },
  data() {
    return {
      isLoading: false,
      autoCompleteSuggestions: [],
      isAgree: false,
      isSupplement: null,
      // 收集欄位錯誤訊息（key 對應 formData 的欄位名）
      errors: {},
      emailVerification: {
        status: "unverified", // unverified | pending | verified
        cooldownSeconds: 0,
        cooldownTimerId: null,
        pollingTimerId: null,
        checkTimerId: null,
        requestInFlight: false,
        lastEmail: "",
      },
      activity: {
        id: "",
        title: "",
      },
      formData: {
        activityId: "",
        activityTitle: "",
        id: "",
        //stage 1
        idNo: "",
        name: "",
        bloodType: "",
        gender: "",
        birthDate: "",
        photoFile: null,
        deletePhotoFile: false,
        schoolCounty: "",
        schoolName: "",
        grade: "1",
        className: "",
        schoolType: "",
        schoolTrack: "",
        diet: "",
        otherDiet: "",
        homePhone: "",
        cellPhone: "",
        email: "",
        addressCode: "",
        address: "",
        parentName: "",
        parentRelation: "",
        parentPhoneDay: "",
        parentPhoneNight: "",
        emergencyContactName: "",
        emergencyContactRelation: "",
        emergencyContactPhoneDay: "",
        emergencyContactPhoneNight: "",
        socialStatus: "",
        otherSocialStatus: "",
        transportation: "",
        transportationFile: null,
        deleteTransportationFile: false,
        specialNeeds: "",
        agreementFile: null,
        deleteAgreementFile: false,

        //stage 2
        autobiography: "",
        autobiographyFile: null,
        deleteAutobiographyFile: false,

        //stage 3
        recommendationName: "",
        recommendationRelation: "",
        recommendationUnit: "",
        recommendationDate: "",
        recommendationContent: "",
        recommendationFile: null,
        deleteRecommendationFile: false,

        //stage 4
        multiPerformanceFile1: null,
        deleteMultiPerformanceFile1: false,
        multiPerformanceFile2: null,
        deleteMultiPerformanceFile2: false,
        multiPerformanceFile3: null,
        deleteMultiPerformanceFile3: false,
        multiPerformanceFile4: null,
        deleteMultiPerformanceFile4: false,
        multiPerformanceFile5: null,
        deleteMultiPerformanceFile5: false,
      },
    };
  },
  computed: {
    pageStage: {
      get() {
        return parseInt(this.$route.query.stage) || 0;
      },
      set(val) {
        this.$router.push({ query: { ...this.$route.query, stage: val } });
      },
    },
    showDepartmentField() {
      return this.formData.schoolType === "技術型高中(高職)";
    },
    showProgramField() {
      return this.formData.schoolType === "綜合高中專門學程";
    },
    isEmailVerified() {
      return this.emailVerification.status === "verified";
    },
    isSupplementMode() {
      return this.isSupplement === "補件";
    },
    showTempSaveButton() {
      if (this.$route.params.supplementId && this.isSupplement === null) {
        return false;
      }
      return !this.isSupplementMode;
    },
    isEmailVerificationRequired() {
      return !this.isSupplementMode;
    },
    isEmailInputLocked() {
      return (
        !this.isEmailVerificationRequired ||
        this.emailVerification.status === "verified" ||
        this.emailVerification.cooldownSeconds > 0
      );
    },
    isEmailVerifyButtonDisabled() {
      if (!this.isEmailVerificationRequired) return true;
      if (this.emailVerification.requestInFlight) return true;
      if (this.emailVerification.status === "verified") return true;
      if (this.emailVerification.cooldownSeconds > 0) return true;
      if (!this.formData.email) return true;
      return !this.isValidEmail(this.formData.email);
    },
    emailVerifyButtonText() {
      return this.isEmailVerified ? "驗證成功" : "驗證";
    },
    emailVerifyCountdownText() {
      if (this.emailVerification.cooldownSeconds > 0) {
        return `倒數 ${this.emailVerification.cooldownSeconds} 秒`;
      }
      return "";
    },
  },
  async mounted() {
    this.activity.id = this.$route.params.activityId;
    if (this.$route.params.supplementId) {
      await this.loadData(this.$route.params.supplementId);
    }
    this.getSuggestions();
  },
  watch: {
    "activity.id"(newValue) {
      this.checkSignupable();
    },
    "formData.transportation"(newValue) {
      if (newValue === "無") {
        this.formData.transportationFile = null;
        this.clearError("transportationFile");
      }
    },
    "formData.schoolType"(newValue) {
      const requiresTrack =
        newValue === "技術型高中(高職)" ||
        newValue === "綜合高中專門學程";
      if (!requiresTrack) {
        this.formData.schoolTrack = "";
        this.clearError("schoolTrack");
      }
    },
    "formData.idNo"(newValue) {
      if (newValue) this.clearError("idNo");
    },
    "formData.email"(newValue, oldValue) {
      if (newValue === oldValue) return;
      this.resetEmailVerificationState();
      this.clearError("email");
      if (newValue && this.isValidEmail(newValue)) {
        this.scheduleEmailVerificationStatusCheck();
      }
    },
    "formData.diet"(newValue, oldValue) {
      // 當飲食習慣從「其他」改為其他選項時，清除「其他飲食習慣」資料
      if (oldValue === "其他" && newValue !== "其他") {
        this.formData.otherDiet = "";
        this.clearError("otherDiet");
      }
    },
    "formData.socialStatus"(newValue, oldValue) {
      // 當身分別從「其他」改為其他選項時，清除「其他身分別」資料
      if (oldValue === "其他" && newValue !== "其他") {
        this.formData.otherSocialStatus = "";
        this.clearError("otherSocialStatus");
      }
    },
  },
  methods: {
    // 簡易工具：清除此欄位的錯誤
    clearError(key) {
      if (this.errors && this.errors[key]) {
        const { [key]: _, ...rest } = this.errors;
        this.errors = rest;
      }
    },
    validateAddressCode(event) {
      this.formData.addressCode = event.target.value.replace(/[^\d]/g, '');
    },
    // 滾到第一個錯誤訊息
    scrollToFirstError() {
      this.$nextTick(() => {
        const host = this.$el;
        const el =
          host && host.querySelector && host.querySelector(".field-error");
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    },
    //mounted 相關方法
    async checkSignupable() {
      if (this.activity.id == false) {
        return;
      }
      let _this = this;
      var getActivityUrl =
        "/api/leaderTrainingCamp/activity/" + this.activity.id;
      this.$http.get(getActivityUrl).then((response) => {
        var msg = "";
        if (response.body) {
          _this.activity = response.body;
          _this.formData.activityId = response.body.id;
          _this.formData.activityTitle = response.body.title;
          var startDate = new Date(response.body.startDate);
          var endDate = new Date(response.body.endDate);
          var now = new Date();
          if (now > endDate) {
            msg = "報名已截止";
          }
          if (now < startDate) {
            msg = "尚未開始報名";
          }
        } else {
          msg = "報名活動不存在";
        }

        if (msg != "") {
          bootbox.alert(msg, function () {
            window.location.href = "/";
          });
        }
      });
    },
    async loadData(supplementId) {
      const _this = this;
      var url = "/api/leaderTrainingCamp/applicant/" + supplementId;
      this.$http
        .get(url)
        .then((response) => {
          if (response.body) {
            if (typeof response.body === "string") {
              bootbox.alert(response.body);
              setTimeout(() => {
                window.location.href = "/";
              }, 2000);
              return;
            }
            const data = response.body;
            // 只更新 formData 中已存在的 key
            for (const key in _this.formData) {
              if (Object.prototype.hasOwnProperty.call(data, key)) {
                _this.formData[key] = data[key] === null ? "" : data[key];
              }
            }
            _this.activity.id = response.body.activity.id;
            _this.isSupplement = data.reviewStatus;
            if (_this.formData.email) {
              _this.checkEmailVerificationStatus();
            }
            if (data.id) {
              _this.fetchApplicantPhoto(data.id);
            }
          } else {
            _this.$router.push({ name: "leaderTrainingCamp.applicant" });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          bootbox.alert("系統發生錯誤");
        });
    },
    async fetchApplicantPhoto(applicantId) {
      try {
        const resp = await this.$http.get(
          `/api/leaderTrainingCamp/applicant/${applicantId}/photo`,
          { responseType: "blob" }
        );

        if (!resp || !resp.body) return;

        const contentType =
          (resp.headers &&
            (resp.headers.get("content-type") ||
              resp.headers.get("Content-Type"))) || "image/jpeg";

        let fileName = "applicant-photo";
        if (resp.headers) {
          const disposition =
            resp.headers.get("content-disposition") ||
            resp.headers.get("Content-Disposition") ||
            "";
          // RFC 5987: filename*=UTF-8''...
          const utf8Name = disposition.match(/filename\*=UTF-8''([^;]+)/i);
          const asciiName = disposition.match(/filename="?([^";]+)"?/i);
          if (utf8Name && utf8Name[1]) {
            try {
              fileName = decodeURIComponent(utf8Name[1]);
            } catch (_) {
              fileName = utf8Name[1];
            }
          } else if (asciiName && asciiName[1]) {
            try {
              fileName = decodeURIComponent(asciiName[1]);
            } catch (_) {
              fileName = asciiName[1];
            }
          }
        }

        const ext = contentType.includes("png")
          ? "png"
          : contentType.includes("gif")
          ? "gif"
          : "jpg";
        if (!/\.(jpg|jpeg|png|gif)$/i.test(fileName)) {
          fileName = `${fileName}.${ext}`;
        }

        const file = new File([resp.body], fileName, { type: contentType });
        this.formData.photoFile = file;
        this.formData.deletePhotoFile = false;
        this.clearError("photoFile");
      } catch (err) {
        // 404 代表尚未上傳，不視為錯誤
        if (err && err.status === 404) return;
        console.error("載入證件照失敗", err);
      }
    },
    // initialAutocomplete() {
    //   new window.Autocomplete(this.$refs.schoolName, {
    //     minLength: 2,
    //     threshold: 300,
    //     search: (inputValue) => {
    //       return fetch(`leaderTrainingCamp/schoolNameList?q=${inputValue}`)
    //         .then((res) => res.json())
    //         .then(
    //           data.map((item) => ({
    //             label: item,
    //             value: item,
    //           }))
    //         );
    //     },
    //     onSelectItem: ({ label, value }) => {
    //       this.$emit("selected", { label, value });
    //     },
    //   });
    // },
    // 頁面狀態切換（改為自訂內嵌錯誤訊息）
    nextStage(whichFormShouldBeValid) {
      if (this.isEmailVerificationRequired && !this.isEmailVerified && whichFormShouldBeValid) {
        this.errors = {
          ...this.errors,
          email: "請先完成 Email 驗證",
        };
        bootbox.alert("請先完成 Email 驗證");
        this.scrollToFirstError();
        return;
      }
      const ok = this.checkData(whichFormShouldBeValid);
      if (!ok) {
        this.scrollToFirstError();
        return;
      }
      this.pageStage = this.pageStage + 1;
    },
    prevStage() {
      if (this.pageStage > 1) {
        this.pageStage = this.pageStage - 1;
      }
    },
    // 資料檢查
    checkData(whichFormShouldBeValid) {
      // 先清空當頁錯誤
      const clearStageErrors = (keys) => {
        const rest = { ...this.errors };
        keys.forEach((k) => delete rest[k]);
        this.errors = rest;
      };

      if (whichFormShouldBeValid === "formStage1") {
        const required = [
          { key: "idNo", label: "身分證字號" },
          { key: "name", label: "姓名" },
          { key: "bloodType", label: "血型" },
          { key: "gender", label: "性別" },
          { key: "birthDate", label: "出生日期" },
          { key: "schoolCounty", label: "學校所在縣市" },
          { key: "schoolName", label: "學校名稱" },
          { key: "grade", label: "年級" },
          { key: "className", label: "班級" },
          { key: "schoolType", label: "學校型態" },
          { key: "diet", label: "飲食習慣" },
          { key: "homePhone", label: "聯絡電話(住家)" },
          { key: "cellPhone", label: "聯絡電話(手機)" },
          { key: "email", label: "E-mail" },
          { key: "addressCode", label: "郵遞區號" },
          { key: "address", label: "通訊地址" },
          { key: "parentName", label: "家長姓名" },
          { key: "parentRelation", label: "關係" },
          { key: "parentPhoneDay", label: "家長聯絡電話(日)" },
          { key: "parentPhoneNight", label: "家長聯絡電話(夜)" },
          { key: "emergencyContactName", label: "緊急聯絡人姓名" },
          { key: "emergencyContactRelation", label: "緊急聯絡人關係" },
          { key: "emergencyContactPhoneDay", label: "緊急聯絡人聯絡電話(日)" },
          {
            key: "emergencyContactPhoneNight",
            label: "緊急聯絡人聯絡電話(夜)",
          },
          { key: "socialStatus", label: "身分別" },
          { key: "transportation", label: "交通補助" },
        ];

        // 清空這一頁可能涉及的錯誤
        clearStageErrors([
          ...required.map((r) => r.key),
          "photoFile",
          "agreementFile",
          "transportationFile",
          "otherDiet",
          "otherSocialStatus",
          "schoolTrack",
        ]);

        const errs = {};
        // 一般必填
        required.forEach(({ key, label }) => {
          const val = this.formData[key];
          if (val === undefined || val === null || val === "") {
            errs[key] = `請填寫${label}`.replace(
              "請填寫交通補助",
              "請選擇交通補助"
            );
          }
        });

        // 學校名稱（v-select）
        if (!this.formData.schoolName) errs.schoolName = "請填寫學校名稱";

        // 身分證格式
        if (this.formData.idNo && !this.isValidTaiwanId(this.formData.idNo)) {
          errs.idNo = "身份證字號格式不正確";
        }

        // Email 格式
        if (this.formData.email) {
          const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
            this.formData.email
          );
          if (!emailOk) errs.email = "Email 格式不正確";
        }

        // 其他飲食
        if (this.formData.diet === "其他" && !this.formData.otherDiet) {
          errs.otherDiet = "請填寫飲食習慣";
        }

        // 其他身分別
        if (
          this.formData.socialStatus === "其他" &&
          !this.formData.otherSocialStatus
        ) {
          errs.otherSocialStatus = "請填寫身分別";
        }

        if ((this.showDepartmentField || this.showProgramField) && !this.formData.schoolTrack) {
          errs.schoolTrack = this.showDepartmentField ? "請填寫科系" : "請填寫學程";
        }

        // 檔案必上傳
        if (!this.formData.photoFile) errs.photoFile = "請上傳證件照";
        if (!this.formData.agreementFile) errs.agreementFile = "請上傳同意書";
        if (
          this.formData.transportation === "需要" &&
          !this.formData.transportationFile
        ) {
          errs.transportationFile = "請上傳交通補助檔案";
        }

        this.errors = { ...this.errors, ...errs };
        return Object.keys(errs).length === 0;
      }

      if (whichFormShouldBeValid === "formStage2") {
        clearStageErrors(["autobiography"]);
        const errs = {};
        if (!this.formData.autobiography) {
          errs.autobiography = "請填寫自傳內容";
        }
        if (
          this.formData.autobiography &&
          this.formData.autobiography.length > 1500
        ) {
          errs.autobiography = "自傳字數超過1500字";
        }
        this.errors = { ...this.errors, ...errs };
        return Object.keys(errs).length === 0;
      }

      if (whichFormShouldBeValid === "formStage3") {
        clearStageErrors(["recommendationContent"]);
        const errs = {};
        if (
          this.formData.recommendationContent &&
          this.formData.recommendationContent.length > 500
        ) {
          errs.recommendationContent = "推薦表內容超過500字";
        }
        this.errors = { ...this.errors, ...errs };
        return Object.keys(errs).length === 0;
      }

      if (whichFormShouldBeValid === "formStage4") {
        clearStageErrors([
          "multiPerformanceFile1",
          "multiPerformanceFile2",
          "multiPerformanceFile3",
          "multiPerformanceFile4",
          "multiPerformanceFile5",
        ]);
        const errs = {};

        // 至少要上傳一個多元表現及相關佐證資料檔案
        const hasAnyFile =
          this.formData.multiPerformanceFile1 ||
          this.formData.multiPerformanceFile2 ||
          this.formData.multiPerformanceFile3 ||
          this.formData.multiPerformanceFile4 ||
          this.formData.multiPerformanceFile5;

        if (!hasAnyFile) {
          errs.multiPerformanceFile1 = "請至少上傳一個多元表現及相關佐證資料檔案";
        }

        this.errors = { ...this.errors, ...errs };
        return Object.keys(errs).length === 0;
      }

      // 其他頁不額外阻擋
      return true;
    },
    checkFileUploadField(fieldName, chineseFieldName) {
      // 已改為 inline 錯誤，保留相容呼叫
      if (!this.formData[fieldName]) {
        this.errors = {
          ...this.errors,
          [fieldName]: `請上傳${chineseFieldName}`,
        };
        return false;
      }
      return true;
    },
    // 上傳檔案
    onFileChange(event, fieldName) {
      const selectedFiles = event.target.files || [];
      const file = selectedFiles[0];
      if (!file) {
        return;
      }

      const fileType = file.type;
      const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/png",
        "image/gif",
      ];
      const deleteKey = `delete${fieldName.charAt(0).toUpperCase()}${fieldName.slice(1)}`;

      if (!allowedTypes.includes(fileType)) {
        this.errors = {
          ...this.errors,
          [fieldName]: "僅能上傳 PDF、JPG、PNG 或 GIF 檔案",
        };
        event.target.value = "";
        return;
      }

      if (file.size > MAX_UPLOAD_FILE_SIZE) {
        if (Array.isArray(this.formData[fieldName])) {
          this.formData[fieldName] = [];
        } else {
          this.formData[fieldName] = null;
        }
        if (Object.prototype.hasOwnProperty.call(this.formData, deleteKey)) {
          this.formData[deleteKey] = false;
        }
        this.errors = {
          ...this.errors,
          [fieldName]: `檔案大小不可超過 ${MAX_UPLOAD_FILE_SIZE_LABEL}`,
        };
        event.target.value = "";
        return;
      }

      if (Array.isArray(this.formData[fieldName])) {
        this.formData[fieldName].push(...selectedFiles);
      } else {
        this.formData[fieldName] = file;
      }

      if (Object.prototype.hasOwnProperty.call(this.formData, deleteKey)) {
        this.formData[deleteKey] = false;
      }

      event.target.value = "";
      this.clearError(fieldName);
    },
    removeFile(fileKey, deleteKey) {
      this.formData[fileKey] = null;
      this.formData[deleteKey] = true;
      // 移除後清理錯誤（讓使用者明確看到需要再上傳）
      this.errors = {
        ...this.errors,
        [fileKey]: this.errors[fileKey] || "此檔案為必填，請重新上傳",
      };
    },
    onMultiFileChange(event, fieldName) {
      const files = Array.from(event.target.files);
      this.formData[fieldName] = files;
    },
    // 預覽檔案
    getFilePreviewUrl(fileOrUrl) {
      // 使用者剛上傳的 File 物件
      if (fileOrUrl instanceof File || fileOrUrl instanceof Blob) {
        return URL.createObjectURL(fileOrUrl);
      }

      // 後端提供的 URL（假設為字串）
      if (typeof fileOrUrl === "string" && fileOrUrl.startsWith("/")) {
        return fileOrUrl;
      }

      // 後端提供 object 物件
      if (typeof fileOrUrl === "object" && fileOrUrl.url) {
        return fileOrUrl.url;
      }

      // 如果都不是，則返回空字串或其他預設值
      return "";
    },
    // 取得表單資料
    getFormData() {
      var formData = new FormData();
      for (var key in this.formData) {
        if (this.formData[key] instanceof File) {
          formData.append(key, this.formData[key]);
        } else {
          formData.append(key, this.formData[key]);
        }
      }

      formData.set("activityId", this.activity.id);
      return formData;
    },
    // 提交表單
    submit() {
      if (this.isEmailVerificationRequired && !this.isEmailVerified) {
        this.errors = { ...this.errors, email: "請先完成 Email 驗證" };
        bootbox.alert("請先完成 Email 驗證");
        this.scrollToFirstError();
        return;
      }
      this.isLoading = true;
      var url = "/api/leaderTrainingCamp/signup";

      var formData = this.getFormData();
      this.$http
        .post(url, formData)
        .then((response) => {
          this.isLoading = false;
          console.log("response", response);
          if (response.body && response.body.state) {
            if (response.body.state === "00") {
              bootbox.alert("報名成功，請到電子信箱確認", function () {
                window.location.href = "/";
              });
            } else {
              bootbox.alert(response.body.msg);
            }
          } else {
            bootbox.alert("報名失敗，請稍後再試");
          }
        })
        .catch((error) => {
          this.isLoading = false;
          bootbox.alert("報名失敗，請稍後再試");
        });
    },
    saveTemp() {
      if (!this.showTempSaveButton) {
        return;
      }
      if (this.isEmailVerificationRequired && !this.isEmailVerified) {
        this.errors = { ...this.errors, email: "請先完成 Email 驗證" };
        bootbox.alert("請先完成 Email 驗證");
        this.scrollToFirstError();
        return;
      }
      // 清空暫存相關的錯誤訊息
      const tempSaveKeys = ['idNo', 'name', 'birthDate', 'schoolCounty', 'schoolName', 'grade', 'email'];
      const rest = { ...this.errors };
      tempSaveKeys.forEach((k) => delete rest[k]);
      this.errors = rest;

      // 檢查必填欄位
      const required = [
        { key: "idNo", label: "身分證字號" },
        { key: "name", label: "姓名" },
        { key: "birthDate", label: "出生日期" },
        { key: "schoolCounty", label: "學校所在縣市" },
        { key: "schoolName", label: "學校名稱" },
        { key: "grade", label: "年級" },
        { key: "email", label: "E-mail" },
      ];

      const errs = {};
      // 一般必填
      required.forEach(({ key, label }) => {
        const val = this.formData[key];
        if (val === undefined || val === null || val === "") {
          errs[key] = `請填寫${label}`;
        }
      });

      // 學校名稱（v-select）
      if (!this.formData.schoolName) errs.schoolName = "請填寫學校名稱";

      // 身分證格式
      if (this.formData.idNo && !this.isValidTaiwanId(this.formData.idNo)) {
        errs.idNo = "身份證字號格式不正確";
      }

      // Email 格式
      if (this.formData.email) {
        const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
          this.formData.email
        );
        if (!emailOk) errs.email = "Email 格式不正確";
      }

      this.errors = { ...this.errors, ...errs };
      if (Object.keys(errs).length > 0) {
        this.scrollToFirstError();
        return;
      }

      this.isLoading = true;
      // 執行暫存
      var url = "/api/leaderTrainingCamp/saveTemp";
      var formData = this.getFormData();
      this.$http
        .post(url, formData)
        .then((res) => {
          this.isLoading = false;
          if (res.body && res.body.state) {
            if (res.body.state === "00") {
              const payload = res.body.data || {};
              const savedId = payload.id || this.formData.id;
              const savedUrl =
                payload.url || (savedId ? `/leaderTrainingCamp/applicant/${savedId}` : "");
              if (savedId) {
                this.formData.id = savedId;
              }
              const isAlreadyEditing =
                !!this.$route.params.supplementId &&
                (savedId
                  ? String(this.$route.params.supplementId) === String(savedId)
                  : this.$route.path.startsWith("/leaderTrainingCamp/applicant/"));
              const successMessage = isAlreadyEditing
                ? "暫存成功"
                : "暫存成功，即將跳轉至暫存編輯頁";

              bootbox.alert(successMessage, () => {
                if (!savedUrl) return;

                const hasStage = /[?&]stage=\d+/i.test(savedUrl);
                const stageParam = `stage=${this.pageStage}`;
                const urlWithStage = hasStage
                  ? savedUrl.replace(/([?&])stage=\d+/i, `$1${stageParam}`)
                  : `${savedUrl}${savedUrl.includes("?") ? "&" : "?"}${stageParam}`;

                if (!isAlreadyEditing) {
                  window.location.href = urlWithStage;
                }
              });
            } else if (res.body.state === "01") {
              bootbox.alert(res.body.msg);
            } else {
              console.error(
                "Temporary save failed:",
                res.body ? res.body.message : "Unknown error"
              );
            }
          } else {
            console.error(
              "Temporary save failed:",
              res.body ? res.body.message : "Unknown error"
            );
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error during temporary save:", error);
        });
    },
    supplement() {
      this.isLoading = true;
      var url = "/api/leaderTrainingCamp/supplement";

      var formData = new FormData();
      for (var key in this.formData) {
        if (this.formData[key] instanceof File) {
          formData.append(key, this.formData[key]);
        } else {
          formData.append(key, this.formData[key]);
        }
      }

      formData.set("activityId", this.activity.id);
      this.$http
        .post(url, formData)
        .then((response) => {
          this.isLoading = false;
          if (response.body && response.body.state) {
            if (response.body.state === "00") {
              bootbox.alert("補件成功！", function () {
                window.location.href = "/";
              });
            } else {
              bootbox.alert(response.body.message);
            }
          } else {
            bootbox.alert("補件失敗，請稍後再試");
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.error("Error:", error);
          bootbox.alert("補件失敗，請稍後再試");
        });
    },
    isValidTaiwanId(idStr) {
      // 依照字母的編號排列，存入陣列備用。
      var letters = new Array(
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "J",
        "K",
        "L",
        "M",
        "N",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "X",
        "Y",
        "W",
        "Z",
        "I",
        "O"
      );
      // 儲存各個乘數
      var multiply = new Array(1, 9, 8, 7, 6, 5, 4, 3, 2, 1);
      var nums = new Array(2);
      var firstChar;
      var firstNum;
      var lastNum;
      var total = 0;
      // 撰寫「正規表達式」。第一個字為英文字母，
      // 第二個字為1或2，後面跟著8個數字，不分大小寫。
      var regExpID = /^[a-z](1|2)\d{8}$/i;
      // 使用「正規表達式」檢驗格式
      if (idStr.search(regExpID) == -1) {
        // 基本格式錯誤
        return false;
      } else {
        // 取出第一個字元和最後一個數字。
        firstChar = idStr.charAt(0).toUpperCase();
        lastNum = idStr.charAt(9);
      }
      // 找出第一個字母對應的數字，並轉換成兩位數數字。
      for (let i = 0; i < 26; i++) {
        if (firstChar == letters[i]) {
          firstNum = i + 10;
          nums[0] = Math.floor(firstNum / 10);
          nums[1] = firstNum - nums[0] * 10;
          break;
        }
      }
      // 執行加總計算
      for (let i = 0; i < multiply.length; i++) {
        if (i < 2) {
          total += nums[i] * multiply[i];
        } else {
          total += parseInt(idStr.charAt(i - 1)) * multiply[i];
        }
      }
      // 和最後一個數字比對
      if ((total + parseInt(lastNum)) % 10 !== 0) {
        return false;
      }
      return true;
    },
    //autocomplete
    getSuggestions() {
      let url = `/api/leaderTrainingCamp/schoolNameList`;
      this.$http.get(url).then((response) => {
        if (response.body) {
          this.autoCompleteSuggestions = response.body;
        } else {
          this.autoCompleteSuggestions = [];
        }
      });
    },
    onSelected(item) {
      console.log("選到：", item);
      this.formData.schoolName = item;
    },
    onSchoolSelected(item) {
      setTimeout(() => {
        this.$refs.schoolSelector.$el.querySelector("input").blur();
      }, 100);
      this.clearError("schoolName");
      console.log(this.$refs.schoolSelector);
    },
    // 動態下載同意書（將 pageStage === 2 的資料送往後端產生 Word/ODT）
    async downloadAgreement() {
      // 僅在第 2 頁（填寫基本資料頁）允許下載，否則直接切換過去
      if (this.pageStage !== 2) {
        this.pageStage = 2;
      }

      // 驗證邏輯與 formStage1 相同，但「不上傳檔案」也可下載
      const required = [
        { key: 'idNo', label: '身分證字號' },
        { key: 'name', label: '姓名' },
        { key: 'bloodType', label: '血型' },
        { key: 'gender', label: '性別' },
        { key: 'birthDate', label: '出生日期' },
        { key: 'schoolCounty', label: '學校所在縣市' },
        { key: 'schoolName', label: '學校名稱' },
        { key: 'grade', label: '年級' },
        { key: 'className', label: '班級' },
        { key: 'schoolType', label: '學校型態' },
        { key: 'diet', label: '飲食習慣' },
        { key: 'homePhone', label: '聯絡電話(住家)' },
        { key: 'cellPhone', label: '聯絡電話(手機)' },
        { key: 'email', label: 'E-mail' },
        { key: 'addressCode', label: '郵遞區號' },
        { key: 'address', label: '通訊地址' },
        { key: 'parentName', label: '家長姓名' },
        { key: 'parentRelation', label: '關係' },
        { key: 'parentPhoneDay', label: '家長聯絡電話(日)' },
        { key: 'parentPhoneNight', label: '家長聯絡電話(夜)' },
        { key: 'emergencyContactName', label: '緊急聯絡人姓名' },
        { key: 'emergencyContactRelation', label: '緊急聯絡人關係' },
        { key: 'emergencyContactPhoneDay', label: '緊急聯絡人聯絡電話(日)' },
        { key: 'emergencyContactPhoneNight', label: '緊急聯絡人聯絡電話(夜)' },
        { key: 'socialStatus', label: '身分別' },
        { key: 'transportation', label: '交通補助' },
      ];

      // 清除此驗證相關的舊錯誤（不包含檔案類）
      const stage1Keys = [
        ...required.map(r => r.key),
        'otherDiet', 'otherSocialStatus',
        'schoolTrack'
      ];
      const rest = { ...this.errors };
      stage1Keys.forEach(k => delete rest[k]);
      this.errors = rest;

      const errs = {};
      // 必填檢查
      required.forEach(({ key, label }) => {
        const val = this.formData[key];
        if (val === undefined || val === null || val === '') {
          errs[key] = key === 'transportation' ? '請選擇交通補助' : `請填寫${label}`;
        }
      });

      // 學校名稱（v-select）
      if (!this.formData.schoolName) errs.schoolName = '請填寫學校名稱';

      // 身分證格式
      if (this.formData.idNo && !this.isValidTaiwanId(this.formData.idNo)) {
        errs.idNo = '身份證字號格式不正確';
      }

      // Email 格式
      if (this.formData.email) {
        const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email);
        if (!emailOk) errs.email = 'Email 格式不正確';
      }

      // 其他飲食
      if (this.formData.diet === '其他' && !this.formData.otherDiet) {
        errs.otherDiet = '請填寫飲食習慣';
      }

      // 其他身分別
      if (this.formData.socialStatus === '其他' && !this.formData.otherSocialStatus) {
        errs.otherSocialStatus = '請填寫身分別';
      }

      if ((this.showDepartmentField || this.showProgramField) && !this.formData.schoolTrack) {
        errs.schoolTrack = this.showDepartmentField ? '請填寫科系' : '請填寫學程';
      }

      this.errors = { ...this.errors, ...errs };
      if (Object.keys(errs).length > 0) {
        bootbox.alert("請修正表單中的錯誤", () => this.scrollToFirstError());
        return;
      }

      try {
        const url = "/api/leaderTrainingCamp/agreementTemplate";
        const fd = new FormData();
        Object.entries(this.formData || {}).forEach(([k, v]) => {
          if (v === undefined || v === null) return;
          if (v instanceof File) {
            fd.append(k, v);
          } else if (
            Array.isArray(v) ||
            (typeof v === "object" && !(v instanceof Date))
          ) {
            try {
              fd.append(k, JSON.stringify(v));
            } catch {
              fd.append(k, String(v));
            }
          } else {
            fd.append(k, v);
          }
        });
        // 補充活動 Id（若後端需要）
        if (this.activity && this.activity.id) {
          fd.append("ActivityId", this.activity.id);
        }

        // 送出請求取得檔案（blob）
        const resp = await this.$http.post(url, fd, { responseType: "blob" });
        if (!resp || !resp.body) {
          bootbox.alert("下載失敗，請稍後再試");
          return;
        }

        // 嘗試從 Content-Disposition 解析檔名
        let fileName = "新世紀領導人才培育營-同意書.docx"; // fallback
        try {
          const header =
            (resp.headers &&
              (resp.headers.get("Content-Disposition") ||
                resp.headers.get("content-disposition"))) ||
            "";
          if (header) {
            // 先處理 RFC 5987 filename*=UTF-8''...
            // 再處理 filename="..."
            const rfc5987Match = header.match(/filename\*=UTF-8''([^;]+)/i);
            const normalMatch = header.match(/filename="?([^";]+)"?/i);
            if (rfc5987Match && rfc5987Match[1]) {
              fileName = decodeURIComponent(rfc5987Match[1]);
            } else if (normalMatch && normalMatch[1]) {
              // 一般情況，嘗試 decodeURIComponent（若非編碼不會壞）
              try {
                fileName = decodeURIComponent(normalMatch[1]);
              } catch (_) {
                fileName = normalMatch[1];
              }
            }
          }
          // 確保副檔名
          if (!/\.docx$/i.test(fileName)) {
            fileName += ".docx";
          }
        } catch (e) {
          console.warn("解析檔名失敗，使用預設檔名", e);
        }

        this.downloadFile(resp.body, fileName);
      } catch (e) {
        console.error(e);
        bootbox.alert("同意書下載失敗，請稍後再試");
      }
    },
    clearSchoolNameValue() {
      this.formData.schoolName = "";
    },
    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || "");
    },
    resetEmailVerificationState() {
      if (this.emailVerification.checkTimerId) {
        clearTimeout(this.emailVerification.checkTimerId);
        this.emailVerification.checkTimerId = null;
      }
      this.stopEmailCooldown();
      this.stopEmailVerificationPolling();
      this.emailVerification.status = "unverified";
      this.emailVerification.lastEmail = (this.formData.email || "").trim();
    },
    setEmailVerified() {
      this.stopEmailCooldown();
      this.stopEmailVerificationPolling();
      this.emailVerification.status = "verified";
      this.emailVerification.cooldownSeconds = 0;
    },
    scheduleEmailVerificationStatusCheck() {
      if (this.emailVerification.checkTimerId) {
        clearTimeout(this.emailVerification.checkTimerId);
      }
      this.emailVerification.checkTimerId = setTimeout(() => {
        this.checkEmailVerificationStatus();
      }, 400);
    },
    async checkEmailVerificationStatus() {
      const email = (this.formData.email || "").trim();
      if (!email || !this.isValidEmail(email)) return;
      try {
        const resp = await this.$http.get(
          "/api/leaderTrainingCamp/emailVerification/status",
          { params: { email } }
        );
        const body = resp && resp.body ? resp.body : {};
        if (body.verified) {
          this.setEmailVerified();
        }
      } catch (e) {
        console.error("Email verification status check failed", e);
      }
    },
    startEmailCooldown(seconds) {
      this.stopEmailCooldown();
      this.emailVerification.status = "pending";
      this.emailVerification.cooldownSeconds = seconds;
      this.emailVerification.cooldownTimerId = setInterval(() => {
        if (this.emailVerification.cooldownSeconds > 0) {
          this.emailVerification.cooldownSeconds -= 1;
        }
        if (this.emailVerification.cooldownSeconds <= 0) {
          this.stopEmailCooldown();
          if (this.emailVerification.status !== "verified") {
            this.emailVerification.status = "unverified";
          }
        }
      }, 1000);
    },
    stopEmailCooldown() {
      if (this.emailVerification.cooldownTimerId) {
        clearInterval(this.emailVerification.cooldownTimerId);
        this.emailVerification.cooldownTimerId = null;
      }
    },
    startEmailVerificationPolling() {
      this.stopEmailVerificationPolling();
      this.emailVerification.pollingTimerId = setInterval(() => {
        this.checkEmailVerificationStatus();
      }, 5000);
    },
    stopEmailVerificationPolling() {
      if (this.emailVerification.pollingTimerId) {
        clearInterval(this.emailVerification.pollingTimerId);
        this.emailVerification.pollingTimerId = null;
      }
    },
    async requestEmailVerification() {
      const email = (this.formData.email || "").trim();
      this.clearError("email");
      if (!email || !this.isValidEmail(email)) {
        this.errors = { ...this.errors, email: "Email 格式不正確" };
        return;
      }

      this.emailVerification.requestInFlight = true;
      try {
        const resp = await this.$http.post(
          "/api/leaderTrainingCamp/emailVerification/request",
          { email }
        );
        const body = resp && resp.body ? resp.body : {};
        if (body.state === "00") {
          if (body.verified === true) {
            this.setEmailVerified();
            bootbox.alert("此信箱已完成驗證");
          } else {
            const cooldown = body.cooldownSeconds || 90;
            this.startEmailCooldown(cooldown);
            this.startEmailVerificationPolling();
            bootbox.alert("驗證信已寄出，請至信箱點擊驗證連結");
          }
        } else {
          if (body.remainSeconds) {
            this.startEmailCooldown(body.remainSeconds);
          }
          bootbox.alert(body.msg || "寄送驗證信失敗");
        }
      } catch (e) {
        console.error(e);
        bootbox.alert("寄送驗證信失敗，請稍後再試");
      } finally {
        this.emailVerification.requestInFlight = false;
      }
    }
  },
};
</script>
<style scoped>
/* Inline field error */
.field-error {
  color: #d93025;
  font-size: 0.9em;
  margin-top: 4px;
}

.email-verify-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.email-verify-row input[type="email"] {
  flex: 1;
}

.email-verify-btn {
  white-space: nowrap;
}

.email-verify-btn--success {
  background-color: #1f8f3b;
  border-color: #1f8f3b;
  color: #ffffff;
}

.email-verify-btn--success:disabled {
  opacity: 1;
}

.email-verify-countdown {
  font-size: 0.9em;
  color: #6b7280;
}

/* Magnific Popup CSS */
.mfp-bg {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1042;
  overflow: hidden;
  position: fixed;
  background: #0b0b0b;
  opacity: 0.8;
}

.mfp-wrap {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1043;
  position: fixed;
  outline: none !important;
  -webkit-backface-visibility: hidden;
}

.mfp-container {
  text-align: center;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  padding: 0 8px;
  box-sizing: border-box;
}

.mfp-container:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.mfp-align-top .mfp-container:before {
  display: none;
}

.mfp-content {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin: 0 auto;
  text-align: left;
  z-index: 1045;
}

.mfp-inline-holder .mfp-content,
.mfp-ajax-holder .mfp-content {
  width: 100%;
  cursor: auto;
}

.mfp-ajax-cur {
  cursor: progress;
}

.mfp-zoom-out-cur,
.mfp-zoom-out-cur .mfp-image-holder .mfp-close {
  cursor: -moz-zoom-out;
  cursor: -webkit-zoom-out;
  cursor: zoom-out;
}

.mfp-zoom {
  cursor: pointer;
  cursor: -webkit-zoom-in;
  cursor: -moz-zoom-in;
  cursor: zoom-in;
}

.mfp-auto-cursor .mfp-content {
  cursor: auto;
}

.mfp-close,
.mfp-arrow,
.mfp-preloader,
.mfp-counter {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

.mfp-loading.mfp-figure {
  display: none;
}

.mfp-hide {
  display: none !important;
}

.mfp-preloader {
  color: #ccc;
  position: absolute;
  top: 50%;
  width: auto;
  text-align: center;
  margin-top: -0.8em;
  left: 8px;
  right: 8px;
  z-index: 1044;
}

.mfp-preloader a {
  color: #ccc;
}

.mfp-preloader a:hover {
  color: #fff;
}

.mfp-s-ready .mfp-preloader {
  display: none;
}

.mfp-s-error .mfp-content {
  display: none;
}

button.mfp-close,
button.mfp-arrow {
  overflow: visible;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
  display: block;
  outline: none;
  padding: 0;
  z-index: 1046;
  box-shadow: none;
  touch-action: manipulation;
}

button::-moz-focus-inner {
  padding: 0;
  border: 0;
}

.mfp-close {
  width: 44px;
  height: 44px;
  line-height: 44px;
  position: absolute;
  right: 0;
  top: 0;
  text-decoration: none;
  text-align: center;
  opacity: 0.65;
  padding: 0 0 18px 10px;
  color: #fff;
  font-style: normal;
  font-size: 2em;
  font-family: Arial, Baskerville, monospace;
}

.mfp-close:hover,
.mfp-close:focus {
  opacity: 1;
}

.mfp-close:active {
  top: 1px;
}

.mfp-close-btn-in .mfp-close {
  color: #333;
}

.mfp-image-holder .mfp-close,
.mfp-iframe-holder .mfp-close {
  color: #fff;
  right: -6px;
  text-align: right;
  padding-right: 6px;
  width: 100%;
}

.mfp-counter {
  position: absolute;
  top: 0;
  right: 0;
  color: #ccc;
  font-size: 0.86em;
  line-height: 18px;
  white-space: nowrap;
}

.mfp-arrow {
  position: absolute;
  opacity: 0.65;
  margin: 0;
  top: 50%;
  margin-top: -55px;
  padding: 0;
  width: 90px;
  height: 110px;
  -webkit-tap-highlight-color: transparent;
}

.mfp-arrow:active {
  margin-top: -54px;
}

.mfp-arrow:hover,
.mfp-arrow:focus {
  opacity: 1;
}

.mfp-arrow:before,
.mfp-arrow:after {
  content: "";
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 35px;
  margin-left: 35px;
  border: medium inset transparent;
}

.mfp-arrow:after {
  border-top-width: 13px;
  border-bottom-width: 13px;
  top: 8px;
}

.mfp-arrow:before {
  border-top-width: 21px;
  border-bottom-width: 21px;
  opacity: 0.7;
}

.mfp-arrow-left {
  left: 0;
}

.mfp-arrow-left:after {
  border-right: 17px solid #fff;
  margin-left: 31px;
}

.mfp-arrow-left:before {
  margin-left: 25px;
  border-right: 27px solid #3f3f3f;
}

.mfp-arrow-right {
  right: 0;
}

.mfp-arrow-right:after {
  border-left: 17px solid #fff;
  margin-left: 39px;
}

.mfp-arrow-right:before {
  border-left: 27px solid #3f3f3f;
}

.mfp-iframe-holder {
  padding-top: 40px;
  padding-bottom: 40px;
}

.mfp-iframe-holder .mfp-content {
  line-height: 0;
  width: 100%;
  max-width: 900px;
}

.mfp-iframe-holder .mfp-close {
  top: -40px;
}

.mfp-iframe-scaler {
  width: 100%;
  height: 0;
  overflow: hidden;
  padding-top: 56.25%;
}

.mfp-iframe-scaler iframe {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
  background: #000;
}

/* Main image in popup */
img.mfp-img {
  width: auto;
  max-width: 100%;
  height: auto;
  display: block;
  line-height: 0;
  box-sizing: border-box;
  padding: 40px 0 40px;
  margin: 0 auto;
}

/* The shadow behind the image */
.mfp-figure {
  line-height: 0;
}

.mfp-figure:after {
  content: "";
  position: absolute;
  left: 0;
  top: 40px;
  bottom: 40px;
  display: block;
  right: 0;
  width: auto;
  height: auto;
  z-index: -1;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.6);
  background: #444;
}

.mfp-figure small {
  color: #bdbdbd;
  display: block;
  font-size: 0.86em;
  line-height: 14px;
}

.mfp-figure figure {
  margin: 0;
}

.mfp-bottom-bar {
  margin-top: -36px;
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  cursor: auto;
}

.mfp-title {
  text-align: left;
  line-height: 18px;
  color: #f3f3f3;
  word-wrap: break-word;
  padding-right: 36px;
}

.mfp-image-holder .mfp-content {
  max-width: 100%;
}

.mfp-gallery .mfp-image-holder .mfp-figure {
  cursor: pointer;
}

@media screen and (max-width: 800px) and (orientation: landscape),
screen and (max-height: 300px) {

  /**
       * Remove all paddings around the image on small screen
       */
  .mfp-img-mobile .mfp-image-holder {
    padding-left: 0;
    padding-right: 0;
  }

  .mfp-img-mobile img.mfp-img {
    padding: 0;
  }

  .mfp-img-mobile .mfp-figure:after {
    top: 0;
    bottom: 0;
  }

  .mfp-img-mobile .mfp-figure small {
    display: inline;
    margin-left: 5px;
  }

  .mfp-img-mobile .mfp-bottom-bar {
    background: rgba(0, 0, 0, 0.6);
    bottom: 0;
    margin: 0;
    top: auto;
    padding: 3px 5px;
    position: fixed;
    box-sizing: border-box;
  }

  .mfp-img-mobile .mfp-bottom-bar:empty {
    padding: 0;
  }

  .mfp-img-mobile .mfp-counter {
    right: 5px;
    top: 3px;
  }

  .mfp-img-mobile .mfp-close {
    top: 0;
    right: 0;
    width: 35px;
    height: 35px;
    line-height: 35px;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    text-align: center;
    padding: 0;
  }
}

@media all and (max-width: 900px) {
  .mfp-arrow {
    -webkit-transform: scale(0.75);
    transform: scale(0.75);
  }

  .mfp-arrow-left {
    -webkit-transform-origin: 0;
    transform-origin: 0;
  }

  .mfp-arrow-right {
    -webkit-transform-origin: 100%;
    transform-origin: 100%;
  }

  .mfp-container {
    padding-left: 6px;
    padding-right: 6px;
  }
}

@charset "UTF-8";

/***
	create 2024/06/08
	edit   2024/12/16
***/
/* Removed external Google Fonts to satisfy CSP; rely on system fonts */
html,
body {
  margin: 0;
  padding: 0;
  font-family: "Noto Sans TC", sans-serif;
  font-size: 1rem;
  color: #313131;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

* {
  box-sizing: border-box;
}

a {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s;
}

a:hover,
a:focus {
  text-decoration: none;
}

a:focus {
  outline: 2px dashed #d14600 !important;
}

.btn:focus,
input:focus,
button:focus,
select:focus,
textarea:focus,
label:focus {
  outline: 2px dashed #d14600 !important;
  box-shadow: none;
}

.btn-default {
  font-weight: 600;
  color: #0a0a0a;
  text-align: center;
  vertical-align: top;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #ddd9d9;
  border: 1px solid transparent;
  padding: 4px;
  font-size: 1rem;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.goto-content {
  display: inline-block;
  padding: 0.2em 1em;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #fff;
  z-index: -99;
}

.goto-content:focus {
  z-index: 999;
}

img {
  width: 100%;
  max-width: 100%;
  vertical-align: bottom;
}

.flex {
  display: flex;
}

.flex-between {
  justify-content: space-between;
}

.flex-center {
  justify-content: center;
}

.align-center {
  align-items: center;
}

.align-top {
  align-items: flex-start;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.text-bold {
  font-weight: bold;
}

.pc-hide {
  display: none;
}

.br {
  display: block;
}

.inline-block {
  display: inline-block;
}

.wrap {
  width: 100%;
  margin: 0 auto;
  max-width: 1300px;
  padding: 0 15px;
}

.btn-side {
  position: fixed;
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  right: 25px;
  z-index: 90;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 1px 12px 0px rgba(0, 0, 0, 0.4);
}

.btn-side.btn-top {
  background-color: rgba(209, 70, 0, 0.9);
  bottom: 10%;
}

.btn-side.btn-back {
  background-color: rgba(93, 107, 192, 0.9);
  bottom: calc(10% + 62px);
}

.color-b1 {
  color: #5d6bc0;
}

.color-r1 {
  color: #d14600 !important;
}

.bg-g3 {
  background-color: #2c8280 !important;
}

.bg-r1 {
  background-color: #d14600 !important;
}

#header {
  padding: 26px 0 12px;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 99;
  background-color: #fff;
}

#header .wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#header .logo {
  width: 457px;
  margin: 0;
}

#header .logo a {
  display: flex;
  align-items: center;
}

#header #tools-menu {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  align-items: center;
}

#header #tools-menu li {
  position: relative;
  margin-right: 1px;
}

#header #tools-menu li::before {
  height: 16px;
  width: 1px;
  background-color: #313131;
  content: "";
  position: absolute;
  left: -1px;
  top: 50%;
  transform: translateY(-50%);
}

#header #tools-menu li:first-child a {
  padding: 0;
}

#header #tools-menu li:first-child::before,
#header #tools-menu li:nth-child(2)::before {
  display: none;
}

#header #tools-menu li.active .sub {
  display: block;
}

#header #tools-menu li a {
  display: flex;
  align-items: center;
  padding: 2px 14px;
}

#header #tools-menu li a.sub-arrow::after {
  content: "";
  margin-left: 4px;
  display: inline-block;
  border-style: solid;
  border-color: #313131 transparent transparent transparent;
  border-width: 6px 4px;
  margin-top: 6px;
}

#header #tools-menu li a i {
  width: 20px;
  height: 18px;
  display: inline-flex;
  margin-right: 4px;
  align-items: center;
}

#header #tools-menu li a i svg {
  fill: #5d6bc0;
}

#header #tools-menu li .sub {
  position: absolute;
  left: 0;
  top: 100%;
  background-color: #f7f7f7;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  display: none;
}

#header #tools-menu li .sub a {
  padding: 6px 26px;
  text-align: right;
  display: block;
}

#header #tools-menu li.setting {
  padding-left: 12px;
}

#header #tools-menu li.setting a {
  display: inline-block;
  vertical-align: top;
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 28px;
  border-radius: 100%;
  border: 1px solid #5d6bc0;
  font-size: 0.875em;
  margin-left: 4px;
  padding: 0;
}

#header #tools-menu li.setting a.active {
  background-color: #5d6bc0;
  color: #fff;
}

#header.page-header .logo {
  width: 336px;
  position: relative;
}

#header.page-header .logo::after {
  width: 130px;
  height: 95px;
  content: "";
  /*background: url(/assets/images/template/bg_header.png) no-repeat center center;*/
  background-size: contain;
  position: absolute;
  right: -160px;
  bottom: -12px;
}

#menu {
  background-color: #5d6bc0;
  position: sticky;
  z-index: 10;
  top: 0;
}

#menu ul {
  list-style: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

#menu ul li {
  position: relative;
}

#menu ul li.btn-search {
  padding-left: 10px;
}

#menu ul li.btn-search a {
  width: 40px;
  height: 40px;
  background-color: #fff;
  font-size: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
}

#menu ul li.btn-search a::after {
  content: "";
  width: 21px;
  height: 21px;
  background: url(/assets/images/template/icon_search_b.svg) no-repeat center center;
  background-size: contain;
}

#menu ul li.btn-search a.active::after {
  background-image: url(/assets/images/template/icon_close_b.svg);
}

#menu ul li a {
  display: block;
  padding: 17px 20px;
  text-align: center;
  color: #fff;
  font-size: 1.125em;
}

#menu ul li .sub {
  position: absolute;
  left: 0;
  top: 100%;
  background-color: #fff;
  width: 210px;
  padding: 0;
  margin: 0;
  list-style: none;
  display: none;
}

#menu ul li .sub>li {
  border-bottom: 1px dashed #5d6bc0;
}

#menu ul li .sub>li>a {
  padding-right: 49px;
}

#menu ul li .sub>li>a::before {
  width: 9px;
  height: 13px;
  background: url(/assets/images/template/icon_arrow_p.svg) no-repeat center center;
  background-size: contain;
  content: "";
  position: absolute;
  left: 22.5px;
  top: 24px;
}

#menu ul li .sub>li>a.sub-arrow::after {
  width: 25px;
  height: 25px;
  background: url(/assets/images/template/menu_open_b.svg) no-repeat center center;
  background-size: contain;
  content: "";
  position: absolute;
  right: 16px;
  top: 16px;
}

#menu ul li .sub>li>a.sub-arrow.open::after {
  background-image: url(/assets/images/template/menu_close_b.svg);
}

#menu ul li .sub a {
  padding: 16px 16px 16px 41px;
  display: block;
  color: #313131;
  text-align: left;
}

#menu ul li .sub .sub {
  background-color: #def5f9;
  /* #018098  #EDEFFA*/
  position: static;
}

#menu ul li .sub .sub li {
  border-bottom: none;
  border-top: 1px dashed #5d6bc0;
}

#menu ul li .sub .sub li a {
  padding-right: 16px;
}

#menu ul li .sub .sub li a::before {
  display: none;
}

#menu ul li.active>.sub {
  display: block;
}

#menu .search-block {
  background-color: #c2c7f7;
  padding: 15px 0;
  display: none;
}

#menu .search-block.active {
  display: block;
}

#menu .search-block .wrap {
  display: flex;
}

#menu .search-block .wrap #S {
  line-height: 45px;
}

#menu .search-block .wrap input {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  border: 1px solid #5d6bc0;
  width: calc(100% - 130px);
  font-size: 0.875em;
  height: 50px;
  padding: 0 20px;
  margin-left: 5px;
}

#menu .search-block .wrap .btn {
  background-color: #5d6bc0;
  color: #fff;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border: 1px solid #5d6bc0;
  width: 124px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.125em;
  cursor: pointer;
}

#menu .search-block .wrap .btn i {
  width: 24px;
  margin-right: 8px;
}

#menu>ul>li.active>a:not(.search-element) {
  background-color: rgba(255, 255, 255, 0.1);
}

#menu>ul>li.active>.sub {
  display: block;
}

#menu>ul>li>.sub {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  overflow-x: hidden;
}

#menu>ul>li>.sub::-webkit-scrollbar {
  width: 7px;
  background-color: #edeffa;
}

#menu>ul>li>.sub::-webkit-scrollbar-button {
  background: transparent;
  display: none;
}

#menu>ul>li>.sub::-webkit-scrollbar-track-piece {
  background: transparent;
}

#menu>ul>li>.sub::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background-color: rgba(116, 118, 195, 0.6);
  border: none;
}

#menu>ul>li>.sub::-webkit-scrollbar-track {
  box-shadow: transparent;
}

#footer {
  padding-top: 29px;
  margin-top: 70px;
  width: 100%;
}

#footer .wrap {
  max-width: 1280px;
  padding: 0 20px;
}

#footer a {
  padding: 0 3px;
  display: inline-block;
}

#footer .footer-top {
  display: flex;
  align-items: flex-start;
  position: relative;
  justify-content: center;
  gap: 0 20px;
  padding-bottom: 20px;
}

#footer .footer-top .footer-logo {
  width: 315px;
}

#footer .footer-top .footer-info .footer-menu {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
}

#footer .footer-top .footer-info .footer-menu li {
  position: relative;
  margin-right: 1px;
}

#footer .footer-top .footer-info .footer-menu li::before {
  height: 18px;
  width: 1px;
  background-color: #313131;
  content: "";
  position: absolute;
  left: -1px;
  top: 50%;
  transform: translateY(-50%);
}

#footer .footer-top .footer-info .footer-menu li:first-child::before {
  display: none;
}

#footer .footer-top .footer-info .footer-menu li a {
  display: block;
  padding: 1px 8px;
}

#footer .footer-top .footer-info p {
  margin: 5px 8px 0;
}

#footer .footer-top .footer-logo-group {
  display: flex;
  align-items: flex-start;
  gap: 0 8px;
}

#footer .footer-top .footer-logo-group a {
  display: block;
  padding: 0;
}

#footer .footer-top .footer-logo-group a:first-child {
  width: 50px;
}

#footer .footer-top .footer-logo-group a:nth-child(2) {
  width: 114px;
}

#footer .footer-bottom {
  border-top: 1px solid #313131;
  padding: 20px 100px;
  font-size: 0.875em;
  text-align: center;
  margin: 0;
  list-style: none;
}

#footer .footer-bottom li {
  display: inline-block;
  padding-left: 8px;
  padding-right: 5px;
  margin-bottom: 10px;
  position: relative;
  margin-right: 1px;
}

#footer .footer-bottom li::before {
  height: 14px;
  width: 1px;
  background-color: #313131;
  content: "";
  position: absolute;
  left: -1px;
  top: 50%;
  transform: translateY(-50%);
}

#footer .footer-bottom li:first-child::before {
  display: none;
}

#footer .footer-bottom li p {
  display: inline-block;
  margin: 0;
}

#footer .footer-bottom li p+p {
  margin-left: 40px;
}

#container {
  background: url(/assets/images/template/bg_bottom.png) repeat-x center bottom;
  background-size: 1440px auto;
}

input,
select,
textarea {
  background-color: #fff;
  border: 1px solid #caccd9;
  padding: 2px 20px 0;
  border-radius: 4px;
  line-height: 40px;
  font-size: 1em;
}

input.datepicker {
  padding: 0 38px 0 20px;
  background: #fff url(/images/template/icon_date.svg) no-repeat calc(100% - 12px) center;
  background-size: 21px auto;
}

select {
  padding: 0 38px 0 20px;
  -webkit-appearance: none;
  background: #fff url(/images/template/select_arrow.svg) no-repeat calc(100% - 12px) center;
  background-size: 14px auto;
}

textarea {
  height: 80px;
}

.checkbox-item {
  position: relative;
}

.checkbox-item>input {
  width: 0 !important;
  position: absolute;
  z-index: -99;
  opacity: 0;
}

.checkbox-item>input:checked+label::before {
  background-image: url(/assets/images/template/checkbox_selected.svg);
}

.checkbox-item>input:checked:disabled+label::before {
  background-image: url(/assets/images/template/checkbox_selected_disabled.svg);
}

.checkbox-item>input:disabled+label::before {
  background-image: url(/assets/images/template/checkbox_disabled.svg);
}

.checkbox-item>input+label {
  display: block;
  position: relative;
  padding-left: 30px;
  line-height: 20px;
  cursor: pointer;
}

.checkbox-item>input+label::before {
  width: 20px;
  height: 20px;
  content: "";
  background: url(/assets/images/template/checkbox.svg) no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 0;
  top: 0;
}

.radio-item {
  position: relative;
}

.radio-item>input {
  width: 0 !important;
  position: absolute;
  z-index: -99;
  opacity: 0;
}

.radio-item>input:checked+label::before {
  background-image: url(/assets/images/template/radio_selected.svg);
}

.radio-item>input:checked:disabled+label::before {
  background-image: url(/assets/images/template/radio_selected_disabled.svg);
}

.radio-item>input:disabled+label::before {
  background-image: url(/assets/images/template/radio_disabled.svg);
}

.radio-item>input+label {
  display: block;
  position: relative;
  padding-left: 30px;
  line-height: 20px;
  cursor: pointer;
}

.radio-item>input+label::before {
  width: 20px;
  height: 20px;
  content: "";
  background: url(/assets/images/template/radio.svg) no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 0;
  top: 0;
}

.checkbox-group.group-inline,
.radio-group.group-inline {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.checkbox-group .checkbox-group,
.checkbox-group .radio-group,
.radio-group .checkbox-group,
.radio-group .radio-group {
  padding-left: 30px;
}

.radio-list {
  border: 1px solid #5d6bc0;
}

.radio-list .radio-item {
  border: 1px solid #fff;
}

.radio-list .radio-item:nth-child(2n) {
  background-color: #f7f7f7;
  border: 1px solid #f7f7f7;
}

.radio-list .radio-item input+label {
  display: flex;
  gap: 10px;
  padding: 12px 10px 12px 40px;
}

.radio-list .radio-item input+label::before {
  left: 10px;
  top: 12px;
}

.btn {
  background-color: #5d6bc0;
  color: #fff;
  border-radius: 50px;
  padding: 0 10px;
  text-align: center;
  border: none;
  font-size: 1em;
  cursor: pointer;
}

.btn.btn-r {
  background-color: #d14600;
}

.btn.btn-lg {
  display: inline-flex;
  align-items: center;
  width: 200px;
  margin: 0 6px;
  justify-content: center;
  border: 1px solid #5d6bc0;
  padding: 10px;
  vertical-align: top;
}

.btn.btn-lg i {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}

.btn.btn-lg i img {
  vertical-align: top;
}

.btn.btn-sm {
  border: 1px solid #5d6bc0;
}

.btn.btn-outline {
  color: #5d6bc0;
  background-color: transparent;
  border: 1px solid #5d6bc0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn.btn-outline i {
  width: 14px;
  height: 14px;
  display: block;
  margin-right: 5px;
}

.btn.btn-outline i svg,
.btn.btn-outline i img {
  vertical-align: top;
}

.btn.btn-outline-r {
  color: #d14600;
  border-color: #d14600;
  background-color: #fff;
}

.btn.btn-outline-r .st0 {
  fill: #d14600;
}

.btn.btn-outline-g {
  color: #5d6bc0;
  border-color: #46cbaa;
  background-color: #fff;
}

.btn.btn-outline-b {
  color: #5d6bc0;
  border-color: #5d6bc0;
  background-color: #fff;
}

.btn.btn-outline-b .st0 {
  fill: #5d6bc0;
}

.btn-default:hover {
  color: #1736d2;
}

.btn-danger {
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
  padding: 6px;
  width: 80px;
}

.btn-danger:hover {
  color: #fff;
  background-color: #c82333 !important;
  border-color: #bd2130 !important;
  padding: 6px;
  width: 80px;
}

.page-container {
  padding-top: 20px;
  background: url(/assets/images/template/bg_dot.png) no-repeat center top;
  background-size: 1440px auto;
  display: flex;
}

.page-container #page-sidebar {
  width: 210px;
  position: relative;
}

.page-container #page-sidebar .side-box {
  border-bottom: 3px solid #5d6bc0;
  margin-bottom: 37px;
}

.page-container #page-sidebar .side-box .side-name {
  font-size: 1.25em;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  letter-spacing: 0.2em;
  background: linear-gradient(180deg, #5d6bc0 3.53%, #2f386f 100%);
  padding: 10px;
  border-radius: 50px 50px 0 0;
}

.page-container #page-sidebar .side-box .side-name::before,
.page-container #page-sidebar .side-box .side-name::after {
  content: "";
  width: 15px;
  height: 15px;
  background: url(/assets/images/template/sidebar_icon.svg) no-repeat center center;
  background-size: contain;
  margin: 0 6px;
}

.page-container #page-sidebar .side-box .side-name::before {
  margin-right: calc(6px + 0.2em);
}

.page-container #page-sidebar::after {
  content: "";
  position: absolute;
  left: -244px;
  bottom: 300px;
  width: 651px;
  height: 818px;
  background: url(/assets/images/template/bg_dot2.png) no-repeat left top;
  background-size: contain;
  z-index: -1;
}

.page-container #page-main {
  width: calc(100% - 210px);
  padding-left: 30px;
  padding-right: 2px;
}

.page-container #page-main .breadcrumbs {
  list-style: none;
  margin: 0 0 20px;
  padding: 0;
  display: flex;
  align-items: center;
  font-size: 0.875em;
  flex-wrap: wrap;
}

.page-container #page-main .breadcrumbs li {
  display: flex;
  align-items: center;
}

.page-container #page-main .breadcrumbs li a {
  display: block;
  padding: 2px 4px;
  border-radius: 4px;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.page-container #page-main .breadcrumbs li::before {
  content: "";
  background: url(/assets/images/template/icon_arrow_p.svg) no-repeat center center;
  background-size: contain;
  width: 6px;
  height: 10px;
  margin: 0 5px;
}

.page-container #page-main .breadcrumbs li:first-child::before {
  display: none;
}

.page-container #page-main .breadcrumbs li:nth-child(2) {
  font-size: 0;
}

.page-container #page-main .breadcrumbs li:nth-child(2)::before {
  display: none;
}

.page-container #page-main .breadcrumbs li:last-child {
  padding: 2px 0;
  color: #5d6bc0;
}

.page-container #page-main .breadcrumbs li i {
  display: inline-block;
  vertical-align: top;
  margin-top: 1px;
  width: 17px;
  height: 17px;
}

.page-container #page-main .breadcrumbs li i svg {
  width: 17px;
  height: 17px;
}

.page-container #page-main .breadcrumbs li i svg .st0 {
  fill: #5d6bc0;
}

.page-container #page-main .page-content {
  padding-bottom: 50px;
}

.page-container #page-main .page-content .page-title {
  font-size: 2.25em;
  padding-left: 70px;
  position: relative;
  font-weight: normal;
  margin: 0 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.page-container #page-main .page-content .page-title::before {
  content: "";
  width: 50px;
  height: 50px;
  background: url(/assets/images/template/icon_title.svg) no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 12px;
  top: 2px;
}

.page-container #page-main .page-content .page-title .btn {
  font-size: 0.556em;
  padding: 3px 18px;
  box-shadow: 6px 6px 0px 0px rgba(0, 0, 0, 0.06);
}

.page-container #page-main .page-content .page-title .btn i {
  width: 45px;
  height: 45px;
  margin-right: 2px;
  display: inline-block;
}

.page-container #page-main .page-content .tabs {
  margin-top: 28px;
}

.page-container #page-main .page-content .tabs .tabs-nav {
  display: flex;
  padding: 0 8px;
  gap: 0 5px;
  border-bottom: 3px solid #5d6bc0;
}

.page-container #page-main .page-content .tabs .tabs-nav a {
  border-width: 1px 1px 0px 1px;
  border-style: dashed;
  border-color: #c2c7f7;
  color: #757575;
  text-align: center;
  min-width: 95px;
  padding: 12px 15px;
  border-radius: 30px 30px 0 0;
}

.page-container #page-main .page-content .tabs .tabs-nav a.active {
  border-style: solid;
  border-color: #5d6bc0;
  position: relative;
  background-color: #fff;
  color: #313131;
}

.page-container #page-main .page-content .tabs .tabs-nav a.active::before {
  display: inline-block;
  vertical-align: top;
  content: "";
  width: 6px;
  height: 6px;
  background-color: #d14600;
  border-radius: 100%;
  margin-right: 8px;
  margin-top: 8px;
}

.page-container #page-main .page-content .tabs .tabs-nav a.active::after {
  content: "";
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border-width: 3px 0 0 0;
  border-style: solid;
  border-color: #5d6bc0;
  position: absolute;
  border-radius: 28px 28px 0 0;
}

.page-container #page-main .page-content .tabs.tabs-apply {
  margin: 30px auto 0;
  max-width: 690px;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-nav {
  display: flex;
  padding: 0;
  gap: 0;
  border-bottom: none;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-nav a {
  flex: 1;
  border: none;
  color: #fff;
  border-radius: 0;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-nav a.active::before {
  display: none;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-nav a.active::after {
  display: none;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content {
  border: 2px solid #c2c7f7;
  box-shadow: 6px 6px 0px 0px rgba(0, 0, 0, 0.06);
  padding: 40px 60px;
  background-color: #fff;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content.line-r1 {
  border-color: #d14600;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content.line-g3 {
  border-color: #2c8280;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .top-block {
  display: flex;
  justify-content: space-between;
  margin-bottom: 32px;
  align-items: center;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .top-block .name {
  color: #5d6bc0;
  font-size: 1.875em;
  flex: 1;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .top-block .btn {
  box-shadow: 6px 6px 0px 0px rgba(0, 0, 0, 0.06);
  padding: 11px 24px;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .btn {
  font-size: 0.875em;
  white-space: nowrap;
  padding: 9px 16px;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row {
  margin: 24px 0;
  gap: 0 12px;
  padding: 0;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .name {
  width: 100px;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row>input,
.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row>select {
  flex: 1;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row {
  padding-left: 112px;
  display: flex;
  gap: 0 12px;
  align-items: center;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row.code-row .img-code {
  width: 100px;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .checkbox-item,
.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .radio-item {
  padding: 10px 0;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content . btn-lg w-100 .btn {
  display: flex;
  width: 100%;
  margin: 0;
}

.page-container #page-main .page-content .news-list .news-item {
  border-bottom: 1px dashed #c2c7f7;
  position: relative;
}

.page-container #page-main .page-content .news-list .news-item.news-img-left .news-text,
.page-container #page-main .page-content .news-list .news-item.news-img-top .news-text {
  padding: 16px 32px 14px 269px;
  min-height: 190px;
}

.page-container #page-main .page-content .news-list .news-item .news-img {
  display: block;
  width: 210px;
  height: 160px;
  border: 1px solid #f1f1f1;
  position: absolute;
  overflow: hidden;
  left: 32px;
  top: 16px;
}

.page-container #page-main .page-content .news-list .news-item .news-img.icon-video::after {
  content: "";
  width: 80px;
  height: 80px;
  background: rgba(93, 107, 192, 0.6) url(/assets/images/template/icon_player.png) no-repeat center center;
  background-size: 48px 48px;
  border: 2px solid #fff;
  border-radius: 100%;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  position: absolute;
}

.page-container #page-main .page-content .news-list .news-item .news-img img {
  width: auto;
  max-width: none;
  height: 160px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.page-container #page-main .page-content .news-list .news-item .news-text {
  display: block;
  padding: 16px 32px 14px;
}

.page-container #page-main .page-content .news-list .news-item .news-text .news-name {
  font-size: 1.25em;
  color: #5d6bc0;
  margin-bottom: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.page-container #page-main .page-content .news-list .news-item .news-text p {
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  line-height: 1.5em;
  height: 4.5em;
}

.page-container #page-main .page-content .news-list .news-item .news-text .news-bottom {
  margin-top: 20px;
  margin-bottom: 10px;
}

.page-container #page-main .page-content .news-list .news-item .news-text .news-bottom .btn-more {
  font-size: 0.75em;
}

.page-container #page-main .page-content .news-list .news-item .news-text .news-bottom .btn-more::before {
  width: 13px;
  height: 13px;
  background-position-x: 55%;
  background-size: auto 7px;
  margin-top: 3px;
}

.page-container #page-main .page-content .media-list {
  display: flex;
  gap: 20px 0;
  flex-wrap: wrap;
  margin: 28px -10px 0;
}

.page-container #page-main .page-content .media-list .media-item {
  display: block;
  border: 1px solid #c2c7f7;
  box-shadow: 6px 6px 0px 0px rgba(0, 0, 0, 0.06);
  padding: 16px;
  background-color: #fff;
  width: calc((100% / 3) - 20px);
  margin: 0 10px;
}

.page-container #page-main .page-content .media-list .media-item .media-img {
  padding-top: 60%;
  border: 1px solid #f1f1f1;
  margin-bottom: 12px;
  position: relative;
  overflow: hidden;
}

.page-container #page-main .page-content .media-list .media-item .media-img::after {
  content: "";
  width: 80px;
  height: 80px;
  background: rgba(93, 107, 192, 0.6) url(/assets/images/template/icon_player.png) no-repeat center center;
  background-size: 48px 48px;
  border: 2px solid #fff;
  border-radius: 100%;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  position: absolute;
}

.page-container #page-main .page-content .media-list .media-item .media-img img {
  width: auto;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.page-container #page-main .page-content .media-list .media-item .media-text .media-name {
  font-size: 1.125em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  line-height: 1.5em;
  height: 3em;
  margin-bottom: 12px;
}

.page-container #page-main .page-content .media-list .media-item .media-text .media-tag {
  background-color: #5d6bc0;
  color: #fff;
  font-size: 0.875em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 6px 12px 7px 34px;
  position: relative;
}

.page-container #page-main .page-content .media-list .media-item .media-text .media-tag::before {
  position: absolute;
  width: 14px;
  height: 16px;
  content: "";
  background: url(/assets/images/template/icon_tag_w.svg) no-repeat center center;
  background-size: contain;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
}

.page-container #page-main .page-content .download-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.page-container #page-main .page-content .download-list li+li {
  border-top: 1px solid #f1f1f1;
}

.page-container #page-main .page-content .download-list li a {
  padding: 12px 20px 12px 30px;
  position: relative;
  display: flex;
  align-items: center;
  min-height: 69px;
}

.page-container #page-main .page-content .download-list li a .name {
  position: relative;
  width: calc(100% - 57px);
  padding-left: 42px;
}

.page-container #page-main .page-content .download-list li a .name::before {
  content: "";
  width: 30px;
  height: 24px;
  background: url(/assets/images/template/icon_download.svg) no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 0;
  top: 0;
}

.page-container #page-main .page-content .download-list li a::after {
  content: "";
  width: 45px;
  height: 45px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  border-radius: 100%;
  margin-left: 12px;
}

.page-container #page-main .page-content .download-list li a.icon-odt::after {
  background-color: rgba(42, 85, 153, 0.1);
  background-image: url(/assets/images/template/download_odt.svg);
}

.page-container #page-main .page-content .download-list li a.icon-ods::after {
  background-color: rgba(30, 112, 66, 0.1);
  background-image: url(/assets/images/template/download_ods.svg);
}

.page-container #page-main .page-content .download-list li a.icon-pdf::after {
  background-color: rgba(179, 11, 0, 0.1);
  background-image: url(/assets/images/template/download_pdf.svg);
}

.page-container #page-main .page-content .download-list li a.icon-odp::after {
  background-color: rgba(222, 58, 25, 0.1);
  background-image: url(/assets/images/template/download_odp.svg);
}

.page-container #page-main .page-content .download-list li a.icon-jpg::after {
  background-color: rgba(93, 107, 192, 0.2);
  background-image: url(/assets/images/template/download_jpg.svg);
}

.page-container #page-main .page-content .download-list li a.icon-png::after {
  background-color: rgba(93, 107, 192, 0.2);
  background-image: url(/assets/images/template/download_png.svg);
}

.page-container #page-main .page-content .books-list {
  display: flex;
  gap: 50px 0;
  flex-wrap: wrap;
  margin-top: 50px;
}

.page-container #page-main .page-content .books-list .book-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc((100% / 3) - 10px);
  margin: 0 5px;
  padding-left: 100px;
}

.page-container #page-main .page-content .books-list .book-item .book-img {
  margin-bottom: 20px;
}

.page-container #page-main .page-content .books-list .book-item .book-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  line-height: 1.5em;
  height: 3em;
}

.page-container #page-main .page-content .books-list .book-hover:hover .book>.book-front,
.page-container #page-main .page-content .books-list .book-hover:focus .book>.book-front {
  transform: rotateY(-145deg) translateZ(0);
  z-index: 0;
}

.page-container #page-main .page-content .books-list .book-hover:hover .book>.book-content li:nth-child(1),
.page-container #page-main .page-content .books-list .book-hover:focus .book>.book-content li:nth-child(1) {
  transform: rotateY(-30deg);
  transition-duration: 1.5s;
}

.page-container #page-main .page-content .books-list .book-hover:hover .book>.book-content li:nth-child(2),
.page-container #page-main .page-content .books-list .book-hover:focus .book>.book-content li:nth-child(2) {
  transform: rotateY(-35deg);
  transition-duration: 1.8s;
}

.page-container #page-main .page-content .books-list .book-hover:hover .book>.book-content li:nth-child(3),
.page-container #page-main .page-content .books-list .book-hover:focus .book>.book-content li:nth-child(3) {
  transform: rotateY(-118deg);
  transition-duration: 1.6s;
}

.page-container #page-main .page-content .books-list .book-hover:hover .book>.book-content li:nth-child(4),
.page-container #page-main .page-content .books-list .book-hover:focus .book>.book-content li:nth-child(4) {
  transform: rotateY(-130deg);
  transition-duration: 1.4s;
}

.page-container #page-main .page-content .books-list .book-hover:hover .book>.book-content li:nth-child(5),
.page-container #page-main .page-content .books-list .book-hover:focus .book>.book-content li:nth-child(5) {
  transform: rotateY(-140deg);
  transition-duration: 1.2s;
}

.page-container #page-main .page-content .books-list .book {
  position: relative;
  width: 125px;
  height: 170px;
  -webkit-perspective: 1000px;
  -moz-perspective: 1000px;
  perspective: 1000px;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.page-container #page-main .page-content .books-list .book-front,
.page-container #page-main .page-content .books-list .book-back,
.page-container #page-main .page-content .books-list .book-spine {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.page-container #page-main .page-content .books-list .book-front li,
.page-container #page-main .page-content .books-list .book-back li,
.page-container #page-main .page-content .books-list .book-spine li {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.page-container #page-main .page-content .books-list .book-front li:first-child::before,
.page-container #page-main .page-content .books-list .book-front li:first-child::after,
.page-container #page-main .page-content .books-list .book-front li:last-child::before,
.page-container #page-main .page-content .books-list .book-front li:last-child::after,
.page-container #page-main .page-content .books-list .book-back li:first-child::before,
.page-container #page-main .page-content .books-list .book-back li:first-child::after,
.page-container #page-main .page-content .books-list .book-back li:last-child::before,
.page-container #page-main .page-content .books-list .book-back li:last-child::after,
.page-container #page-main .page-content .books-list .book-spine li:first-child::before,
.page-container #page-main .page-content .books-list .book-spine li:first-child::after,
.page-container #page-main .page-content .books-list .book-spine li:last-child::before,
.page-container #page-main .page-content .books-list .book-spine li:last-child::after {
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}

.page-container #page-main .page-content .books-list .book-front {
  -webkit-transform-origin: 0% 100%;
  -moz-transform-origin: 0% 100%;
  transform-origin: 0% 100%;
  transform: rotateY(-34deg) translateZ(8px);
  transition: all 0.8s ease, z-index 0.6s;
  z-index: 100;
}

.page-container #page-main .page-content .books-list .book-front li:first-child {
  background-color: #eee;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  backface-visibility: hidden;
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  transform: translateZ(2px);
}

.page-container #page-main .page-content .books-list .book-front li:first-child::before,
.page-container #page-main .page-content .books-list .book-front li:first-child::after {
  background-color: #999;
  width: 4px;
  height: 100%;
  content: "";
}

.page-container #page-main .page-content .books-list .book-front li:first-child::after {
  transform: rotateY(90deg) translateZ(-2px) translateX(2px);
}

.page-container #page-main .page-content .books-list .book-front li:first-child::before {
  transform: rotateY(90deg) translateZ(123.5px) translateX(2px);
}

.page-container #page-main .page-content .books-list .book-front li:last-child {
  background-color: #fffbec;
  transform: rotateY(180deg) translateZ(2px);
}

.page-container #page-main .page-content .books-list .book-front li:last-child::before,
.page-container #page-main .page-content .books-list .book-front li:last-child::after {
  background-color: #999;
  width: 4px;
  height: 125px;
  content: "";
}

.page-container #page-main .page-content .books-list .book-front li:last-child::after {
  transform: rotateX(90deg) rotateZ(90deg) translateZ(62.5px) translateX(-2px) translateY(-61px);
}

.page-container #page-main .page-content .books-list .book-front li:last-child::before {
  box-shadow: 0px 0px 30px 5px #999;
  transform: rotateX(90deg) rotateZ(90deg) translateZ(-109px) translateX(-2px) translateY(-61px);
}

.page-container #page-main .page-content .books-list .book-back {
  transform-origin: 0% 100%;
  transform: rotateY(-15deg) translateZ(-8px);
}

.page-container #page-main .page-content .books-list .book-back::before,
.page-container #page-main .page-content .books-list .book-back::after {
  content: "";
}

.page-container #page-main .page-content .books-list .book-back li:first-child {
  background-color: #fffbec;
  transform: translateZ(2px);
}

.page-container #page-main .page-content .books-list .book-back li:first-child::before,
.page-container #page-main .page-content .books-list .book-back li:first-child::after {
  width: 4px;
  height: 100%;
  background-color: #999;
  content: "";
}

.page-container #page-main .page-content .books-list .book-back li:first-child::after {
  transform: rotateY(90deg) translateZ(-2px) translateX(2px);
}

.page-container #page-main .page-content .books-list .book-back li:first-child::before {
  transform: rotateY(90deg) translateZ(123.5px) translateX(2px);
}

.page-container #page-main .page-content .books-list .book-back li:last-child {
  background-color: #fffbec;
  transform: translateZ(-2px);
}

.page-container #page-main .page-content .books-list .book-back li:last-child::before,
.page-container #page-main .page-content .books-list .book-back li:last-child::after {
  content: "";
  width: 4px;
  height: 125px;
  background-color: #999;
}

.page-container #page-main .page-content .books-list .book-back li:last-child::after {
  transform: rotateX(90deg) rotateZ(90deg) translateZ(62.5px) translateX(2px) translateY(-61px);
}

.page-container #page-main .page-content .books-list .book-back li:last-child::before {
  box-shadow: 10px -1px 40px 10px #999;
  transform: rotateX(90deg) rotateZ(90deg) translateZ(-109px) translateX(2px) translateY(-61px);
}

.page-container #page-main .page-content .books-list .book-spine {
  transform: rotateY(60deg) translateX(-5px) translateZ(-12px);
  width: 16px;
  z-index: 0;
}

.page-container #page-main .page-content .books-list .book-spine li:first-child {
  background-color: #eee;
  transform: translateZ(2px);
}

.page-container #page-main .page-content .books-list .book-spine li:first-child::before,
.page-container #page-main .page-content .books-list .book-spine li:first-child::after {
  background-color: #999;
  width: 4px;
  height: 100%;
  content: "";
}

.page-container #page-main .page-content .books-list .book-spine li:first-child::after {
  transform: rotateY(90deg) translateZ(-2px) translateX(2px);
}

.page-container #page-main .page-content .books-list .book-spine li:first-child::before {
  transform: rotateY(-90deg) translateZ(-12px);
}

.page-container #page-main .page-content .books-list .book-spine li:last-child {
  background-color: #999;
  transform: translateZ(-2px);
}

.page-container #page-main .page-content .books-list .book-spine li:last-child::before,
.page-container #page-main .page-content .books-list .book-spine li:last-child::after {
  background-color: #999;
  width: 4px;
  height: 16px;
  content: "";
}

.page-container #page-main .page-content .books-list .book-spine li:last-child::after {
  transform: rotateX(90deg) rotateZ(90deg) translateZ(8px) translateX(2px) translateY(-6px);
}

.page-container #page-main .page-content .books-list .book-spine li:last-child::before {
  box-shadow: 5px -1px 50px 20px rgba(0, 0, 0, 0.2);
  transform: rotateX(90deg) rotateZ(90deg) translateZ(-164px) translateX(2px) translateY(-6px);
}

.page-container #page-main .page-content .books-list .book-content {
  width: 100%;
  height: 98%;
  top: 1%;
  left: 3%;
  z-index: 10;
  position: absolute;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.page-container #page-main .page-content .books-list .book-content li {
  background: linear-gradient(to left, #fffbf6 0%, #eee 100%);
  box-shadow: inset 0px -1px 2px rgba(50, 50, 50, 0.1),
    inset -1px 0px 1px rgba(150, 150, 150, 0.2);
  border-radius: 0px 5px 5px 0px;
  width: 100%;
  height: 100%;
  transform-origin: left center;
  transition-property: transform;
  transition-timing-function: ease;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.page-container #page-main .page-content .books-list .book-content li:nth-child(1) {
  transform: rotateY(-28deg);
  transition-duration: 0.6s;
}

.page-container #page-main .page-content .books-list .book-content li:nth-child(2) {
  transform: rotateY(-30deg);
  transition-duration: 0.6s;
  display: flex;
  justify-content: center;
  align-items: center;
}

.page-container #page-main .page-content .books-list .book-content li:nth-child(3) {
  transform: rotateY(-32deg);
  transition-duration: 0.4s;
}

.page-container #page-main .page-content .books-list .book-content li:nth-child(4) {
  transform: rotateY(-34deg);
  transition-duration: 0.5s;
}

.page-container #page-main .page-content .books-list .book-content li:nth-child(5) {
  transform: rotateY(-36deg);
  transition-duration: 0.6s;
}

.page-container #page-main .page-content .books-list .cover {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  backface-visibility: hidden;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.page-container #page-main .page-content .books-list .book-btn {
  display: block;
  border: 2px solid #313131;
  font-size: 0.875em;
  font-weight: 700;
  padding: 5px 15px;
  text-align: center;
}

.page-container #page-main .page-content .faq-list {
  margin-top: 30px;
}

.page-container #page-main .page-content .faq-list .faq-item {
  border: 1px solid #c2c7f7;
  border-radius: 10px;
  box-shadow: 6px 6px 0px 0px rgba(93, 107, 192, 0.06);
  margin-bottom: 16px;
  background-color: #fff;
}

.page-container #page-main .page-content .faq-list .faq-item.active .faq-header {
  border-radius: 10px 10px 0 0;
}

.page-container #page-main .page-content .faq-list .faq-item.active .faq-header::after {
  background-image: url(/assets/images/fag/btn_close.svg);
}

.page-container #page-main .page-content .faq-list .faq-item.active .faq-content {
  display: block;
}

.page-container #page-main .page-content .faq-list .faq-item .faq-header {
  display: flex;
  padding: 16px 68px 16px 22px;
  align-items: flex-start;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
}

.page-container #page-main .page-content .faq-list .faq-item .faq-header::after {
  width: 36px;
  height: 36px;
  position: absolute;
  right: 20px;
  top: 16px;
  border-radius: 100%;
  content: "";
  background: #5d6bc0 url(/assets/images/fag/btn_open.svg) no-repeat center center;
}

.page-container #page-main .page-content .faq-list .faq-item .faq-header .icon {
  width: 40px;
  height: 40px;
  margin-top: 12px;
  margin-right: 12px;
}

.page-container #page-main .page-content .faq-list .faq-item .faq-header .name {
  width: calc(100% - 52px);
}

.page-container #page-main .page-content .faq-list .faq-item .faq-header .name .top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.page-container #page-main .page-content .faq-list .faq-item .faq-header .name .top .tag {
  font-size: 0.875em;
  padding: 4px 12px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  background-color: #f7f7f7;
}

.page-container #page-main .page-content .faq-list .faq-item .faq-header .name .top .tag i {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}

.page-container #page-main .page-content .faq-list .faq-item .faq-header .name .top .tag i img {
  vertical-align: top;
  margin-top: 1px;
}

.page-container #page-main .page-content .faq-list .faq-item .faq-header .name p {
  font-size: 1.125em;
  color: #5d6bc0;
  margin: 0;
  padding-left: 12px;
}

.page-container #page-main .page-content .faq-list .faq-item .faq-content {
  margin: 8px 0 18px 48px;
  padding: 0 40px 0 16px;
  border-left: 1px dashed #c2c7f7;
  display: none;
}

.page-container #page-main .page-content .pagination {
  margin-top: 42px;
  margin-bottom: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.page-container #page-main .page-content .pagination .pagination-num {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  gap: 0 10px;
}

.page-container #page-main .page-content .pagination .pagination-num li a,
.page-container #page-main .page-content .pagination .pagination-num li span {
  display: block;
  border: 1px solid #5d6bc0;
  border-radius: 4px;
  line-height: 28px;
  min-width: 30px;
  text-align: center;
  padding: 0 10px;
  background-color: #fff;
}

.page-container #page-main .page-content .pagination .pagination-num li a.active {
  background-color: #edeffa;
}

.page-container #page-main .page-content .pagination .pagination-num li a.page-arrow {
  background-color: #5d6bc0;
  color: #fff;
  padding: 0 12px;
  text-align: center;
}

.page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-prev {
  border-radius: 30px 4px 4px 30px;
}

.page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-prev::before {
  content: "";
  width: 7px;
  height: 10px;
  display: inline-block;
  vertical-align: top;
  margin-right: 6px;
  margin-top: 10px;
  background: url(/assets/images/template/icon_arrow_w.svg) no-repeat center center;
  background-size: contain;
  transform: rotate(180deg);
}

.page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-next {
  border-radius: 4px 30px 30px 4px;
}

.page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-next::after {
  content: "";
  width: 7px;
  height: 10px;
  display: inline-block;
  vertical-align: top;
  margin-left: 6px;
  margin-top: 10px;
  background: url(/assets/images/template/icon_arrow_w.svg) no-repeat center center;
  background-size: contain;
}

.page-container #page-main .page-content .pagination .pagination-page::before {
  content: "";
  width: 15px;
  height: 15px;
  background: url(/assets/images/template/sidebar_icon.svg) no-repeat center center;
  background-size: contain;
  margin: 0 10px 0 16px;
  display: inline-block;
}

.page-container #page-main .page-content .pagination .pagination-page label,
.page-container #page-main .page-content .pagination .pagination-page span {
  display: inline-block;
  margin: 0 4px;
}

.page-container #page-main .page-content .pagination .pagination-page label span,
.page-container #page-main .page-content .pagination .pagination-page span span {
  margin: 0;
}

.page-container #page-main .page-content .pagination .pagination-page input {
  width: 80px;
  border: 1px solid #757575;
  border-radius: 4px;
  padding: 2px 5px 0;
  line-height: 25px;
  height: auto;
  text-align: center;
}

.page-container #page-main .page-content .pagination .pagination-page .btn {
  display: inline-block;
  margin-left: 10px;
  padding-top: 3px;
  line-height: 27px;
  font-size: 1em;
  width: 100px;
}

.page-container #page-main .page-content .block-content {
  border-top: 2px solid #c2c7f7;
  border-bottom: 2px solid #c2c7f7;
  padding: 20px;
  margin-top: 28px;
}

.page-container #page-main .page-content .color-block {
  padding: 15px 20px;
  background-color: #edeffa;
}

.page-container #page-main .page-content .color-block p {
  margin: 0;
}

.page-container #page-main .page-content .color-block p.line-top {
  border-top: 1px solid #c2c7f7;
  padding-top: 12px;
}

.page-container #page-main .page-content table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #5d6bc0;
  margin-bottom: 13px;
  background-color: #fff;
}

.page-container #page-main .page-content table.table-sm {
  font-size: 0.875em;
}

.page-container #page-main .page-content table.table-sm thead th {
  padding: 12px 8px;
}

.page-container #page-main .page-content table.table-sm tbody td {
  padding: 12px 8px;
}

.page-container #page-main .page-content table.table-sm .btn {
  padding: 8px 10px;
}

.page-container #page-main .page-content table.table-sm .btn+.btn {
  margin-top: 10px;
}

.page-container #page-main .page-content table.table-horizontal tr {
  border-bottom: none;
}

.page-container #page-main .page-content table thead {
  background-color: #5d6bc0;
  color: #fff;
}

.page-container #page-main .page-content table thead th {
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  padding: 12px 16px;
}

.page-container #page-main .page-content table tbody td {
  padding: 12px 16px;
  vertical-align: top;
}

.page-container #page-main .page-content table tbody td.name {
  background-color: #5d6bc0;
  color: #fff;
  width: 150px;
}

.page-container #page-main .page-content table tbody tr {
  border-bottom: 1px solid #c2c7f7;
}

.page-container #page-main .page-content table tbody tr:nth-child(2n) {
  background-color: #f7f7f7;
}

.page-container #page-main .page-content table tbody tr.focus {
  background-color: #c2c7f7 !important;
  outline: 2px dashed #d14600 !important;
}

.page-container #page-main .page-content table tbody tr.tr-link {
  cursor: pointer;
}

.page-container #page-main .page-content table .tr-hover:focus {
  outline: none !important;
}

.page-container #page-main .page-content table a {
  display: block;
}

.page-container #page-main .page-content table i {
  width: 14px;
  height: 16px;
  display: inline-block;
  vertical-align: top;
  margin-right: 6px;
  margin-top: 5px;
}

.page-container #page-main .page-content table i img {
  vertical-align: top;
}

.page-container #page-main .page-content table .td-date {
  white-space: nowrap;
}

.page-container #page-main .page-content table .download-list {
  margin: -12px -16px !important;
}

.page-container #page-main .page-content table .download-list li a {
  padding: 12px 16px;
  min-height: 65px;
}

.page-container #page-main .page-content table .download-list li a .name {
  width: calc(100% - 50px);
  padding-left: 34px;
}

.page-container #page-main .page-content table .download-list li a .name::before {
  width: 25px;
  height: 20px;
  top: 3px;
}

.page-container #page-main .page-content table .download-list li a::after {
  width: 40px;
  height: 40px;
  margin-left: 10px;
}

.page-container #page-main .page-content table p {
  margin: 0;
}

.page-container #page-main .page-content table .tag-y {
  display: inline-flex;
  padding: 5px 10px;
  border-radius: 50px;
  background-color: #fffb9d;
  color: #5d6bc0;
  font-size: 0.857em;
  display: inline-flex;
  align-items: center;
  margin-bottom: 4px;
}

.page-container #page-main .page-content table .tag-y i {
  width: 8px;
  height: 12px;
  margin-right: 4px;
  margin-top: 2px;
}

.page-container #page-main .page-content table .tag-y i img {
  vertical-align: top;
}

.page-container #page-main .page-content table .text-limit {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  line-height: 1.4em;
  min-height: 5.6em;
}

.page-container #page-main .page-content .article a {
  text-decoration: underline;
  color: #5d6bc0;
}

.page-container #page-main .page-content .article figure {
  text-align: center;
  margin: 0 0 16px;
}

.page-container #page-main .page-content .article figure img {
  width: auto;
}

.page-container #page-main .page-content .article p {
  margin-bottom: 20px;
  margin-top: 0;
}

.page-container #page-main .page-content .article .h2 {
  font-size: 1.25em;
}

.page-container #page-main .page-content .article .h3 {
  font-size: 1.125em;
}

.page-container #page-main .page-content .article .h4 {
  font-size: 1em;
}

.page-container #page-main .page-content .article ol {
  margin-top: 0;
  margin-bottom: 20px;
}

.page-container #page-main .page-content .article ol.list-number {
  padding-left: 1.4em;
}

.page-container #page-main .page-content .article ol.list-en {
  list-style: lower-alpha;
  padding-left: 1.4em;
}

.page-container #page-main .page-content .article ol.list-tw {
  list-style: cjk-ideographic;
}

.page-container #page-main .page-content .article ol.list-tw>li b {
  margin-bottom: 8px;
}

.page-container #page-main .page-content .article ol.list-tw .list-tw {
  counter-reset: count;
}

.page-container #page-main .page-content .article ol.list-tw .list-tw>li {
  counter-increment: count;
}

.page-container #page-main .page-content .article ol.list-tw .list-tw>li::marker {
  content: "（" counter(count, cjk-ideographic) "）";
}

.page-container #page-main .page-content .tag-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0 8px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.page-container #page-main .page-content .tag-list .tag-item {
  padding: 16px 12px;
  width: calc(100% / 3);
  border-bottom: 1px solid #c2c7f7;
  background-color: #fff;
}

.page-container #page-main .page-content .tag-list .tag-item .tag-name {
  box-shadow: 4px 4px 0px 0px rgba(0, 0, 0, 0.15);
  border: 1px solid #c2c7f7;
  border-radius: 0 50px 50px 0;
  padding: 2px 16px 2px 12px;
  position: relative;
  display: inline-flex;
  align-items: center;
  color: #5d6bc0;
  font-size: 0.875em;
  margin-bottom: 12px;
  background-color: #fff;
}

.page-container #page-main .page-content .tag-list .tag-item .tag-name::before {
  content: "";
  width: 13px;
  height: 13px;
  margin-right: 8px;
  background: url(/assets/images/template/icon_user_g.svg) no-repeat center center;
  background-size: contain;
}

.page-container #page-main .page-content .tag-list .tag-item p {
  margin: 0;
}

.page-container #page-main .page-content .tag-list .tag-item.tag-item-bg {
  background-color: #f7f7f7;
}

.page-container #page-main .page-content .tag-list .tag-item-col12 {
  width: 100%;
}

.page-container #page-main .page-content .tag-list .tag-item-col6 {
  width: 50%;
}

.page-container #page-main .page-content .tag-list .tag-item-col8 {
  width: calc((100% / 3) * 2);
}

.page-container #page-main .page-content .tag-list .tag-item .download-list li a {
  padding: 0;
  min-height: 48px;
  color: #5d6bc0;
  text-decoration: underline;
}

.page-container #page-main .page-content .keyboard-tag {
  display: inline-block;
  vertical-align: top;
  margin: -7px 5px 0;
  width: 100px;
  border: 1px solid #cbcbcb;
  border-radius: 5px;
  padding: 6px 0;
  text-align: center;
  background-color: #edeffa;
}

.page-container #page-main .page-content . btn-lg w-100 {
  margin-top: 30px;
}

.page-container #page-main .page-content . btn-lg w-100 .btn-outline {
  background-color: #edeffa;
}

.page-container #page-main .page-content .text-sm {
  font-size: 0.875em;
}

.page-container #page-main .page-content .from-block .input-row {
  display: flex;
  align-items: center;
  padding: 16px 8px;
  gap: 0 8px;
}

.page-container #page-main .page-content .from-block [data-relation-show] {
  display: none;
}

.page-container #page-main .page-content .from-block [data-relation-show].open {
  display: flex;
}

.page-container #page-main .page-content .keyboard-list li {
  display: flex;
  align-items: flex-start;
}

.page-container #page-main .page-content .keyboard-list li .keyboard-text {
  width: calc(100% - 110px);
}

.page-container #page-main .page-content .keyboard-list li .keyboard-group-lg+.keyboard-text {
  width: calc(100% - 255px);
}

.page-container #page-main .page-content .sitemap-list {
  margin-top: 20px;
  border-bottom: 1px dashed #c2c7f7;
}

.page-container #page-main .page-content .sitemap-list .sitemap-name {
  font-size: 1.25em;
  display: flex;
  align-items: center;
  font-weight: 500;
  padding: 5px;
  text-decoration: none;
  color: inherit;
}

.page-container #page-main .page-content .sitemap-list .sitemap-name::before {
  display: inline-block;
  width: 40px;
  height: 40px;
  content: "";
  background: url(/assets/images/sitemap/icon_bear.svg) no-repeat center center;
  background-size: contain;
  margin-right: 8px;
}

.page-container #page-main .page-content .sitemap-list .link {
  display: flex;
  padding: 13px 5px;
  text-decoration: none;
  color: inherit;
}

.page-container #page-main .page-content .sitemap-list .link span {
  white-space: nowrap;
}

.page-container #page-main .page-content .sitemap-list .row:nth-child(2n) {
  background-color: #f7f7f7;
}

.page-container #page-main .page-content .sitemap-list .row .col {
  padding: 16px 15px;
  border-top: 1px solid #c2c7f7;
}

.page-container #page-main .article-main .article-top {
  /*margin-bottom: 32px;*/
}

.page-container #page-main .article-main .article-top .article-title {
  font-size: 2em;
  margin-bottom: 8px;
  font-weight: bold;
}

.page-container #page-main .article-main .article-top .article-sub-title {
  font-size: 1.5em;
  color: #5d6bc0;
  font-weight: bold;
}

.page-container #page-main .article-main .article-top .article-tag {
  display: inline-flex;
  padding: 5px 10px;
  border-radius: 50px;
  background-color: #fffb9d;
  color: #5d6bc0;
  font-size: 0.875em;
  display: inline-flex;
  align-items: center;
  margin-bottom: 8px;
  margin-top: 20px;
}

.page-container #page-main .article-main .article-top .article-tag i {
  width: 11px;
  height: 15px;
  margin-right: 4px;
}

.page-container #page-main .article-main .article-top .article-tag i img {
  vertical-align: top;
}

.page-container #page-main .article-main .article-tag {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 0.875em;
}

.page-container #page-main .article-main .article-tag li {
  display: inline-flex;
  vertical-align: top;
  align-items: center;
  position: relative;
  margin: 2px 0;
}

.page-container #page-main .article-main .article-tag li::before {
  content: "";
  width: 16px;
  height: 16px;
  display: block;
  margin-right: 6px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
}

.page-container #page-main .article-main .article-tag li::after {
  content: "";
  width: 1px;
  height: 12px;
  background-color: #313131;
  display: block;
  margin: 0 10px 0 12px;
}

.page-container #page-main .article-main .article-tag li:last-child:after {
  display: none;
}

.page-container #page-main .article-main .article-tag li.icon-clock::before {
  background-image: url(/assets/images/template/icon_clock_p.svg);
}

.page-container #page-main .article-main .article-tag li.icon-tag::before {
  background-image: url(/assets/images/template/icon_tag_p.svg);
}

.page-container #page-main .article-main .article-tag li.icon-user::before {
  background-image: url(/assets/images/template/icon_user.svg);
}

.page-container #page-main .article-main .article-tag li.icon-flag::before {
  background-image: url(/assets/images/template/icon_flag.svg);
}

.page-container #page-main .article-main .article-tag li.icon-card::before {
  background-image: url(/assets/images/template/icon_card.svg);
}

.page-container #page-main .article-main .article-tag li.icon-author::before {
  background-image: url(/assets/images/template/icon_author.svg);
}

.page-container #page-main .article-main .article-wrap {
  /*margin-top: 10px;*/
  /*padding-top: 10px;*/
  /*border-top: 1px solid #C2C7F7;*/
  display: flex;
  align-items: flex-start;
}

.page-container #page-main .article-main .article-wrap .article-share {
  order: 2;
  position: sticky;
  width: 67px;
  border-radius: 0 0 50px 50px;
  background-color: #f7f7f7;
  padding-top: 11px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px 0;
  align-items: center;
  margin-left: 10px;
  top: 70px;
}

.page-container #page-main .article-main .article-wrap .article-share a {
  width: 35px;
  height: 35px;
  display: block;
}

.page-container #page-main .article-main .article-wrap .article-content {
  order: 1;
  flex: 1;
}

.page-container #page-main .article-main .article-wrap .article-content-top {
  padding: 15px 20px;
  margin-top: 40px;
}

.page-container #page-main .article-main .article-wrap .article-content-top .article-top-name {
  font-weight: bold;
  font-size: 1.25em;
  margin-bottom: 10px;
}

.page-container #page-main .article-main .article-wrap .article-content-top .article-top-block {
  margin: 12px 0;
}

.page-container #page-main .article-main .article-wrap .article-content-top .article-top-block .name {
  font-weight: bold;
  margin-bottom: 10px;
}

.page-container #page-main .article-main .article-wrap .article-content-top .article-tag {
  padding-left: 20px;
  padding-right: 20px;
}

.page-container #page-main .article-main .article-wrap .article-content-top+.article {
  padding-top: 16px;
}

.page-container #page-main .article-main .article-wrap .article-content-bottom {
  padding: 20px;
  background-color: #f7f7f7;
  display: flex;
}

.page-container #page-main .article-main .article-wrap .article-content-bottom .article-bottom-img {
  width: 210px;
  height: 170px;
  margin-right: 20px;
  display: block;
  position: relative;
  overflow: hidden;
}

.page-container #page-main .article-main .article-wrap .article-content-bottom .article-bottom-img img {
  width: auto;
  max-width: none;
  height: 170px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}

.page-container #page-main .article-main .article-wrap .article-content-bottom .article-bottom-text {
  flex: 1;
}

.page-container #page-main .article-main .article-wrap .article-content-bottom .article-bottom-name {
  font-size: 1.25em;
  color: #5d6bc0;
  margin-bottom: 8px;
  font-weight: bold;
}

.page-container #page-main .article-main .article-wrap .article-content-bottom p {
  margin: 0;
}

.page-container #page-main .article-main .article-wrap .template-block {
  margin-top: 10px;
  padding-top: 0px;
}

.page-container #page-main .article-main .article-wrap .template-block.line-top {
  border-top: 1px solid #5d6bc0;
}

.page-container #page-main .article-main .article-wrap .template-block .template-name {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.page-container #page-main .article-main .article-wrap .template-block .template-name.text-lg {
  font-size: 1.25em;
}

.page-container #page-main .article-main .article-wrap .template-block .template-name::before {
  width: 20px;
  height: 20px;
  content: "";
  display: inline-block;
  margin-right: 8px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
}

.page-container #page-main .article-main .article-wrap .template-block .template-name.icon-download::before {
  background-image: url(/assets/images/template/icon_download_p.svg);
}

.page-container #page-main .article-main .article-wrap .template-block .template-name.icon-article::before {
  background-image: url(/assets/images/template/icon_article_p.svg);
}

.page-container #page-main .article-main .article-wrap .template-block .template-name.icon-info::before {
  width: 23px;
  margin-top: 2px;
  background-image: url(/assets/images/template/icon_card.svg);
}

.page-container #page-main .article-main .article-wrap .template-block .download-list {
  border-top: 1px solid #5d6bc0;
  border-bottom: 1px solid #5d6bc0;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block {
  border-top: 2px solid #5d6bc0;
  border-bottom: 2px solid #5d6bc0;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row {
  align-items: flex-start;
  flex-wrap: wrap;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row+.input-row {
  padding-top: 0;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .name {
  padding: 0.4em 0;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-group.row {
  width: calc(100% - 75px);
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-item,
.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .radio-item {
  padding: 0.6em 0;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-item label,
.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .radio-item label {
  padding-left: 30px;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-item label+label,
.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .radio-item label+label {
  margin-top: 8px;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row input,
.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row select {
  width: 100%;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row input:disabled,
.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row select:disabled {
  background-color: #f1f1f1 !important;
  color: #757575 !important;
  border-color: #f1f1f1 !important;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>input,
.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>select,
.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>textarea,
.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.row,
.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.checkbox-group,
.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.radio-group {
  width: calc(100% - 253px);
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .name {
  width: 245px;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-sm {
  width: 90px;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-sm-auto {
  width: calc(100% - 236px);
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-md {
  width: 170px;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-lg {
  width: 310px;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .ps {
  font-size: 0.75em;
  margin: 0;
  padding-left: 140px;
  padding-top: 2px;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row .input-row {
  padding: 0;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row .input-row .name {
  width: 65px;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row .col-4 {
  width: calc((100% / 3) - 8px);
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .link {
  padding: 0.4em 0;
  display: inline-flex;
  align-items: center;
  color: #5d6bc0;
  text-decoration: underline;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .link i {
  margin-right: 5px;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .link i svg {
  fill: #5d6bc0;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block>.row {
  border-bottom: 1px solid #c2c7f7;
  background-color: #fff;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block>.row:nth-child(2n) {
  background-color: #f7f7f7;
}

.filter-block {
  background-color: #edeffa;
  border-radius: 100px 100px 10px 10px;
  padding: 13px 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0 12px;
  margin-bottom: 12px;
}

.filter-block .filter-item {
  flex: 1;
  display: flex;
  align-items: center;
}

.filter-block label {
  white-space: nowrap;
}

.filter-block label.label-text {
  padding: 0 8px;
}

.filter-block label[class*="icon-"]::before {
  width: 18px;
  height: 16px;
  content: "";
  display: inline-block;
  vertical-align: top;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  margin-right: 6px;
  margin-top: 5px;
}

.filter-block label.icon-keyword::before {
  background-image: url(/assets/images/template/icon_keyboard.svg);
}

.filter-block label.icon-category::before {
  width: 20px;
  background-image: url(/assets/images/template/icon_category.svg);
}

.filter-block input,
.filter-block select {
  flex: 1;
  width: 100%;
}

.filter-block input.datepicker {
  width: 123px;
}

.filter-block .btn {
  width: 120px;
  line-height: 38px;
  padding-top: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.filter-block .btn i {
  width: 14px;
  height: 14px;
  margin-right: 8px;
}

.filter-block .btn i img {
  vertical-align: top;
}

.filter-block .btn.btn-sm {
  width: 90px;
}

.filter-block.filter-collapse {
  display: block;
  border-radius: 30px 30px 0 0;
  padding: 0;
}

.filter-block.filter-collapse.active {
  display: block;
}

.filter-block.filter-collapse.active .btn-collapse::before {
  content: "關閉";
}

.filter-block.filter-collapse.active .btn-collapse::after {
  background-image: url(/assets/images/template/btn_collapse_close.svg);
}

.filter-block.filter-collapse.active .collapse-content {
  display: block;
}

.filter-block.filter-collapse .filter-name {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 24px 13px 12px;
}

.filter-block.filter-collapse .filter-name .name {
  font-size: 1.125em;
  color: #5d6bc0;
  padding: 0 5px;
}

.filter-block.filter-collapse .filter-name .name::before,
.filter-block.filter-collapse .filter-name .name::after {
  display: inline-block;
  vertical-align: middle;
  margin: -2px 10px 0;
  width: 1px;
  height: 18px;
  content: "";
  background-color: #5d6bc0;
}

.filter-block.filter-collapse .btn-collapse {
  display: flex;
  align-items: center;
  color: #5d6bc0;
}

.filter-block.filter-collapse .btn-collapse::before {
  content: "開啟";
}

.filter-block.filter-collapse .btn-collapse::after {
  content: "";
  width: 18px;
  height: 18px;
  display: block;
  background: url(/assets/images/template/btn_collapse_open.svg) no-repeat center center;
  background-size: contain;
  margin: 2px 0 0 5px;
}

.filter-block.filter-collapse .collapse-content {
  border-top: 2px solid #c2c7f7;
  border-bottom: 2px solid #c2c7f7;
  background-color: #fff;
  box-shadow: 6px 6px 0px 0px rgba(0, 0, 0, 0.06);
  display: none;
}

.filter-block.filter-collapse .collapse-content .row {
  padding: 16px 20px;
  gap: 0 12px;
  align-items: center;
  flex-wrap: nowrap;
}

.filter-block.filter-collapse .collapse-content .row .col {
  display: flex;
  gap: 0 6px;
  align-items: center;
}

.filter-block.filter-collapse .collapse-content .row .col-auto {
  flex: 1;
}

.filter-block.filter-collapse .collapse-content .row .col-auto-2 {
  flex: 2;
}

.filter-block.filter-collapse .collapse-content .select {
  width: 125px;
}

.filter-block.filter-collapse .collapse-content . btn-lg w-100 {
  margin-top: 0;
}

.popup {
  position: relative;
  max-width: 950px;
  width: 90%;
  border-radius: 10px;
  background-color: #fff;
  padding: 12px 20px;
  margin: 0 auto;
  font-size: 1em;
}

.popup .btn-popup-close {
  position: absolute;
  width: 50px;
  height: 50px;
  right: -25px;
  top: -25px;
  border: 1px solid #c2c7f7;
  background-color: #5d6bc0;
  border-radius: 100%;
}

.popup.popup-info {
  padding: 0;
}

.popup.popup-info .info-name {
  background-color: #5d6bc0;
  color: #fff;
  padding: 12px 20px;
  font-size: 1.25em;
  display: flex;
  align-items: center;
  border-radius: 10px 10px 0 0;
}

.popup.popup-info .info-name i {
  width: 23px;
  height: 23px;
  margin-right: 10px;
}

.popup.popup-info .info-name i svg {
  vertical-align: top;
  width: 23px;
  height: 23px;
}

.popup.popup-info .info-name i svg .st0 {
  fill: #fff;
}

.popup.popup-info .info-content {
  padding: 30px;
  max-height: 70vh;
  overflow-y: auto;
}

.popup.popup-info .info-content i {
  width: 14px;
  height: 14px;
  display: inline-block;
  vertical-align: top;
  margin-top: 0.5em;
}

.popup.popup-info .info-content i svg,
.popup.popup-info .info-content i img {
  vertical-align: top;
}

.popup.popup-info .info-content a {
  display: inline-block;
  padding: 2px 5px;
  text-decoration: underline;
  color: #5d6bc0;
}

.popup.popup-info .info-content hr {
  margin-top: 0;
  margin-bottom: 16px;
  border-top: 2px solid #c2c7f7;
}

.popup.popup-info .info-content p {
  margin-top: 0;
  margin-bottom: 16px;
}

.popup.popup-info .info-content .filter-block {
  padding-left: 30px;
  padding-right: 30px;
  font-size: 0.875em;
}

.popup.popup-info .info-content .filter-block select {
  padding: 0 38px 0 12px;
  width: 100px;
}

.popup.popup-info .info-content .filter-block input {
  padding: 2px 12px 0;
  width: 100px;
}

.tabs .tabs-block {
  display: none;
}

.tabs .tabs-block.active {
  display: block;
}

.tabs .tabs-block .filter-block {
  margin-top: 20px;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.row .col-6 {
  width: 50%;
}

.row .col-12 {
  width: 100%;
}

.row .col-3 {
  width: calc(100% / 4);
}

.btn-more {
  color: #d14600;
}

.btn-more::before {
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background: #d14600 url(/assets/images/template/icon_arrow_w.svg) no-repeat center center;
  background-size: auto 8px;
  margin-right: 5px;
  content: "";
  margin-top: 5px;
  display: inline-block;
  vertical-align: top;
}

#index-banner {
  position: relative;
  overflow: hidden;
}

#index-banner .swiper-arrow {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #c2c7f7;
  background-color: rgba(255, 255, 255, 0.45);
  top: 50%;
}

#index-banner .swiper-arrow svg {
  width: 50px;
  height: 50px;
}

#index-banner .swiper-arrow svg .st0 {
  fill: #c2c7f7;
}

#index-banner .swiper-arrow::after {
  display: none;
}

#index-banner .swiper-arrow.swiper-button-prev {
  transform: translateY(-50%) translateX(-656px);
  left: 50%;
}

#index-banner .swiper-arrow.swiper-button-next {
  right: 50%;
  transform: translateY(-50%) rotateY(180deg) translateX(-656px);
}

#index-banner .swiper-notification {
  display: none;
}

#index-banner .swiper-pagination-bullet {
  background-color: #c2c7f7;
  border: 1px solid #5d6bc0;
  width: 10px;
  height: 10px;
  opacity: 1;
  cursor: pointer;
}

#index-banner .swiper-pagination-bullet:focus {
  outline: 2px dashed #d14600 !important;
}

#index-banner .swiper-pagination-bullet-active {
  background-color: #5d6bc0;
  border-color: #c2c7f7;
}

#index-banner a {
  display: block;
  overflow: hidden;
  height: 379px;
}

#index-banner a img {
  width: auto;
}

#index-news {
  padding-top: 67px;
  position: relative;
}

#index-news .btn-anchor {
  display: block;
  position: absolute;
  left: -7px;
  top: 13px;
}

#index-news .index-news-top {
  margin-bottom: 40px;
  display: flex;
  align-items: flex-end;
}

#index-news .index-news-top .index-news-title {
  font-size: 40px;
  letter-spacing: 0.2em;
  font-weight: normal;
  position: relative;
  padding-left: 42px;
  line-height: 1;
  margin: 0 10px 0 0;
}

#index-news .index-news-top .index-news-title::before {
  content: attr(data-title);
  font-size: 73px;
  font-weight: 600;
  color: #f1f1f1;
  position: absolute;
  z-index: -1;
  left: 0;
  bottom: 0;
  letter-spacing: -0.025em;
}

#index-news .index-news-top .tabs-nav {
  border-bottom: 1px solid #f1f1f1;
  display: flex;
  padding: 0 30px;
  flex: 1;
}

#index-news .index-news-top .tabs-nav a {
  font-size: 1.125em;
  display: block;
  padding: 4px 16px;
  margin: 0 12px;
  position: relative;
  border-radius: 12px 12px 0 0;
  min-width: 100px;
  text-align: center;
}

#index-news .index-news-top .tabs-nav a::before {
  content: "";
  width: 1px;
  height: 20px;
  background-color: #313131;
  position: absolute;
  left: -12px;
  bottom: 5px;
}

#index-news .index-news-top .tabs-nav a:first-child {
  margin-left: 0;
}

#index-news .index-news-top .tabs-nav a:first-child::before {
  display: none;
}

#index-news .index-news-top .tabs-nav a.active {
  background-color: #d14600;
  color: #fff;
}

#index-news .index-news-top .swiper-control {
  display: flex;
}

#index-news .index-news-top .swiper-control .swiper-arrow {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  border: 1px solid #c2c7f7;
  margin-left: 15px;
}

#index-news .index-news-top .swiper-control .swiper-arrow .st0 {
  fill: #313131;
}

#index-news .index-news-top .swiper-control .swiper-arrow.swiper-next {
  transform: rotate(180deg);
}

#index-news .index-news-top .swiper-control .swiper-arrow.btn-disabled {
  pointer-events: none;
  opacity: 0.5;
  background-color: #f1f1f1;
}

#index-news .newsSwiper {
  position: relative;
  overflow: hidden;
  padding-bottom: 50px;
  padding-top: 2px;
}

#index-news .newsSwiper .swiper-slide {
  padding: 0 6px;
}

#index-news .news-card {
  padding: 24px 20px;
  border-radius: 10px;
  background-color: #f7f7f7;
  display: block;
  position: relative;
}

#index-news .news-card::after {
  content: "";
  border-style: solid;
  border-color: #f7f7f7 #f7f7f7 transparent transparent;
  border-width: 12px 9px;
  position: absolute;
  bottom: -19px;
  right: 45px;
  transition: border-color 0.3s;
}

#index-news .news-card .news-card-top {
  font-size: 0.75em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

#index-news .news-card .news-card-top .tag {
  padding: 4px 10px 4px 30px;
  position: relative;
  border-radius: 50px;
  background-color: #5d6bc0;
  color: #fff;
  max-width: 150px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

#index-news .news-card .news-card-top .tag::before {
  content: "";
  width: 15px;
  height: 15px;
  background: url(/assets/images/template/icon_user_checked.svg) no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 10px;
  top: 4px;
}

#index-news .news-card .news-card-top .date {
  padding: 4px 0 4px 16px;
  position: relative;
  color: #5d6bc0;
}

#index-news .news-card .news-card-top .date::before {
  content: "";
  width: 12px;
  height: 12px;
  background: url(/assets/images/template/icon_clock.svg) no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 0;
  top: 8px;
}

#index-news .news-card .news-card-text {
  font-size: 1.125em;
}

#index-news .news-card .news-card-text p {
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  line-height: 1.5em;
  height: 3em;
}

#index-quick {
  margin-bottom: 37px;
}

#index-quick .index-quick-top {
  position: relative;
  text-align: center;
  color: #5d6bc0;
  font-size: 1.875em;
  letter-spacing: 0.5em;
  padding: 68px 298px 22px 337px;
  margin: 0;
  font-weight: normal;
}

#index-quick .index-quick-top::before {
  content: "";
  width: 277px;
  height: 178px;
  position: absolute;
  background: url(/assets/images/index/pic_boy.svg) no-repeat center center;
  background-size: contain;
  top: 0;
  left: 37px;
}

#index-quick .index-quick-top::after {
  content: "";
  width: 238px;
  height: 184px;
  position: absolute;
  background: url(/assets/images/index/pic_flower.svg) no-repeat center center;
  background-size: contain;
  top: 0;
  right: 59px;
}

#index-quick .index-quick-content {
  background-color: #fffb9d;
  border-radius: 100px;
  margin: 0 -60px;
  padding: 20px 60px 0;
  position: relative;
  z-index: 5;
  display: flex;
  gap: 0 19px;
}

#index-quick .index-quick-content a {
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 22px 0 10px;
  flex: 1;
  background-color: #fff;
  border-radius: 100px 100px 0 0;
}

#index-quick .index-quick-content a .icon {
  width: 70px;
  margin: 0 auto;
}

#index-quick .index-quick-content a p {
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

#index-more {
  background: url(/assets/images/index/bg.png) repeat-x center bottom;
  background-size: 1440px auto;
  padding-bottom: 50px;
}

#index-more .index-more-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
  margin-bottom: 10px;
  padding: 0 26px;
}

#index-more .index-more-top .index-more-title {
  font-size: 1.875em;
  color: #5d6bc0;
  margin: 0;
  font-weight: normal;
  display: flex;
  align-items: center;
}

#index-more .index-more-top .index-more-title::after {
  content: "";
  width: 41px;
  height: 5px;
  background: url(/assets/images/index/arrow.svg) no-repeat left bottom;
  margin-left: 9px;
  margin-top: 20px;
  background-size: contain;
}

#index-more .index-more-content {
  position: relative;
  z-index: 2;
  border: 12px solid #c2c7f7;
  box-shadow: 4px 4px 0px 0px rgba(0, 0, 0, 0.15);
  border-radius: 16px 16px 0 0;
  background-color: #fff;
}

#index-video {
  position: relative;
  padding-top: 50px;
  padding-right: 37px;
}

#index-video::before {
  width: 390px;
  height: 390px;
  content: "";
  position: absolute;
  top: 0;
  left: -79px;
  background: url(/assets/images/index/bg_round.svg) no-repeat center center;
  background-size: contain;
  z-index: 0;
}

#index-video .index-more-top .index-more-title::before {
  content: "";
  width: 32px;
  height: 32px;
  background: url(/assets/images/index/icon_video.svg) no-repeat center center;
  background-size: contain;
  margin-right: 9px;
  margin-top: 2px;
}

#index-video .video {
  padding-top: 56%;
  position: relative;
}

#index-video .video iframe {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

#index-resource {
  position: relative;
  padding: 67px 0 0 46px;
}

#index-resource::before {
  width: 163px;
  height: 168px;
  content: "";
  position: absolute;
  top: 30px;
  left: 37px;
  background: url(/assets/images/index/pic_elephant.svg) no-repeat center center;
  background-size: contain;
  z-index: 0;
}

#index-resource .index-more-top {
  padding-left: 180px;
  padding-right: 0;
}

#index-resource .fullSwiper {
  overflow: hidden;
}

#index-resource .fullSwiper .swiper-slide {
  height: 276px;
  overflow: hidden;
  background-color: #fff;
}

#index-resource .swiper-arrow {
  width: 50px;
  height: 50px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #fff;
  background: linear-gradient(180deg, #5d6bc0 3.53%, #2f386f 100%);
  top: 50%;
  position: absolute;
  z-index: 5;
  box-shadow: 4px 4px 0px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

#index-resource .swiper-arrow svg {
  width: 50px;
  height: 50px;
}

#index-resource .swiper-arrow svg .st0 {
  fill: #fff;
}

#index-resource .swiper-arrow.swiper-prev {
  transform: translateY(-50%);
  left: -37px;
}

#index-resource .swiper-arrow.swiper-next {
  right: -37px;
  transform: translateY(-50%) rotateY(180deg);
}

#index-social {
  display: flex;
  align-items: center;
}

#index-social .index-social-top {
  padding: 22px;
  background-color: #fff;
  border-radius: 0 0 60px 60px;
  display: flex;
  border-width: 0 1px 1px;
  border-style: solid;
  border-color: #c2c7f7;
  box-shadow: 4px 4px 0px 0px rgba(93, 107, 192, 0.15);
  margin-right: 21px;
  width: 290px;
  justify-content: center;
  align-items: center;
}

#index-social .index-social-top .icon {
  width: 70px;
  height: 70px;
  margin-right: 6px;
}

#index-social .index-social-top .text .name {
  font-size: 1.25em;
  color: #365899;
}

#index-social .index-social-top .text p {
  margin: 0;
  letter-spacing: 0.2em;
}

#index-social .index-social-top .text p i {
  display: inline-block;
  width: 20px;
  margin-right: 8px;
  vertical-align: top;
  margin-top: -2px;
}

#index-social .index-social-content {
  width: calc(100% - 290px);
  padding: 10px 46px;
  position: relative;
}

#index-social .index-social-content .swiper-arrow {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #c2c7f7;
  top: 50%;
  position: absolute;
  z-index: 5;
  cursor: pointer;
}

#index-social .index-social-content .swiper-arrow svg {
  width: 30px;
  height: 30px;
}

#index-social .index-social-content .swiper-arrow svg .st0 {
  fill: #5d6bc0;
}

#index-social .index-social-content .swiper-arrow.swiper-prev {
  transform: translateY(-50%);
  left: 0;
}

#index-social .index-social-content .swiper-arrow.swiper-next {
  right: 0;
  transform: translateY(-50%) rotateY(180deg);
}

#index-social .index-social-content .socialSwiper {
  overflow: hidden;
}

#index-social .index-social-content .socialSwiper .swiper-slide {
  padding: 5px 8px;
}

#index-social .index-social-content .socialSwiper .swiper-slide a {
  display: block;
  overflow: hidden;
  border: 1px solid #f7f7f7;
  box-shadow: 4px 4px 0px 0px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
}

.popup-album .album-info {
  margin-bottom: 16px;
}

.popup-album .album-info .info-item {
  display: inline-flex;
  vertical-align: top;
  border: 1px solid #c2c7f7;
  font-size: 0.75em;
  border-radius: 50px;
  padding: 7px 12px;
  margin-right: 6px;
}

.popup-album .album-info .info-item.active {
  background-color: #edeffa;
}

.popup-album .album-info .info-item i {
  width: 15px;
  height: 16px;
  margin-right: 6px;
}

.popup-album .album-info .info-item i img {
  width: 100%;
  height: auto;
}

.popup-album .album-content {
  font-size: 1.25em;
}

.popup-album .album-content p {
  margin: 0;
}

.popup-album .album-content .album {
  margin-top: 16px;
  border-radius: 4px;
  text-align: center;
}

.popup-album .album-content .album img {
  width: auto;
  max-height: 60vh;
}

.popup-album .album-content .album.video {
  padding-top: 56%;
  position: relative;
  border-radius: 0;
}

.popup-album .album-content .album.video iframe {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}

body {
  font-size: 1rem;
}

body[data-size="sm"] #app {
  font-size: 0.875em;
}

body[data-size="sm"] .btn-more::before {
  margin-top: 3px;
}

body[data-size="sm"] .popup {
  font-size: 0.875em;
}

body[data-size="sm"] .page-container #page-main .page-content .news-list .news-item .news-text .news-bottom .btn-more::before {
  margin-top: 2px;
}

body[data-size="sm"] .page-container #page-main .page-content table i {
  margin-top: 2px;
}

body[data-size="sm"] .page-container #page-main .page-content table .download-list li a .name::before {
  top: 1px;
}

body[data-size="sm"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .name {
  padding: 0.6em 0;
}

body[data-size="sm"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-item,
body[data-size="sm"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .radio-item {
  padding: 0.65em 0;
}

body[data-size="sm"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .link {
  padding: 0.6em 0;
}

body[data-size="sm"] .filter-block label::before {
  margin-top: 2px;
}

body[data-size="md"] #app {
  font-size: 1em;
}

body[data-size="md"] .popup {
  font-size: 1em;
}

body[data-size="lg"] #app {
  font-size: 1.125em;
}

body[data-size="lg"] #footer .footer-top {
  gap: 0 12px;
}

body[data-size="lg"] #footer .footer-top .footer-info .footer-menu li a {
  padding: 1px 6px;
}

body[data-size="lg"] #footer .footer-bottom {
  padding: 20px 85px;
}

body[data-size="lg"] .btn-more::before {
  margin-top: 6px;
}

body[data-size="lg"] .popup {
  font-size: 1.125em;
}

body[data-size="lg"] .page-container #page-main .page-content .news-list .news-item .news-text .news-bottom .btn-more::before {
  margin-top: 4px;
}

body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num {
  gap: 0 6px;
}

body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a,
body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li span {
  line-height: 38px;
  min-width: 40px;
}

body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow {
  padding: 0 10px;
}

body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-prev {
  border-radius: 40px 4px 4px 40px;
}

body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-prev::before {
  margin-top: 15px;
}

body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-next {
  border-radius: 4px 40px 40px 4px;
}

body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-next::after {
  margin-top: 15px;
}

body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page::before {
  margin: 0 5px 0 11px;
}

body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page label,
body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page span {
  margin: 0;
}

body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page input {
  line-height: 35px;
}

body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page .btn {
  line-height: 37px;
}

body[data-size="lg"] .page-container #page-main .page-content .tabs .tabs-nav a {
  min-width: 90px;
  padding: 12px 10px;
}

body[data-size="lg"] .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .name {
  width: 115px;
}

body[data-size="lg"] .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row {
  padding-left: 127px;
}

body[data-size="lg"] .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row.code-row input {
  width: 200px;
}

body[data-size="lg"] .page-container #page-main .page-content .keyboard-list li .keyboard-group-lg+.keyboard-text {
  width: calc(100% - 260px);
}

body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .name {
  padding: 0.25em 0;
}

body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-group.row {
  width: calc(100% - 85px);
}

body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-item,
body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .radio-item {
  padding: 0.5em 0;
}

body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>input,
body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>select,
body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>textarea,
body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.row,
body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.checkbox-group,
body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.radio-group {
  width: calc(100% - 158px);
}

body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .name {
  width: 150px;
}

body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-sm {
  width: 100px;
}

body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-sm-auto {
  width: calc(100% - 266px);
}

body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-md {
  width: 170px;
}

body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-lg {
  width: 310px;
}

body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .ps {
  padding-left: 160px;
}

body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row .input-row .name {
  width: 75px;
}

body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .link {
  padding: 0.25em 0;
}

body[data-size="lg"] #index-news .news-card .news-card-top .tag::before {
  top: 7px;
}

body[data-size="lg"] #index-quick .index-quick-top {
  letter-spacing: 0.4em;
}

body[data-size="lg"] #index-social .index-social-top {
  width: 320px;
  padding: 20px 20px 24px;
}

body[data-size="lg"] #index-social .index-social-content {
  width: calc(100% - 320px);
  padding: 10px 40px;
}

#app {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 114px;
  font-size: 1em;
}

#app.page {
  padding-top: 93px;
}

.ui-widget-header {
  background: #5d6bc0;
  color: #fff;
}

.ui-datepicker .ui-datepicker-header {
  padding-bottom: 0;
}

.ui-datepicker .ui-datepicker-prev span {
  background: #fff url(/assets/images/template/icon_arrow_p.svg) no-repeat center center;
  background-size: 10px 10px;
  border-radius: 100%;
  transform: rotate(180deg);
  cursor: pointer;
}

.ui-datepicker .ui-datepicker-next span {
  background: #fff url(/assets/images/template/icon_arrow_p.svg) no-repeat center center;
  background-size: 10px 10px;
  border-radius: 100%;
  cursor: pointer;
}

.ui-widget-header .ui-state-hover,
.ui-widget-header .ui-state-focus {
  border: none;
  background: none;
}

.ui-widget-content .ui-state-hover,
.ui-widget-content .ui-state-focus,
.ui-button:hover,
.ui-button:focus {
  color: #5d6bc0;
}

.ui-datepicker .ui-datepicker-prev-hover,
.ui-datepicker .ui-datepicker-next-hover {
  top: 2px;
}

.ui-datepicker .ui-datepicker-next-hover {
  right: 2px;
}

.ui-datepicker .ui-datepicker-prev-hover {
  left: 2px;
}

.ui-datepicker .ui-datepicker-prev-hover span,
.ui-datepicker .ui-datepicker-next-hover span {
  background-color: #edeffa;
}

.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default,
.ui-button,
html .ui-button.ui-state-disabled:hover,
html .ui-button.ui-state-disabled:active {
  border-color: transparent;
  background: none;
  text-align: center;
  text-align: center;
  width: 25px;
  height: 25px;
  border-radius: 100%;
  line-height: 24px;
  margin: 0 auto;
  padding: 0;
}

.ui-state-highlight,
.ui-widget-content .ui-state-highlight,
.ui-widget-header .ui-state-highlight {
  border: 1px solid #5d6bc0;
  background: #edeffa;
  color: #5d6bc0;
}

.ui-state-active,
.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active,
a.ui-button:active,
.ui-button:active,
.ui-button.ui-state-active:hover {
  background: #5d6bc0;
  color: #fff;
}

@media screen and (max-width: 1440px) {
  #header .logo {
    width: 325px;
  }

  #header.page-header .logo {
    width: 239px;
  }

  #header.page-header .logo::after {
    width: 93px;
    height: 68px;
    right: -120px;
    bottom: -12px;
  }

  #menu ul li a {
    padding: 17px 15px;
    font-size: 1em;
  }

  #menu .search-block .wrap .btn {
    font-size: 1em;
  }

  #menu .search-block .wrap .btn i {
    width: 20px;
  }

  #footer {
    margin-top: 50px;
  }

  #footer .footer-top {
    gap: 0 10px;
  }

  #footer .footer-top .footer-logo {
    width: 224px;
  }

  #footer .footer-top .footer-info {
    font-size: 0.875em;
  }

  #footer .footer-top .footer-info .footer-menu li::before {
    height: 15px;
  }

  #footer .footer-top .footer-logo-group a:first-child {
    width: 36px;
  }

  #footer .footer-top .footer-logo-group a:nth-child(2) {
    width: 81px;
  }

  #footer .footer-bottom {
    font-size: 0.75em;
    padding: 20px 80px;
  }

  #footer .footer-bottom li::before {
    height: 12px;
  }

  .page-container #page-main .page-content {
    padding-bottom: 120px;
  }

  .page-container #page-main .page-content .news-list .news-item.news-img-left .news-text,
  .page-container #page-main .page-content .news-list .news-item.news-img-top .news-text {
    padding: 16px 20px 14px 257px;
  }

  .page-container #page-main .page-content .news-list .news-item .news-img {
    left: 20px;
  }

  .page-container #page-main .page-content .news-list .news-item .news-text {
    padding: 16px 20px 14px;
  }

  #index-banner .swiper-arrow.swiper-button-prev {
    transform: translateY(-50%);
    left: 24px;
  }

  #index-banner .swiper-arrow.swiper-button-next {
    right: 24px;
    transform: translateY(-50%) rotateY(180deg);
  }

  #index-banner a {
    height: calc(100vw / 1024 * 270);
  }

  #index-news .btn-anchor {
    left: 15px;
    top: 13px;
  }

  #index-news .index-news-top .tabs-nav {
    padding: 0 20px;
  }

  #index-news .index-news-top .tabs-nav a {
    padding: 4px 14px;
    margin: 0 10px;
  }

  #index-news .news-card .news-card-top {
    margin-bottom: 15px;
  }

  #index-news .news-card .news-card-top .tag {
    max-width: 110px;
  }

  #index-quick .index-quick-top {
    padding: 53px 220px 20px 255px;
  }

  #index-quick .index-quick-top::before {
    width: 210px;
    height: 135px;
  }

  #index-quick .index-quick-top::after {
    width: 180px;
    height: 138px;
    right: 37px;
  }

  #index-quick .index-quick-content {
    margin: 0;
    padding: 20px 40px 0;
    gap: 0 10px;
  }

  #index-quick .index-quick-content a {
    font-size: 0.875em;
  }

  #index-more {
    padding-bottom: 30px;
  }

  #index-video {
    padding-right: 15px;
  }

  #index-resource {
    padding: 70px 20px 0 35px;
  }

  #index-resource .fullSwiper .swiper-slide {
    height: 285px;
  }

  #index-social {
    display: flex;
  }

  #index-social .index-social-top {
    padding: 22px;
    background-color: #fff;
    border-radius: 0 0 60px 60px;
    display: flex;
    border-width: 0 1px 1px;
    border-style: solid;
    border-color: #c2c7f7;
    box-shadow: 4px 4px 0px 0px rgba(93, 107, 192, 0.15);
    margin-right: 21px;
    width: 290px;
    align-items: center;
  }

  #index-social .index-social-top .icon {
    width: 70px;
    height: 70px;
    margin-right: 6px;
  }

  #index-social .index-social-top .text .name {
    font-size: 1.25em;
    color: #365899;
  }

  #index-social .index-social-top .text p {
    margin: 0;
    letter-spacing: 0.2em;
  }

  #index-social .index-social-top .text p i {
    display: inline-block;
    width: 20px;
    margin-right: 8px;
    vertical-align: top;
    margin-top: -2px;
  }

  #index-social .index-social-content {
    width: calc(100% - 290px);
    padding: 10px 46px;
    position: relative;
  }

  #index-social .index-social-content .swiper-arrow {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #c2c7f7;
    top: 50%;
    position: absolute;
    z-index: 5;
    cursor: pointer;
  }

  #index-social .index-social-content .swiper-arrow svg {
    width: 30px;
    height: 30px;
  }

  #index-social .index-social-content .swiper-arrow svg .st0 {
    fill: #5d6bc0;
  }

  #index-social .index-social-content .swiper-arrow.swiper-prev {
    transform: translateY(-50%);
    left: 0;
  }

  #index-social .index-social-content .swiper-arrow.swiper-next {
    right: 0;
    transform: translateY(-50%) rotateY(180deg);
  }

  #index-social .index-social-content .socialSwiper {
    overflow: hidden;
  }

  #index-social .index-social-content .socialSwiper .swiper-slide {
    padding: 5px 8px;
  }

  #index-social .index-social-content .socialSwiper .swiper-slide a {
    display: block;
    overflow: hidden;
    border: 1px solid #f7f7f7;
    box-shadow: 4px 4px 0px 0px rgba(0, 0, 0, 0.15);
    border-radius: 5px;
  }

  body[data-size="lg"] #menu>ul>li:not(.btn-search)>a {
    padding: 17px 10px;
  }

  body[data-size="lg"] #footer .footer-top {
    gap: 0 8px;
  }

  body[data-size="lg"] #footer .footer-top .footer-info .footer-menu li a {
    padding: 1px 5px;
  }

  body[data-size="lg"] #index-news .index-news-top .tabs-nav {
    padding: 0 15px;
  }

  body[data-size="lg"] #index-news .index-news-top .tabs-nav a {
    padding: 4px 12px;
    margin: 0 8px;
  }

  body[data-size="lg"] #index-quick .index-quick-top {
    letter-spacing: 0.3em;
  }

  body[data-size="lg"] #index-quick .index-quick-content {
    padding: 20px 30px 0;
  }

  body[data-size="lg"] #index-video .index-more-top .index-more-title::before {
    margin-top: 5px;
  }

  body[data-size="lg"] #index-resource::before {
    left: 25px;
  }

  body[data-size="lg"] #index-resource .index-more-top {
    padding-left: 155px;
  }

  #app {
    padding-top: 91px;
  }

  #app.page {
    padding-top: 77.5px;
  }
}

@media screen and (max-width: 1200px) {
  #container {
    background-size: 1200px auto;
  }

  .page-container #page-main .page-content {
    padding-bottom: 60px;
  }

  .page-container #page-main .page-content .pagination {
    flex-direction: column;
  }

  .page-container #page-main .page-content .pagination .pagination-num {
    margin-bottom: 23px;
  }

  .page-container #page-main .page-content .pagination .pagination-page::before {
    display: none;
  }

  .page-container #page-main .page-content .books-list .book-item {
    padding-left: 90px;
  }

  .page-container #page-main .page-content .tabs .tabs-nav a {
    min-width: 90px;
    padding: 12px 10px;
  }

  .page-container #page-main .page-content table.table-text-sm .btn {
    padding: 8px 6px;
  }

  .filter-block.filter-collapse .collapse-content .row {
    gap: 12px;
    flex-wrap: wrap;
  }

  .filter-block.filter-collapse .collapse-content .row+.row {
    padding-top: 0;
  }

  #index-resource .fullSwiper .swiper-slide {
    height: calc(100vw / 1200 * 275);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num {
    gap: 0 10px;
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num a.page-arrow {
    padding: 0 20px;
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page label,
  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page span {
    margin: 0 4px;
  }
}

@media screen and (max-width: 1023px) {
  .t-hide {
    display: none;
  }

  .t-block {
    display: block;
  }

  .t-inline {
    display: inline;
  }

  .wrap {
    padding: 0 calc(100vw / 768 * 25);
  }

  .btn-side {
    width: calc(100vw / 768 * 50);
    height: calc(100vw / 768 * 50);
    right: calc(100vw / 768 * 20);
    box-shadow: 0 calc(100vw / 768 * 1) calc(100vw / 768 * 12) 0 rgba(0, 0, 0, 0.4);
  }

  .btn-side.btn-top {
    bottom: 10%;
  }

  .btn-side.btn-back {
    bottom: calc(10% + (100vw / 768 * 62));
  }

  #header {
    padding: calc(100vw / 768 * 15) 0 calc(100vw / 768 * 12);
    border-top: calc(100vw / 768 * 3) solid #5d6bc0;
    z-index: 99;
  }

  #header .wrap {
    padding: 0 calc(100vw / 768 * 20);
  }

  #header .logo {
    width: calc(100vw / 768 * 266);
  }

  #header .btn-ham {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    width: calc(100vw / 768 * 50);
    height: calc(100vw / 768 * 50);
    background: #5d6bc0 url(/assets/images/template/btn_ham.svg) no-repeat center center;
    background-size: contain;
    font-size: 0;
  }

  #header .btn-ham.active {
    background-image: url(/assets/images/template/btn_close.svg);
  }

  #header #tools-menu {
    display: flex;
    position: fixed;
    left: 105%;
    bottom: 0;
    width: 100%;
    background-color: #5d6bc0;
    color: #fff;
    flex-wrap: wrap;
    justify-content: center;
    padding: calc(100vw / 768 * 20) calc(100vw / 768 * 20) calc(100vw / 768 * 30);
    font-size: 1.5em;
    transition: left 0.3s;
  }

  #header #tools-menu.active {
    left: 0;
  }

  #header #tools-menu::before {
    content: "";
    height: calc(100vw / 768 * 2);
    width: calc(100% - (100vw / 768 * 60));
    top: 0;
    left: calc(100vw / 768 * 30);
    position: absolute;
    background-color: #fff;
  }

  #header #tools-menu li {
    margin-right: 0;
  }

  #header #tools-menu li::before {
    height: calc(100vw / 768 * 18);
    width: calc(100vw / 768 * 1.5);
    background-color: #fff;
    left: 0;
  }

  #header #tools-menu li:nth-child(4) {
    order: 1;
  }

  #header #tools-menu li:nth-child(4)::before {
    display: none;
  }

  #header #tools-menu li:nth-child(3) {
    order: 2;
  }

  #header #tools-menu li:nth-child(5) {
    order: 3;
  }

  #header #tools-menu li:nth-child(6) {
    order: 4;
  }

  #header #tools-menu li a {
    padding: calc(100vw / 768 * 3) calc(100vw / 768 * 24);
  }

  #header #tools-menu li a.sub-arrow::after {
    margin-left: calc(100vw / 768 * 6);
    border-color: #fff transparent transparent transparent;
    border-width: calc(100vw / 768 * 9) calc(100vw / 768 * 6);
    margin-top: calc(100vw / 768 * 9);
  }

  #header #tools-menu li a i {
    width: calc(100vw / 768 * 30);
    height: calc(100vw / 768 * 25);
    margin-right: calc(100vw / 768 * 10);
  }

  #header #tools-menu li a i svg {
    width: calc(100vw / 768 * 30);
    height: calc(100vw / 768 * 25);
    fill: #fff;
  }

  #header #tools-menu li .sub {
    top: auto;
    bottom: 100%;
    background-color: #edeffa;
  }

  #header #tools-menu li .sub a {
    padding: calc(100vw / 768 * 9) calc(100vw / 768 * 40) calc(100vw / 768 * 9) calc(100vw / 768 * 15);
    color: #313131;
  }

  #header #tools-menu li.setting {
    width: 100%;
    padding-left: 0;
    margin-top: calc(100vw / 768 * 30);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #header #tools-menu li.setting::before {
    display: none;
  }

  #header #tools-menu li.setting .setting-name {
    margin-right: calc(100vw / 768 * 21);
    display: flex;
  }

  #header #tools-menu li.setting .setting-name i {
    margin-right: calc(100vw / 768 * 10);
  }

  #header #tools-menu li.setting .setting-name i img {
    width: calc(100vw / 768 * 25);
  }

  #header #tools-menu li.setting a {
    width: calc(100vw / 768 * 60);
    height: calc(100vw / 768 * 60);
    line-height: calc(100vw / 768 * 57);
    border: calc(100vw / 768 * 1.5) solid #fff;
    font-size: 1.125em;
    margin-left: calc(100vw / 768 * 15);
  }

  #header #tools-menu li.setting a.active {
    background-color: #edeffa;
    color: #313131;
    border-color: #c2c7f7;
  }

  #header #tools-menu>li:first-child,
  #header #tools-menu>li:nth-child(2) {
    display: none;
  }

  #header.page-header .logo {
    width: calc(100vw / 768 * 266);
  }

  #header.page-header .logo::after {
    display: none;
  }

  #menu {
    background-color: #5d6bc0;
    position: fixed;
    z-index: 98;
    top: 0;
    left: 105%;
    display: flex;
    flex-direction: column;
    padding-top: calc(100vw / 768 * 80);
    padding-bottom: calc(100vw / 768 * 210);
    width: 100%;
    height: 100%;
    font-size: 1.5em;
    overflow-y: auto;
    transition: left 0.3s;
  }

  #menu.active {
    left: 0;
  }

  #menu ul {
    order: 2;
    display: block;
  }

  #menu ul li {
    display: block;
  }

  #menu ul li.btn-search {
    display: none;
  }

  #menu ul li a {
    padding: calc(100vw / 768 * 24) calc(100vw / 768 * 75) calc(100vw / 768 * 24) calc(100vw / 768 * 30);
    text-align: left;
    font-size: 1em;
  }

  #menu ul li .sub {
    position: static;
    width: 100%;
  }

  #menu ul li .sub>li {
    border-bottom-width: calc(100vw / 768 * 1);
  }

  #menu ul li .sub>li>a::before {
    width: calc(100vw / 768 * 14);
    height: calc(100vw / 768 * 20);
    left: calc(100vw / 768 * 34);
    top: calc(100vw / 768 * 32);
  }

  #menu ul li .sub>li>a.sub-arrow::after {
    width: calc(100vw / 768 * 38);
    height: calc(100vw / 768 * 38);
    right: calc(100vw / 768 * 24);
    top: calc(100vw / 768 * 22);
  }

  #menu ul li .sub a {
    padding: calc(100vw / 768 * 24) calc(100vw / 768 * 75) calc(100vw / 768 * 24) calc(100vw / 768 * 60);
  }

  #menu ul li .sub .sub li {
    border-top-width: calc(100vw / 768 * 1);
  }

  #menu ul li .sub .sub li a {
    padding-right: calc(100vw / 768 * 75);
  }

  #menu .search-block {
    order: 1;
    padding: calc(100vw / 768 * 20);
    display: block;
  }

  #menu .search-block .wrap {
    padding: 0;
  }

  #menu .search-block .wrap #S {
    line-height: calc(100vw / 768 * 50);
  }

  #menu .search-block .wrap input {
    border-top-left-radius: calc(100vw / 768 * 50);
    border-bottom-left-radius: calc(100vw / 768 * 50);
    border-width: calc(100vw / 768 * 1);
    width: calc(100% - (100vw / 768 * 130));
    height: calc(100vw / 768 * 60);
    padding: 0 calc(100vw / 768 * 30);
    margin-left: calc(100vw / 768 * 5);
  }

  #menu .search-block .wrap .btn {
    background-color: #5d6bc0;
    color: #fff;
    border-top-right-radius: calc(100vw / 768 * 50);
    border-bottom-right-radius: calc(100vw / 768 * 50);
    border-width: calc(100vw / 768 * 1);
    width: calc(100vw / 768 * 130);
    padding: 0;
    font-size: 1em;
  }

  #menu .search-block .wrap .btn i {
    width: calc(100vw / 768 * 30);
    margin-right: calc(100vw / 768 * 4);
  }

  #menu .search-block .wrap .btn i img {
    width: calc(100vw / 768 * 30);
  }

  #menu>ul>li {
    border-bottom: calc(100vw / 768 * 1) dashed #edeffa;
  }

  #menu>ul>li>a.sub-arrow::after {
    width: calc(100vw / 768 * 38);
    height: calc(100vw / 768 * 38);
    right: calc(100vw / 768 * 24);
    top: calc(100vw / 768 * 22);
    background: url(/assets/images/template/menu_open.svg) no-repeat center center;
    background-size: contain;
    content: "";
    position: absolute;
  }

  #menu>ul>li>a.sub-arrow.open::after {
    background-image: url(/assets/images/template/menu_close.svg);
  }

  #menu>ul>li>.sub {
    max-height: none;
  }

  #footer {
    padding-top: calc(100vw / 768 * 20);
    margin-top: calc(100vw / 768 * 40);
    background: linear-gradient(180deg, #f7f7f7 0%, #c2c7f7 100%);
  }

  #footer .wrap {
    padding: 0 calc(100vw / 768 * 24);
  }

  #footer a {
    padding: 0 calc(100vw / 768 * 3);
  }

  #footer .footer-top {
    justify-content: initial;
    flex-wrap: wrap;
    gap: calc(100vw / 768 * 20) calc(100vw / 768 * 4);
    padding-bottom: calc(100vw / 768 * 12);
  }

  #footer .footer-top .footer-logo {
    width: calc(100vw / 768 * 262);
  }

  #footer .footer-top .footer-info {
    width: 100%;
  }

  #footer .footer-top .footer-info .footer-menu li {
    margin-right: 0;
  }

  #footer .footer-top .footer-info .footer-menu li::before {
    height: calc(100vw / 768 * 18);
    width: calc(100vw / 768 * 1);
    left: 0;
  }

  #footer .footer-top .footer-info .footer-menu li a {
    padding: calc(100vw / 768 * 1) calc(100vw / 768 * 8);
  }

  #footer .footer-top .footer-info p {
    margin: calc(100vw / 768 * 5) calc(100vw / 768 * 8) 0;
  }

  #footer .footer-top .footer-logo-group {
    width: 100%;
    gap: 0 calc(100vw / 768 * 8);
  }

  #footer .footer-top .footer-logo-group a:first-child {
    width: calc(100vw / 768 * 43);
  }

  #footer .footer-top .footer-logo-group a:nth-child(2) {
    width: calc(100vw / 768 * 99);
  }

  #footer .footer-bottom {
    border-top-width: calc(100vw / 768 * 1);
    padding: calc(100vw / 768 * 20) calc(100vw / 768 * 8);
    font-size: 0.75em;
    text-align: left;
  }

  #footer .footer-bottom li {
    padding-left: calc(100vw / 768 * 8);
    padding-right: calc(100vw / 768 * 5);
    margin-bottom: 0;
    margin-right: 0;
    display: inline;
  }

  #footer .footer-bottom li::before {
    height: calc(100vw / 768 * 12);
    width: calc(100vw / 768 * 1);
    left: 0;
    top: calc(100vw / 768 * 10);
  }

  #footer .footer-bottom li:first-child {
    padding-left: 0;
  }

  #footer .footer-bottom li:nth-child(2)::after {
    content: "";
    display: block;
    width: 100%;
    height: 0;
    margin-bottom: calc(100vw / 768 * 10);
  }

  #footer .footer-bottom li p+p {
    margin-left: calc(100vw / 768 * 12);
  }

  #container {
    background: none;
  }

  input,
  select {
    border-width: calc(100vw / 768 * 1);
    padding: calc(100vw / 768 * 2) calc(100vw / 768 * 12) 0;
    border-radius: calc(100vw / 768 * 4);
    height: calc(100vw / 768 * 40);
    line-height: calc(100vw / 768 * 40);
  }

  input.datepicker {
    padding: 0 calc(100vw / 768 * 38) 0 calc(100vw / 768 * 12);
    background-position: calc(100% - (100vw / 768 * 10)) center;
    background-size: calc(100vw / 768 * 21) auto;
  }

  select {
    padding: 0 calc(100vw / 768 * 30) 0 calc(100vw / 768 * 12);
    background-position: calc(100% - (100vw / 768 * 10)) center;
    background-size: calc(100vw / 768 * 14) auto;
  }

  textarea {
    height: calc(100vw / 768 * 80);
  }

  .checkbox-item>input+label,
  .radio-item>input+label {
    padding-left: calc(100vw / 768 * 30);
    line-height: calc(100vw / 768 * 20);
  }

  .checkbox-item>input+label::before,
  .radio-item>input+label::before {
    width: calc(100vw / 768 * 20);
    height: calc(100vw / 768 * 20);
  }

  .checkbox-group.group-inline,
  .radio-group.group-inline {
    gap: calc(100vw / 768 * 8);
  }

  .checkbox-group .checkbox-group,
  .checkbox-group .radio-group,
  .radio-group .checkbox-group,
  .radio-group .radio-group {
    padding-left: calc(100vw / 768 * 30);
  }

  .radio-list {
    border-width: calc(100vw / 768 * 1);
  }

  .radio-list .radio-item {
    border-width: calc(100vw / 768 * 1);
  }

  .radio-list .radio-item input+label {
    gap: calc(100vw / 768 * 10);
    padding: calc(100vw / 768 * 12) calc(100vw / 768 * 10) calc(100vw / 768 * 12) calc(100vw / 768 * 40);
  }

  .radio-list .radio-item input+label::before {
    left: calc(100vw / 768 * 10);
    top: calc(100vw / 768 * 12);
  }

  .btn {
    border-radius: calc(100vw / 768 * 50);
    padding: 0 calc(100vw / 768 * 12);
  }

  .btn.btn-lg {
    width: calc(100vw / 768 * 200);
    margin: 0 calc(100vw / 768 * 6);
    border-width: calc(100vw / 768 * 1);
    padding: calc(100vw / 768 * 10);
  }

  .btn.btn-lg i {
    width: calc(100vw / 768 * 16);
    height: calc(100vw / 768 * 16);
    margin-right: calc(100vw / 768 * 5);
  }

  .page-container {
    padding-top: calc(100vw / 768 * 20);
    background: url(/assets/images/template/bg_dot_t.png) no-repeat right top;
    background-size: calc(100vw / 768 * 453) auto;
  }

  .page-container #page-main {
    width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  .page-container #page-main .breadcrumbs {
    margin-bottom: calc(100vw / 768 * 30);
  }

  .page-container #page-main .breadcrumbs li a {
    padding: calc(100vw / 768 * 2) calc(100vw / 768 * 4);
    border-radius: calc(100vw / 768 * 4);
    max-width: calc(100vw / 768 * 200);
  }

  .page-container #page-main .breadcrumbs li::before {
    width: calc(100vw / 768 * 6);
    height: calc(100vw / 768 * 10);
    margin: 0 calc(100vw / 768 * 5);
  }

  .page-container #page-main .breadcrumbs li:last-child {
    padding: calc(100vw / 768 * 2) 0;
  }

  .page-container #page-main .breadcrumbs li i {
    margin-top: calc(100vw / 768 * 1);
    width: calc(100vw / 768 * 14);
    height: calc(100vw / 768 * 14);
  }

  .page-container #page-main .breadcrumbs li i svg {
    width: calc(100vw / 768 * 14);
    height: calc(100vw / 768 * 14);
  }

  .page-container #page-main .page-content {
    padding-bottom: 0;
  }

  .page-container #page-main .page-content .page-title {
    font-size: 1.5em;
    padding-left: calc(100vw / 768 * 55);
    margin-bottom: calc(100vw / 768 * 16);
  }

  .page-container #page-main .page-content .page-title::before {
    width: calc(100vw / 768 * 35);
    height: calc(100vw / 768 * 35);
    left: calc(100vw / 768 * 12);
    top: calc(100vw / 768 * 2);
  }

  .page-container #page-main .page-content .page-title .btn {
    padding: calc(100vw / 768 * 3) calc(100vw / 768 * 20);
    box-shadow: calc(100vw / 768 * 6) calc(100vw / 768 * 6) 0px 0px rgba(0, 0, 0, 0.06);
    font-size: 0.83em;
  }

  .page-container #page-main .page-content .page-title .btn i {
    width: calc(100vw / 768 * 45);
    height: calc(100vw / 768 * 45);
    margin-right: calc(100vw / 768 * 2);
  }

  .page-container #page-main .page-content .tabs {
    margin-top: calc(100vw / 768 * 14);
  }

  .page-container #page-main .page-content .tabs .tabs-nav {
    padding: 0 calc(100vw / 768 * 8);
    border-bottom-width: calc(100vw / 768 * 3);
    display: block;
    overflow-x: auto;
    max-width: 100%;
    white-space: nowrap;
  }

  .page-container #page-main .page-content .tabs .tabs-nav a {
    border-width: calc(100vw / 768 * 1) calc(100vw / 768 * 1) 0 calc(100vw / 768 * 1);
    min-width: calc(100vw / 768 * 130);
    padding: calc(100vw / 768 * 12);
    border-radius: calc(100vw / 768 * 30) calc(100vw / 768 * 30) 0 0;
    display: inline-block;
    margin: 0 calc(100vw / 768 * 1);
  }

  .page-container #page-main .page-content .tabs .tabs-nav a.active::before {
    width: calc(100vw / 768 * 6);
    height: calc(100vw / 768 * 6);
    margin-right: calc(100vw / 768 * 8);
    margin-top: calc(100vw / 768 * 8);
  }

  .page-container #page-main .page-content .tabs .tabs-nav a.active::after {
    border-width: calc(100vw / 768 * 3) 0 0 0;
    border-radius: calc(100vw / 768 * 28) calc(100vw / 768 * 28) 0 0;
  }

  .page-container #page-main .page-content .tabs.tabs-apply {
    margin: calc(100vw / 768 * 30) auto 0;
    max-width: none;
    width: 100%;
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content {
    border-width: calc(100vw / 768 * 2);
    box-shadow: calc(100vw / 768 * 6) calc(100vw / 768 * 6) 0px 0px rgba(0, 0, 0, 0.06);
    padding: calc(100vw / 768 * 40) calc(100vw / 768 * 60);
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .top-block {
    margin-bottom: calc(100vw / 768 * 32);
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .top-block .btn {
    box-shadow: calc(100vw / 768 * 6) calc(100vw / 768 * 6) 0px 0px rgba(0, 0, 0, 0.06);
    padding: calc(100vw / 768 * 10) calc(100vw / 768 * 24);
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .btn {
    padding: calc(100vw / 768 * 9) calc(100vw / 768 * 16);
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row {
    margin: calc(100vw / 768 * 24) 0;
    gap: 0 calc(100vw / 768 * 12);
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .name {
    width: calc(100vw / 768 * 100);
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row {
    padding-left: calc(100vw / 768 * 112);
    gap: 0 calc(100vw / 768 * 12);
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row.code-row .img-code {
    width: calc(100vw / 768 * 100);
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .checkbox-item,
  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .radio-item {
    padding: calc(100vw / 768 * 10) 0;
  }

  .page-container #page-main .page-content .news-list .news-item {
    border-bottom-width: calc(100vw / 768 * 1);
  }

  .page-container #page-main .page-content .news-list .news-item.news-img-left .news-text,
  .page-container #page-main .page-content .news-list .news-item.news-img-top .news-text {
    padding: calc(100vw / 768 * 16) calc(100vw / 768 * 32) calc(100vw / 768 * 14) calc(100vw / 768 * 269);
    min-height: calc(100vw / 768 * 190);
  }

  .page-container #page-main .page-content .news-list .news-item .news-img {
    width: calc(100vw / 768 * 210);
    height: calc(100vw / 768 * 160);
    border-width: calc(100vw / 768 * 1);
    left: calc(100vw / 768 * 32);
    top: calc(100vw / 768 * 16);
  }

  .page-container #page-main .page-content .news-list .news-item .news-img.icon-video::after {
    width: calc(100vw / 768 * 80);
    height: calc(100vw / 768 * 80);
    background-size: calc(100vw / 768 * 48) calc(100vw / 768 * 48);
    border-width: calc(100vw / 768 * 2);
  }

  .page-container #page-main .page-content .news-list .news-item .news-img img {
    height: calc(100vw / 768 * 160);
  }

  .page-container #page-main .page-content .news-list .news-item .news-text {
    padding: calc(100vw / 768 * 16) calc(100vw / 768 * 32) calc(100vw / 768 * 14);
  }

  .page-container #page-main .page-content .news-list .news-item .news-text .news-name {
    margin-bottom: calc(100vw / 768 * 8);
  }

  .page-container #page-main .page-content .news-list .news-item .news-text .news-bottom {
    margin-top: calc(100vw / 768 * 20);
    margin-bottom: calc(100vw / 768 * 10);
  }

  .page-container #page-main .page-content .news-list .news-item .news-text .news-bottom .btn-more::before {
    width: calc(100vw / 768 * 13);
    height: calc(100vw / 768 * 13);
    background-size: auto calc(100vw / 768 * 7);
    margin-top: calc(100vw / 768 * 3);
  }

  .page-container #page-main .page-content .media-list {
    gap: calc(100vw / 768 * 20) 0;
    margin: calc(100vw / 768 * 14) calc(100vw / 768 * -20) 0;
  }

  .page-container #page-main .page-content .media-list .media-item {
    border-width: calc(100vw / 768 * 1);
    box-shadow: calc(100vw / 768 * 6) calc(100vw / 768 * 6) 0px 0px rgba(0, 0, 0, 0.06);
    padding: calc(100vw / 768 * 16);
    width: calc((100% / 3) - (100vw / 768 * 20));
    margin: 0 calc(100vw / 768 * 10);
  }

  .page-container #page-main .page-content .media-list .media-item .media-img {
    border-width: calc(100vw / 768 * 1);
    margin-bottom: calc(100vw / 768 * 12);
    padding-top: 77%;
  }

  .page-container #page-main .page-content .media-list .media-item .media-img::after {
    width: calc(100vw / 768 * 80);
    height: calc(100vw / 768 * 80);
    background-size: calc(100vw / 768 * 48) calc(100vw / 768 * 48);
    border-width: calc(100vw / 768 * 2);
  }

  .page-container #page-main .page-content .media-list .media-item .media-text .media-name {
    margin-bottom: calc(100vw / 768 * 12);
  }

  .page-container #page-main .page-content .media-list .media-item .media-text .media-tag {
    padding: calc(100vw / 768 * 6) calc(100vw / 768 * 12) calc(100vw / 768 * 7) calc(100vw / 768 * 34);
  }

  .page-container #page-main .page-content .media-list .media-item .media-text .media-tag::before {
    width: calc(100vw / 768 * 14);
    height: calc(100vw / 768 * 16);
    left: calc(100vw / 768 * 12);
  }

  .page-container #page-main .page-content .download-list li+li {
    border-top-width: calc(100vw / 768 * 1);
  }

  .page-container #page-main .page-content .download-list li a {
    padding: calc(100vw / 768 * 12) calc(100vw / 768 * 20) calc(100vw / 768 * 12) calc(100vw / 768 * 30);
    min-height: calc(100vw / 768 * 69);
  }

  .page-container #page-main .page-content .download-list li a .name {
    width: calc(100% - (100vw / 768 * 57));
    padding-left: calc(100vw / 768 * 42);
  }

  .page-container #page-main .page-content .download-list li a .name::before {
    width: calc(100vw / 768 * 30);
    height: calc(100vw / 768 * 24);
  }

  .page-container #page-main .page-content .download-list li a::after {
    width: calc(100vw / 768 * 45);
    height: calc(100vw / 768 * 45);
    margin-left: calc(100vw / 768 * 12);
  }

  .page-container #page-main .page-content .books-list {
    gap: calc(100vw / 768 * 50) 0;
    margin: calc(100vw / 768 * 40) 0;
  }

  .page-container #page-main .page-content .books-list .book-item {
    width: calc((100% / 3) - (100vw / 768 * 10));
    margin: 0 calc(100vw / 768 * 5);
    padding-left: calc(100vw / 768 * 80);
  }

  .page-container #page-main .page-content .books-list .book-item .book-img {
    margin-bottom: calc(100vw / 768 * 20);
  }

  .page-container #page-main .page-content .books-list .book {
    width: calc(100vw / 768 * 100);
    height: calc(100vw / 768 * 136);
  }

  .page-container #page-main .page-content .books-list .book-front {
    transform: rotateY(-34deg) translateZ(calc(100vw / 768 * 8));
  }

  .page-container #page-main .page-content .books-list .book-front li:first-child {
    transform: translateZ(calc(100vw / 768 * 2));
  }

  .page-container #page-main .page-content .books-list .book-front li:first-child::before,
  .page-container #page-main .page-content .books-list .book-front li:first-child::after {
    width: calc(100vw / 768 * 4);
  }

  .page-container #page-main .page-content .books-list .book-front li:first-child::after {
    transform: rotateY(90deg) translateZ(calc(100vw / 768 * -2)) translateX(calc(100vw / 768 * 2));
  }

  .page-container #page-main .page-content .books-list .book-front li:first-child::before {
    transform: rotateY(90deg) translateZ(calc(100vw / 768 * 98)) translateX(calc(100vw / 768 * 2));
  }

  .page-container #page-main .page-content .books-list .book-front li:last-child {
    transform: rotateY(180deg) translateZ(calc(100vw / 768 * 2));
  }

  .page-container #page-main .page-content .books-list .book-front li:last-child::before,
  .page-container #page-main .page-content .books-list .book-front li:last-child::after {
    width: calc(100vw / 768 * 4);
    height: calc(100vw / 768 * 100);
  }

  .page-container #page-main .page-content .books-list .book-front li:last-child::after {
    transform: rotateX(90deg) rotateZ(90deg) translateZ(calc(100vw / 768 * 50)) translateX(calc(100vw / 768 * -2)) translateY(calc(100vw / 768 * -49));
  }

  .page-container #page-main .page-content .books-list .book-front li:last-child::before {
    box-shadow: 0px 0px calc(100vw / 768 * 30) calc(100vw / 768 * 5) #999;
    transform: rotateX(90deg) rotateZ(90deg) translateZ(calc(100vw / 768 * -87)) translateX(calc(100vw / 768 * -2)) translateY(calc(100vw / 768 * -49));
  }

  .page-container #page-main .page-content .books-list .book-back {
    transform: rotateY(-15deg) translateZ(calc(100vw / 768 * -8));
  }

  .page-container #page-main .page-content .books-list .book-back li:first-child {
    transform: translateZ(calc(100vw / 768 * 2));
  }

  .page-container #page-main .page-content .books-list .book-back li:first-child::before,
  .page-container #page-main .page-content .books-list .book-back li:first-child::after {
    width: calc(100vw / 768 * 4);
  }

  .page-container #page-main .page-content .books-list .book-back li:first-child::after {
    transform: rotateY(90deg) translateZ(calc(100vw / 768 * -2)) translateX(calc(100vw / 768 * 2));
  }

  .page-container #page-main .page-content .books-list .book-back li:first-child::before {
    transform: rotateY(90deg) translateZ(calc(100vw / 768 * 98)) translateX(calc(100vw / 768 * 2));
  }

  .page-container #page-main .page-content .books-list .book-back li:last-child {
    transform: translateZ(calc(100vw / 768 * -2));
  }

  .page-container #page-main .page-content .books-list .book-back li:last-child::before,
  .page-container #page-main .page-content .books-list .book-back li:last-child::after {
    width: calc(100vw / 768 * 4);
    height: calc(100vw / 768 * 100);
  }

  .page-container #page-main .page-content .books-list .book-back li:last-child::after {
    transform: rotateX(90deg) rotateZ(90deg) translateZ(calc(100vw / 768 * 50)) translateX(calc(100vw / 768 * 2)) translateY(calc(100vw / 768 * -49));
  }

  .page-container #page-main .page-content .books-list .book-back li:last-child::before {
    box-shadow: calc(100vw / 768 * 10) calc(100vw / 768 * -1) calc(100vw / 768 * 40) calc(100vw / 768 * 10) #999;
    transform: rotateX(90deg) rotateZ(90deg) translateZ(calc(100vw / 768 * -87)) translateX(calc(100vw / 768 * 2)) translateY(calc(100vw / 768 * -49));
  }

  .page-container #page-main .page-content .books-list .book-spine {
    transform: rotateY(60deg) translateX(calc(100vw / 768 * -5)) translateZ(calc(100vw / 768 * -12));
    width: calc(100vw / 768 * 16);
  }

  .page-container #page-main .page-content .books-list .book-spine li:first-child {
    transform: translateZ(calc(100vw / 768 * 2));
  }

  .page-container #page-main .page-content .books-list .book-spine li:first-child::before,
  .page-container #page-main .page-content .books-list .book-spine li:first-child::after {
    width: calc(100vw / 768 * 4);
  }

  .page-container #page-main .page-content .books-list .book-spine li:first-child::after {
    transform: rotateY(90deg) translateZ(calc(100vw / 768 * -2)) translateX(calc(100vw / 768 * 2));
  }

  .page-container #page-main .page-content .books-list .book-spine li:first-child::before {
    transform: rotateY(-90deg) translateZ(calc(100vw / 768 * -12));
  }

  .page-container #page-main .page-content .books-list .book-spine li:last-child {
    transform: translateZ(calc(100vw / 768 * -2));
  }

  .page-container #page-main .page-content .books-list .book-spine li:last-child::before,
  .page-container #page-main .page-content .books-list .book-spine li:last-child::after {
    width: calc(100vw / 768 * 4);
    height: calc(100vw / 768 * 16);
  }

  .page-container #page-main .page-content .books-list .book-spine li:last-child::after {
    transform: rotateX(90deg) rotateZ(90deg) translateZ(calc(100vw / 768 * 8)) translateX(calc(100vw / 768 * 2)) translateY(calc(100vw / 768 * -6));
  }

  .page-container #page-main .page-content .books-list .book-spine li:last-child::before {
    box-shadow: calc(100vw / 768 * 5) calc(100vw / 768 * -1) calc(100vw / 768 * 50) calc(100vw / 768 * 20) rgba(0, 0, 0, 0.2);
    transform: rotateX(90deg) rotateZ(90deg) translateZ(calc(100vw / 768 * -131)) translateX(calc(100vw / 768 * 2)) translateY(calc(100vw / 768 * -6));
  }

  .page-container #page-main .page-content .books-list .book-content li {
    box-shadow: inset 0px calc(100vw / 768 * -1) calc(100vw / 768 * 2) rgba(50, 50, 50, 0.1),
      inset calc(100vw / 768 * -1) 0px calc(100vw / 768 * 1) rgba(150, 150, 150, 0.2);
    border-radius: 0px calc(100vw / 768 * 5) calc(100vw / 768 * 5) 0px;
  }

  .page-container #page-main .page-content .books-list .book-btn {
    border-width: calc(100vw / 768 * 2);
    padding: calc(100vw / 768 * 3) calc(100vw / 768 * 8);
  }

  .page-container #page-main .page-content .faq-list {
    margin-top: calc(100vw / 768 * 30);
  }

  .page-container #page-main .page-content .faq-list .faq-item {
    border-width: calc(100vw / 768 * 1);
    border-radius: calc(100vw / 768 * 10);
    box-shadow: calc(100vw / 768 * 6) calc(100vw / 768 * 6) 0 0 rgba(93, 107, 192, 0.06);
    margin-bottom: calc(100vw / 768 * 16);
  }

  .page-container #page-main .page-content .faq-list .faq-item.active .faq-header {
    border-radius: calc(100vw / 768 * 10) calc(100vw / 768 * 10) 0 0;
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header {
    padding: calc(100vw / 768 * 16) calc(100vw / 768 * 68) calc(100vw / 768 * 16) calc(100vw / 768 * 22);
    border-radius: calc(100vw / 768 * 10);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header::after {
    width: calc(100vw / 768 * 36);
    height: calc(100vw / 768 * 36);
    right: calc(100vw / 768 * 20);
    top: calc(100vw / 768 * 16);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .icon {
    width: calc(100vw / 768 * 40);
    height: calc(100vw / 768 * 40);
    margin-top: calc(100vw / 768 * 12);
    margin-right: calc(100vw / 768 * 12);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .name {
    width: calc(100% - (100vw / 768 * 52));
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .name .top {
    margin-bottom: calc(100vw / 768 * 8);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .name .top .tag {
    padding: calc(100vw / 768 * 4) calc(100vw / 768 * 12);
    border-radius: calc(100vw / 768 * 30);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .name .top .tag i {
    width: calc(100vw / 768 * 12);
    height: calc(100vw / 768 * 12);
    margin-right: calc(100vw / 768 * 4);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .name .top .tag i img {
    margin-top: 0;
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .name p {
    padding-left: calc(100vw / 768 * 12);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-content {
    margin: calc(100vw / 768 * 8) 0 calc(100vw / 768 * 18) calc(100vw / 768 * 48);
    padding: 0 calc(100vw / 768 * 40) 0 calc(100vw / 768 * 16);
    border-left-width: calc(100vw / 768 * 1);
  }

  .page-container #page-main .page-content .pagination {
    margin-top: calc(100vw / 768 * 42);
    margin-bottom: 0;
    padding: 0 calc(100vw / 768 * 60);
  }

  .page-container #page-main .page-content .pagination .pagination-num {
    gap: 0 calc(100vw / 768 * 10);
    margin-bottom: calc(100vw / 768 * 23);
  }

  .page-container #page-main .page-content .pagination .pagination-num li a,
  .page-container #page-main .page-content .pagination .pagination-num li span {
    border-width: calc(100vw / 768 * 1);
    border-radius: calc(100vw / 768 * 4);
    line-height: calc(100vw / 768 * 38);
    min-width: calc(100vw / 768 * 40);
    padding: 0 calc(100vw / 768 * 10);
  }

  .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow {
    width: calc(100vw / 768 * 144);
    padding: 0 calc(100vw / 768 * 15);
  }

  .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-prev {
    border-radius: calc(100vw / 768 * 40) calc(100vw / 768 * 4) calc(100vw / 768 * 4) calc(100vw / 768 * 40);
  }

  .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-prev::before {
    width: calc(100vw / 768 * 8);
    height: calc(100vw / 768 * 11);
    margin-right: calc(100vw / 768 * 8);
    margin-top: calc(100vw / 768 * 15);
  }

  .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-next {
    border-radius: calc(100vw / 768 * 4) calc(100vw / 768 * 40) calc(100vw / 768 * 40) calc(100vw / 768 * 4);
  }

  .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-next::after {
    width: calc(100vw / 768 * 8);
    height: calc(100vw / 768 * 11);
    margin-left: calc(100vw / 768 * 8);
    margin-top: calc(100vw / 768 * 15);
  }

  .page-container #page-main .page-content .pagination .pagination-page label,
  .page-container #page-main .page-content .pagination .pagination-page span {
    margin: 0 calc(100vw / 768 * 12);
  }

  .page-container #page-main .page-content .pagination .pagination-page input {
    width: calc(100vw / 768 * 350);
    border-width: calc(100vw / 768 * 1);
    border-radius: calc(100vw / 768 * 4);
    padding: calc(100vw / 768 * 2) calc(100vw / 768 * 5) 0;
    line-height: calc(100vw / 768 * 35);
    height: auto;
  }

  .page-container #page-main .page-content .pagination .pagination-page .btn {
    display: block;
    margin-left: 0;
    padding-top: calc(100vw / 768 * 3);
    line-height: calc(100vw / 768 * 37);
    width: 100%;
    margin-top: calc(100vw / 768 * 23);
  }

  .page-container #page-main .page-content .block-content {
    margin-top: calc(100vw / 768 * 14);
    padding: calc(100vw / 768 * 20);
  }

  .page-container #page-main .page-content .color-block {
    padding: calc(100vw / 768 * 15) calc(100vw / 768 * 20);
  }

  .page-container #page-main .page-content table {
    margin-bottom: calc(100vw / 768 * 13);
  }

  .page-container #page-main .page-content table.table-sm .btn {
    padding: calc(100vw / 768 * 8) calc(100vw / 768 * 10);
    width: calc(100vw / 768 * 150);
    display: inline-block;
  }

  .page-container #page-main .page-content table.table-sm .btn+.btn {
    margin-top: 0;
    margin-left: calc(100vw / 768 * 5);
  }

  .page-container #page-main .page-content table.table-horizontal tbody td {
    text-align: left;
  }

  .page-container #page-main .page-content table.t-table-vertical {
    border: none;
  }

  .page-container #page-main .page-content table.t-table-vertical tbody td {
    padding: calc(100vw / 768 * 12) calc(100vw / 768 * 12) calc(100vw / 768 * 12) calc(100vw / 768 * 176);
    display: block;
    position: relative;
    overflow: hidden;
  }

  .page-container #page-main .page-content table.t-table-vertical tbody td::before {
    position: absolute;
    background-color: #5d6bc0;
    color: #fff;
    padding: calc(100vw / 768 * 12);
    width: calc(100vw / 768 * 140);
    content: attr(data-name);
    left: 0;
    top: 0;
    height: 100%;
  }

  .page-container #page-main .page-content table.t-table-vertical tr {
    display: block;
    margin-bottom: calc(100vw / 768 * 6);
    border: calc(100vw / 768 * 1) solid #5d6bc0;
  }

  .page-container #page-main .page-content table.t-table-vertical thead {
    display: none;
  }

  .page-container #page-main .page-content table tbody td {
    padding: calc(100vw / 768 * 12);
    border-bottom: calc(100vw / 768 * 1) solid #c2c7f7;
  }

  .page-container #page-main .page-content table tbody tr {
    border-bottom-width: calc(100vw / 768 * 1);
  }

  .page-container #page-main .page-content table i {
    width: calc(100vw / 768 * 14);
    height: calc(100vw / 768 * 16);
    margin-right: calc(100vw / 768 * 6);
    margin-top: calc(100vw / 768 * 5);
  }

  .page-container #page-main .page-content table .download-list {
    margin: calc(100vw / 768 * -12) !important;
  }

  .page-container #page-main .page-content table .download-list li a {
    min-height: calc(100vw / 768 * 65);
    padding: calc(100vw / 768 * 12) calc(100vw / 768 * 16);
  }

  .page-container #page-main .page-content table .download-list li a .name {
    width: calc(100% - (100vw / 768 * 50));
    padding-left: calc(100vw / 768 * 35);
  }

  .page-container #page-main .page-content table .download-list li a .name::before {
    width: calc(100vw / 768 * 25);
    height: calc(100vw / 768 * 20);
    top: calc(100vw / 768 * 3);
  }

  .page-container #page-main .page-content table .download-list li a::after {
    width: calc(100vw / 768 * 40);
    height: calc(100vw / 768 * 40);
    margin-left: calc(100vw / 768 * 10);
  }

  .page-container #page-main .page-content table .article.top-line {
    border-top: calc(100vw / 768 * 1) solid #c2c7f7;
    padding-top: calc(100vw / 768 * 16);
  }

  .page-container #page-main .page-content table .article figure {
    margin: 0 0 calc(100vw / 768 * 16);
  }

  .page-container #page-main .page-content table .article p {
    margin-bottom: calc(100vw / 768 * 20);
  }

  .page-container #page-main .page-content table .article ol {
    margin-bottom: calc(100vw / 768 * 20);
  }

  .page-container #page-main .page-content table .article ol.list-tw>li b {
    margin-bottom: calc(100vw / 768 * 8);
  }

  .page-container #page-main .page-content table .article ol li p {
    margin-bottom: calc(100vw / 768 * 8);
  }

  .page-container #page-main .page-content table .tag-y {
    padding: calc(100vw / 768 * 5) calc(100vw / 768 * 10);
    border-radius: calc(100vw / 768 * 50);
    margin-bottom: calc(100vw / 768 * 4);
  }

  .page-container #page-main .page-content table .tag-y i {
    width: calc(100vw / 768 * 10);
    height: calc(100vw / 768 * 13);
    margin-right: calc(100vw / 768 * 4);
    margin-top: 0;
  }

  .page-container #page-main .page-content table .text-limit {
    -webkit-line-clamp: 2;
    line-height: 1.5em;
    min-height: 3em;
  }

  .page-container #page-main .page-content .tag-list {
    padding: 0 calc(100vw / 768 * 8);
    margin-top: calc(100vw / 768 * 12);
    margin-bottom: calc(100vw / 768 * 20);
  }

  .page-container #page-main .page-content .tag-list .tag-item {
    padding: calc(100vw / 768 * 16) calc(100vw / 768 * 12);
    border-bottom-width: calc(100vw / 768 * 1);
  }

  .page-container #page-main .page-content .tag-list .tag-item .tag-name {
    box-shadow: calc(100vw / 768 * 4) calc(100vw / 768 * 4) 0 0 rgba(0, 0, 0, 0.15);
    border-width: calc(100vw / 768 * 1);
    border-radius: 0 calc(100vw / 768 * 50) calc(100vw / 768 * 50) 0;
    padding: calc(100vw / 768 * 2) calc(100vw / 768 * 16) calc(100vw / 768 * 2) calc(100vw / 768 * 12);
    margin-bottom: calc(100vw / 768 * 12);
  }

  .page-container #page-main .page-content .tag-list .tag-item .tag-name::before {
    width: calc(100vw / 768 * 13);
    height: calc(100vw / 768 * 13);
    margin-right: calc(100vw / 768 * 8);
  }

  .page-container #page-main .page-content .tag-list .tag-item .download-list li a {
    min-height: calc(100vw / 768 * 48);
  }

  .page-container #page-main .page-content .keyboard-tag {
    margin: calc(100vw / 768 * -7) calc(100vw / 768 * 5) 0;
    width: calc(100vw / 768 * 100);
    border-width: calc(100vw / 768 * 1);
    border-radius: calc(100vw / 768 * 5);
    padding: calc(100vw / 768 * 6) 0;
  }

  .page-container #page-main .page-content . btn-lg w-100 {
    margin-top: calc(100vw / 768 * 30);
  }

  .page-container #page-main .page-content .from-block .input-row {
    padding: calc(100vw / 768 * 16) calc(100vw / 768 * 8);
    gap: 0 calc(100vw / 768 * 8);
  }

  .page-container #page-main .page-content .keyboard-list li .keyboard-text {
    width: calc(100% - (100vw / 768 * 110));
  }

  .page-container #page-main .page-content .keyboard-list li .keyboard-group-lg+.keyboard-text {
    width: calc(100% - calc(100vw / 768 * 255));
  }

  .page-container #page-main .page-content .sitemap-list {
    margin-top: calc(100vw / 768 * 20);
    border-bottom-width: calc(100vw / 768 * 1);
  }

  .page-container #page-main .page-content .sitemap-list .sitemap-name {
    padding: calc(100vw / 768 * 5);
  }

  .page-container #page-main .page-content .sitemap-list .sitemap-name::before {
    width: calc(100vw / 768 * 40);
    height: calc(100vw / 768 * 40);
    margin-right: calc(100vw / 768 * 8);
  }

  .page-container #page-main .page-content .sitemap-list .link {
    padding: calc(100vw / 768 * 13) calc(100vw / 768 * 5);
  }

  .page-container #page-main .page-content .sitemap-list .row .col {
    padding: calc(100vw / 768 * 16) calc(100vw / 768 * 15);
    border-top-width: calc(100vw / 768 * 1);
  }

  .page-container #page-main .article-main {
    margin-top: 0;
  }

  .page-container #page-main .article-main .article-top {
    margin-bottom: calc(100vw / 768 * 26);
  }

  .page-container #page-main .article-main .article-top .article-title {
    font-size: 1.5em;
    margin-bottom: calc(100vw / 768 * 8);
  }

  .page-container #page-main .article-main .article-top .article-sub-title {
    font-size: 1.25em;
  }

  .page-container #page-main .article-main .article-top .article-tag {
    padding: calc(100vw / 768 * 5) calc(100vw / 768 * 10);
    margin-bottom: calc(100vw / 768 * 8);
    margin-top: 0;
  }

  .page-container #page-main .article-main .article-top .article-tag i {
    width: calc(100vw / 768 * 11);
    height: calc(100vw / 768 * 15);
    margin-right: calc(100vw / 768 * 4);
  }

  .page-container #page-main .article-main .article-tag li {
    margin: calc(100vw / 768 * 2) 0;
  }

  .page-container #page-main .article-main .article-tag li::before {
    width: calc(100vw / 768 * 16);
    height: calc(100vw / 768 * 16);
    margin-right: calc(100vw / 768 * 6);
  }

  .page-container #page-main .article-main .article-tag li::after {
    width: calc(100vw / 768 * 1);
    height: calc(100vw / 768 * 12);
    margin: 0 calc(100vw / 768 * 10) 0 calc(100vw / 768 * 12);
  }

  .page-container #page-main .article-main .article-wrap {
    /*margin-top: calc(100vw / 768 * 10);
    padding-top: calc(100vw / 768 * 10);
    border-top-width: calc(100vw / 768 * 1);
    flex-direction: column;*/
  }

  .page-container #page-main .article-main .article-wrap .article-share {
    order: 1;
    width: auto;
    border-radius: 0 calc(100vw / 768 * 50) calc(100vw / 768 * 50) 0;
    padding: calc(100vw / 768 * 13) calc(100vw / 768 * 16);
    flex-direction: row;
    gap: 0 calc(100vw / 768 * 15);
    margin-left: 0;
    margin-bottom: calc(100vw / 768 * 10);
    top: 0;
    z-index: 10;
  }

  .page-container #page-main .article-main .article-wrap .article-share a {
    width: calc(100vw / 768 * 35);
    height: calc(100vw / 768 * 35);
  }

  .page-container #page-main .article-main .article-wrap .article-content {
    order: 2;
    flex: none;
    width: 100%;
  }

  .page-container #page-main .article-main .article-wrap .article-content-top {
    border-top-width: calc(100vw / 768 * 2);
    border-bottom-width: calc(100vw / 768 * 2);
    padding: calc(100vw / 768 * 15) calc(100vw / 768 * 20);
    margin-top: 0;
  }

  .page-container #page-main .article-main .article-wrap .article-content-top .article-top-name {
    margin-bottom: calc(100vw / 768 * 10);
  }

  .page-container #page-main .article-main .article-wrap .article-content-top .article-top-block {
    padding: calc(100vw / 768 * 15) calc(100vw / 768 * 20);
    margin: calc(100vw / 768 * 12) 0;
  }

  .page-container #page-main .article-main .article-wrap .article-content-top .article-top-block .name {
    margin-bottom: calc(100vw / 768 * 10);
  }

  .page-container #page-main .article-main .article-wrap .article-content-top .article-tag {
    padding-left: calc(100vw / 768 * 20);
    padding-right: calc(100vw / 768 * 20);
  }

  .page-container #page-main .article-main .article-wrap .article-content-top+.article {
    padding-top: calc(100vw / 768 * 16);
  }

  .page-container #page-main .article-main .article-wrap .article-content-bottom {
    padding: calc(100vw / 768 * 20);
  }

  .page-container #page-main .article-main .article-wrap .article-content-bottom .article-bottom-img {
    width: calc(100vw / 768 * 210);
    margin-right: calc(100vw / 768 * 20);
  }

  .page-container #page-main .article-main .article-wrap .article-content-bottom .article-bottom-name {
    margin-bottom: calc(100vw / 768 * 8);
  }

  .page-container #page-main .article-main .article-wrap .template-block {
    /*margin-top: calc(100vw / 768 *16);
    padding-top: calc(100vw / 768 * 20);*/
  }

  .page-container #page-main .article-main .article-wrap .template-block.line-top {
    border-top-width: calc(100vw / 768 * 1);
  }

  .page-container #page-main .article-main .article-wrap .template-block .template-name {
    margin-bottom: calc(100vw / 768 * 12);
  }

  .page-container #page-main .article-main .article-wrap .template-block .template-name::before {
    width: calc(100vw / 768 * 20);
    height: calc(100vw / 768 * 20);
    margin-right: calc(100vw / 768 * 8);
  }

  .page-container #page-main .article-main .article-wrap .template-block .template-name.icon-info::before {
    width: calc(100vw / 768 * 23);
    margin-top: calc(100vw / 768 * 2);
  }

  .page-container #page-main .article-main .article-wrap .template-block .download-list {
    border-top-width: calc(100vw / 768 * 1);
    border-bottom-width: calc(100vw / 768 * 1);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block {
    border-top-width: calc(100vw / 768 * 2);
    border-bottom-width: calc(100vw / 768 * 2);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-group.row {
    width: calc(100% - (100vw / 768 * 75));
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-item label,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .radio-item label {
    padding-left: calc(100vw / 768 * 30);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-item label+label,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .radio-item label+label {
    margin-top: calc(100vw / 768 * 8);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>input,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>select,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>textarea,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.row,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.checkbox-group,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.radio-group {
    width: calc(100% - (100vw / 768 * 138));
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .name {
    width: calc(100vw / 768 * 130);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-sm {
    width: calc(100vw / 768 * 90);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-sm-auto {
    width: calc(100% - (100vw / 768 * 236));
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-md {
    width: calc(100vw / 768 * 170);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-lg {
    width: calc(100vw / 768 * 310);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .ps {
    padding-left: calc(100vw / 768 * 140);
    padding-top: calc(100vw / 768 * 2);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row .input-row .name {
    width: calc(100vw / 768 * 65);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row .col-4 {
    width: calc((100% / 3) - (100vw / 768 * 8));
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .link i {
    margin-right: calc(100vw / 768 * 5);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block>.row {
    border-bottom-width: calc(100vw / 768 * 1);
  }

  .filter-block {
    border-radius: calc(100vw / 768 * 100) calc(100vw / 768 * 100) calc(100vw / 768 * 10) calc(100vw / 768 * 10);
    padding: calc(100vw / 768 * 13) calc(100vw / 768 * 60);
    gap: 0 calc(100vw / 768 * 12);
    margin-bottom: calc(100vw / 768 * 12);
  }

  .filter-block.filter-align-bottom {
    align-items: flex-end;
  }

  .filter-block.t-filter-inline {
    padding: calc(100vw / 768 * 13) calc(100vw / 768 * 30);
    gap: 0 calc(100vw / 768 * 10);
  }

  .filter-block.t-filter-inline .filter-item {
    flex: none;
  }

  .filter-block.t-filter-inline .filter-item label {
    width: auto;
    margin-bottom: 0;
  }

  .filter-block.t-filter-inline .filter-item input,
  .filter-block.t-filter-inline .filter-item select {
    flex: none;
    width: calc(100vw / 768 * 105);
    padding-left: calc(100vw / 768 * 10);
  }

  .filter-block .filter-item {
    flex-wrap: wrap;
  }

  .filter-block .filter-item label {
    width: 100%;
    margin-bottom: calc(100vw / 768 * 5);
    display: flex;
    align-items: center;
  }

  .filter-block label.label-text {
    padding: 0 calc(100vw / 768 * 3);
  }

  .filter-block label[class*="icon-"]::before {
    width: calc(100vw / 768 * 18);
    height: calc(100vw / 768 * 16);
    margin-right: calc(100vw / 768 * 6);
    margin-top: calc(100vw / 768 * 5);
  }

  .filter-block label.icon-category::before {
    width: calc(100vw / 768 * 20);
  }

  .filter-block .btn {
    width: calc(100vw / 768 * 120);
    line-height: calc(100vw / 768 * 38);
    padding-top: calc(100vw / 768 * 2);
  }

  .filter-block .btn.btn-sm {
    width: calc(100vw / 768 * 70);
  }

  .filter-block.filter-collapse {
    border-radius: calc(100vw / 768 * 30) calc(100vw / 768 * 30) 0 0;
  }

  .filter-block.filter-collapse .filter-name {
    padding: calc(100vw / 768 * 12) calc(100vw / 768 * 24) calc(100vw / 768 * 12) calc(100vw / 768 * 12);
  }

  .filter-block.filter-collapse .filter-name .name {
    font-size: 1.125em;
    padding: 0 calc(100vw / 768 * 5);
  }

  .filter-block.filter-collapse .filter-name .name::before,
  .filter-block.filter-collapse .filter-name .name::after {
    margin: calc(100vw / 768 * -2) calc(100vw / 768 * 10) 0;
    width: calc(100vw / 768 * 1);
    height: calc(100vw / 768 * 18);
  }

  .filter-block.filter-collapse .btn-collapse::after {
    width: calc(100vw / 768 * 18);
    height: calc(100vw / 768 * 18);
    margin: calc(100vw / 768 * 2) 0 0 calc(100vw / 768 * 5);
  }

  .filter-block.filter-collapse .collapse-content {
    border-top-width: calc(100vw / 768 * 2);
    border-bottom-width: calc(100vw / 768 * 2);
    box-shadow: calc(100vw / 768 * 6) calc(100vw / 768 * 6) 0 0 rgba(0, 0, 0, 0.06);
    padding: calc(100vw / 768 * 4) 0;
  }

  .filter-block.filter-collapse .collapse-content .row {
    padding: calc(100vw / 768 * 12) calc(100vw / 768 * 20);
    gap: calc(100vw / 768 * 12);
  }

  .filter-block.filter-collapse .collapse-content .row .col {
    gap: 0 calc(100vw / 768 * 6);
  }

  .filter-block.filter-collapse .collapse-content .row .col-auto-2 {
    width: calc(50% - (100vw / 768 * 6));
    flex: none;
  }

  .filter-block.filter-collapse .collapse-content .row+.row {
    padding-top: 0;
  }

  .filter-block.filter-collapse .collapse-content .select {
    width: calc(100vw / 768 * 125);
  }

  .filter-block.filter-collapse .collapse-content . btn-lg w-100 {
    flex: none !important;
  }

  .popup {
    max-width: calc(100vw / 768 * 950);
    border-radius: calc(100vw / 768 * 10);
    padding: calc(100vw / 768 * 12) calc(100vw / 768 * 20);
  }

  .popup .btn-popup-close {
    width: calc(100vw / 768 * 50);
    height: calc(100vw / 768 * 50);
    right: calc(100vw / 768 * -25);
    top: calc(100vw / 768 * -25);
    border-width: calc(100vw / 768 * 1);
  }

  .popup.popup-info .info-name {
    padding: calc(100vw / 768 * 12) calc(100vw / 768 * 20);
    border-radius: calc(100vw / 768 * 10) calc(100vw / 768 * 10) 0 0;
  }

  .popup.popup-info .info-name i {
    width: calc(100vw / 768 * 23);
    height: calc(100vw / 768 * 23);
    margin-right: calc(100vw / 768 * 10);
  }

  .popup.popup-info .info-name i svg {
    width: calc(100vw / 768 * 23);
    height: calc(100vw / 768 * 23);
  }

  .popup.popup-info .info-content {
    padding: calc(100vw / 768 * 30);
  }

  .popup.popup-info .info-content i {
    width: calc(100vw / 768 * 14);
    height: calc(100vw / 768 * 14);
  }

  .popup.popup-info .info-content a {
    padding: calc(100vw / 768 * 2) calc(100vw / 768 * 5);
  }

  .popup.popup-info .info-content hr {
    margin-bottom: calc(100vw / 768 * 16);
    border-top-width: calc(100vw / 768 * 2);
  }

  .popup.popup-info .info-content p {
    margin-bottom: calc(100vw / 768 * 16);
  }

  .popup.popup-info .info-content .filter-block {
    padding-left: calc(100vw / 768 * 30);
    padding-right: calc(100vw / 768 * 30);
  }

  .popup.popup-info .info-content .filter-block select {
    padding: 0 calc(100vw / 768 * 30) 0 calc(100vw / 768 * 12);
    width: calc(100vw / 768 * 100);
  }

  .popup.popup-info .info-content .filter-block input {
    padding: calc(100vw / 768 * 2) calc(100vw / 768 * 12) 0;
    width: calc(100vw / 768 * 100);
  }

  .row .col-6 {
    width: 50%;
  }

  .btn-more {
    font-size: 0.875em;
  }

  .btn-more::before {
    width: calc(100vw / 768 * 14);
    height: calc(100vw / 768 * 14);
    background-size: auto calc(100vw / 768 * 6);
    margin-right: calc(100vw / 768 * 5);
    margin-top: calc(100vw / 768 * 5);
  }

  #index-banner .swiper-arrow {
    width: calc(100vw / 768 * 50);
    height: calc(100vw / 768 * 50);
    border-width: calc(100vw / 768 * 1);
  }

  #index-banner .swiper-arrow svg {
    width: calc(100vw / 768 * 50);
    height: calc(100vw / 768 * 50);
  }

  #index-banner .swiper-arrow.swiper-button-prev {
    left: calc(100vw / 768 * 24);
  }

  #index-banner .swiper-arrow.swiper-button-next {
    right: calc(100vw / 768 * 24);
  }

  #index-banner .swiper-pagination-bullet {
    border-width: calc(100vw / 768 * 1);
    width: calc(100vw / 768 * 10);
    height: calc(100vw / 768 * 10);
  }

  #index-banner a {
    height: calc(100vw / 768 * 360);
  }

  #index-news {
    padding-top: calc(100vw / 768 * 20);
  }

  #index-news .btn-anchor {
    left: calc(100vw / 768 * 25);
    top: calc(100vw / 768 * 20);
  }

  #index-news .index-news-top {
    margin-bottom: calc(100vw / 768 * 25);
    flex-wrap: wrap;
  }

  #index-news .index-news-top .index-news-title {
    font-size: calc(100vw / 768 * 40);
    padding-left: calc(100vw / 768 * 42);
    margin: calc(100vw / 768 * 28) 0 calc(100vw / 768 * 30) calc(100vw / 768 * 30);
    width: 100%;
  }

  #index-news .index-news-top .index-news-title::before {
    font-size: calc(100vw / 768 * 73);
  }

  #index-news .index-news-top .tabs-nav {
    border-bottom-width: calc(100vw / 768 * 1);
    padding: 0 calc(100vw / 768 * 14);
  }

  #index-news .index-news-top .tabs-nav a {
    font-size: 1em;
    padding: calc(100vw / 768 * 5) calc(100vw / 768 * 8);
    margin: 0 calc(100vw / 768 * 12);
    border-radius: calc(100vw / 768 * 12) calc(100vw / 768 * 12) 0 0;
    min-width: calc(100vw / 768 * 70);
  }

  #index-news .index-news-top .tabs-nav a::before {
    width: calc(100vw / 768 * 1);
    height: calc(100vw / 768 * 20);
    left: calc(100vw / 768 * -8);
    bottom: calc(100vw / 768 * 5);
  }

  #index-news .index-news-top .swiper-control {
    margin-left: calc(100vw / 768 * 15);
  }

  #index-news .index-news-top .swiper-control .swiper-arrow {
    width: calc(100vw / 768 * 30);
    height: calc(100vw / 768 * 30);
    border-width: calc(100vw / 768 * 1);
    margin-left: calc(100vw / 768 * 15);
  }

  #index-news .newsSwiper {
    padding-bottom: calc(100vw / 768 * 20);
    padding-top: 0;
    margin-right: calc(100vw / 768 * -150);
  }

  #index-news .newsSwiper .swiper-slide {
    padding: 0 calc(100vw / 768 * 6);
  }

  #index-news .news-card {
    padding: calc(100vw / 768 * 24) calc(100vw / 768 * 20);
    border-radius: calc(100vw / 768 * 10);
  }

  #index-news .news-card::after {
    border-width: calc(100vw / 768 * 12) calc(100vw / 768 * 9);
    bottom: calc(100vw / 768 * -19);
    right: calc(100vw / 768 * 45);
  }

  #index-news .news-card .news-card-top {
    margin-bottom: calc(100vw / 768 * 20);
  }

  #index-news .news-card .news-card-top .tag {
    padding: calc(100vw / 768 * 5) calc(100vw / 768 * 10) calc(100vw / 768 * 5) calc(100vw / 768 * 30);
    border-radius: calc(100vw / 768 * 50);
    max-width: calc(100vw / 768 * 150);
  }

  #index-news .news-card .news-card-top .tag::before {
    width: calc(100vw / 768 * 15);
    height: calc(100vw / 768 * 15);
    left: calc(100vw / 768 * 10);
    top: calc(100vw / 768 * 6);
  }

  #index-news .news-card .news-card-top .date {
    padding: calc(100vw / 768 * 4) 0 calc(100vw / 768 * 4) calc(100vw / 768 * 16);
  }

  #index-news .news-card .news-card-top .date::before {
    width: calc(100vw / 768 * 12);
    height: calc(100vw / 768 * 12);
    top: calc(100vw / 768 * 8);
  }

  #index-quick {
    margin-bottom: calc(100vw / 768 * 30);
  }

  #index-quick .index-quick-top {
    font-size: 1.25em;
    letter-spacing: 0.25em;
    padding: calc(100vw / 768 * 44) calc(100vw / 768 * 180) calc(100vw / 768 * 30) calc(100vw / 768 * 243);
  }

  #index-quick .index-quick-top::before {
    width: calc(100vw / 768 * 206);
    height: calc(100vw / 768 * 132);
    left: calc(100vw / 768 * 20);
  }

  #index-quick .index-quick-top::after {
    width: calc(100vw / 768 * 176);
    height: calc(100vw / 768 * 136);
    right: 0;
  }

  #index-quick .index-quick-content {
    border-radius: calc(100vw / 768 * 130);
    margin: 0;
    padding: calc(100vw / 768 * 20) calc(100vw / 768 * 70) 0;
    gap: calc(100vw / 768 * 19);
    flex-wrap: wrap;
  }

  #index-quick .index-quick-content a {
    padding: calc(100vw / 768 * 23) 0 calc(100vw / 768 * 5);
    border-radius: calc(100vw / 768 * 100) calc(100vw / 768 * 100) 0 0;
    width: calc(25% - (100vw / 768 * 15));
    flex: none;
  }

  #index-quick .index-quick-content a .icon {
    width: calc(100vw / 768 * 70);
  }

  #index-quick .index-quick-content a p {
    line-height: 1.4em;
    height: 2.8em;
    flex: none;
  }

  #index-more {
    padding-bottom: calc(100vw / 768 * 32);
  }

  #index-more .index-more-top {
    margin-bottom: calc(100vw / 768 * 10);
    padding: 0 calc(100vw / 768 * 30) 0 calc(100vw / 768 * 5);
  }

  #index-more .index-more-top .index-more-title {
    font-size: 1.5em;
  }

  #index-more .index-more-top .index-more-title::after {
    width: calc(100vw / 768 * 23);
    height: calc(100vw / 768 * 3);
    margin-left: calc(100vw / 768 * 4);
    margin-top: calc(100vw / 768 * 19);
  }

  #index-more .index-more-content {
    border-width: calc(100vw / 768 * 6);
    box-shadow: calc(100vw / 768 * 4) calc(100vw / 768 * 4) 0 0 rgba(0, 0, 0, 0.15);
    border-radius: calc(100vw / 768 * 12) calc(100vw / 768 * 12) 0 0;
  }

  #index-video {
    padding-top: calc(100vw / 768 * 50);
    padding-right: calc(100vw / 768 * 16);
  }

  #index-video::before {
    width: calc(100vw / 768 * 264);
    height: calc(100vw / 768 * 264);
    left: calc(100vw / 768 * -9);
  }

  #index-video .index-more-top .index-more-title::before {
    width: calc(100vw / 768 * 29);
    height: calc(100vw / 768 * 29);
    margin-right: calc(100vw / 768 * 2);
    margin-top: calc(100vw / 768 * 1);
  }

  #index-resource {
    padding: calc(100vw / 768 * 50) 0 0 calc(100vw / 768 * 16);
  }

  #index-resource::before {
    width: calc(100vw / 768 * 89);
    height: calc(100vw / 768 * 92);
    top: calc(100vw / 768 * 30);
    left: calc(100vw / 768 * 26);
  }

  #index-resource .index-more-top {
    padding-left: calc(100vw / 768 * 104);
  }

  #index-resource .fullSwiper .swiper-slide {
    height: calc(100vw / 768 * 185);
  }

  #index-resource .swiper-arrow {
    width: calc(100vw / 768 * 30);
    height: calc(100vw / 768 * 30);
    border-width: calc(100vw / 768 * 1);
    box-shadow: calc(100vw / 768 * 4) calc(100vw / 768 * 4) 0 0 rgba(0, 0, 0, 0.2);
  }

  #index-resource .swiper-arrow svg {
    width: calc(100vw / 768 * 30);
    height: calc(100vw / 768 * 30);
  }

  #index-resource .swiper-arrow.swiper-prev {
    left: calc(100vw / 768 * -18);
  }

  #index-resource .swiper-arrow.swiper-next {
    right: calc(100vw / 768 * -18);
  }

  #index-social .index-social-top {
    padding: calc(100vw / 768 * 22) calc(100vw / 768 * 18);
    border-radius: 0 0 calc(100vw / 768 * 60) calc(100vw / 768 * 60);
    border-width: 0 calc(100vw / 768 * 1) calc(100vw / 768 * 1);
    box-shadow: calc(100vw / 768 * 4) calc(100vw / 768 * 4) 0 0 rgba(93, 107, 192, 0.15);
    margin-right: calc(100vw / 768 * 14);
    width: calc(100vw / 768 * 230);
  }

  #index-social .index-social-top .icon {
    width: calc(100vw / 768 * 50);
    height: calc(100vw / 768 * 50);
    margin-right: calc(100vw / 768 * 6);
  }

  #index-social .index-social-top .text .name {
    font-size: 1.125em;
  }

  #index-social .index-social-top .text p {
    letter-spacing: 0.05em;
  }

  #index-social .index-social-top .text p i {
    width: calc(100vw / 768 * 20);
    margin-right: calc(100vw / 768 * 6);
    margin-top: calc(100vw / 768 * -1);
  }

  #index-social .index-social-content {
    width: calc(100% - (100vw / 768 * 245));
    padding: calc(100vw / 768 * 10) calc(100vw / 768 * 42);
  }

  #index-social .index-social-content .swiper-arrow {
    width: calc(100vw / 768 * 30);
    height: calc(100vw / 768 * 30);
    border-width: calc(100vw / 768 * 1);
  }

  #index-social .index-social-content .swiper-arrow svg {
    width: calc(100vw / 768 * 30);
    height: calc(100vw / 768 * 30);
  }

  #index-social .index-social-content .socialSwiper .swiper-slide {
    padding: calc(100vw / 768 * 5) calc(100vw / 768 * 8);
  }

  #index-social .index-social-content .socialSwiper .swiper-slide a {
    border-width: calc(100vw / 768 * 1);
    box-shadow: calc(100vw / 768 * 4) calc(100vw / 768 * 4) 0 0 rgba(0, 0, 0, 0.15);
    border-radius: calc(100vw / 768 * 8);
  }

  .popup-album .album-info {
    margin-bottom: calc(100vw / 768 * 16);
  }

  .popup-album .album-info .info-item {
    border-width: calc(100vw / 768 * 1);
    border-radius: calc(100vw / 768 * 50);
    padding: calc(100vw / 768 * 7) calc(100vw / 768 * 12);
    margin-right: calc(100vw / 768 * 12);
    font-size: 0.875em;
  }

  .popup-album .album-info .info-item i {
    width: calc(100vw / 768 * 15);
    height: calc(100vw / 768 * 16);
    margin-right: calc(100vw / 768 * 6);
    margin-top: calc(100vw / 768 * -1);
  }

  .popup-album .album-content .album {
    margin-top: calc(100vw / 768 * 16);
    border-radius: calc(100vw / 768 * 4);
  }

  body {
    font-size: calc(100vw / 768 * 16);
  }

  body[data-size="sm"] .btn-more::before {
    margin-top: calc(100vw / 768 * 2);
  }

  body[data-size="sm"] .page-container #page-main .page-content .news-list .news-item .news-text .news-bottom .btn-more::before {
    margin-top: calc(100vw / 768 * 2);
  }

  body[data-size="sm"] .page-container #page-main .page-content table i {
    margin-top: calc(100vw / 768 * 2);
  }

  body[data-size="sm"] .page-container #page-main .page-content table .download-list li a .name::before {
    top: 0;
  }

  body[data-size="sm"] .filter-block label::before {
    margin-top: calc(100vw / 768 * 1);
  }

  body[data-size="lg"] #menu ul li .sub>li>a::before {
    top: calc(100vw / 768 * 34);
  }

  body[data-size="lg"] #menu>ul>li:not(.btn-search)>a {
    padding: calc(100vw / 768 * 24) calc(100vw / 768 * 75) calc(100vw / 768 * 24) calc(100vw / 768 * 30);
  }

  body[data-size="lg"] #footer .footer-top {
    gap: calc(100vw / 768 * 20) calc(100vw / 768 * 4);
  }

  body[data-size="lg"] #footer .footer-top .footer-info .footer-menu li a {
    padding: calc(100vw / 768 * 1) calc(100vw / 768 * 8);
  }

  body[data-size="lg"] #footer .footer-bottom {
    padding: calc(100vw / 768 * 20) calc(100vw / 768 * 8);
  }

  body[data-size="lg"] .btn-more::before {
    margin-top: calc(100vw / 768 * 5);
  }

  body[data-size="lg"] .page-container #page-main .page-content {
    padding-bottom: 0;
  }

  body[data-size="lg"] .page-container #page-main .page-content .news-list .news-item .news-text .news-bottom .btn-more::before {
    margin-top: calc(100vw / 768 * 4);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num {
    gap: 0 calc(100vw / 768 * 10);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a,
  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li span {
    line-height: calc(100vw / 768 * 38);
    min-width: calc(100vw / 768 * 40);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow {
    padding: 0 calc(100vw / 768 * 15);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-prev {
    border-radius: calc(100vw / 768 * 40) calc(100vw / 768 * 4) calc(100vw / 768 * 4) calc(100vw / 768 * 40);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-prev::before {
    margin-top: calc(100vw / 768 * 15);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-next {
    border-radius: calc(100vw / 768 * 4) calc(100vw / 768 * 40) calc(100vw / 768 * 40) calc(100vw / 768 * 4);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-next::after {
    margin-top: calc(100vw / 768 * 15);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page label,
  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page span {
    margin: 0 calc(100vw / 768 * 12);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page input {
    line-height: calc(100vw / 768 * 35);
    width: calc(100vw / 768 * 280);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page .btn {
    line-height: calc(100vw / 768 * 37);
  }

  body[data-size="lg"] .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .name {
    width: calc(100vw / 768 * 115);
  }

  body[data-size="lg"] .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row {
    padding-left: calc(100vw / 768 * 127);
  }

  body[data-size="lg"] .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row.code-row input {
    width: calc(100vw / 768 * 200);
  }

  body[data-size="lg"] .page-container #page-main .page-content .keyboard-list li .keyboard-group-lg+.keyboard-text {
    width: calc(100% - (100vw / 768 * 260));
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-group.row {
    width: calc(100% - (100vw / 768 * 85));
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>input,
  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>select,
  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>textarea,
  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.row,
  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.checkbox-group,
  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.radio-group {
    width: calc(100% - (100vw / 768 * 158));
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .name {
    width: calc(100vw / 768 * 150);
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-sm {
    width: calc(100vw / 768 * 100);
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-sm-auto {
    width: calc(100% - (100vw / 768 * 266));
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-md {
    width: calc(100vw / 768 * 170);
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-lg {
    width: calc(100vw / 768 * 310);
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .ps {
    padding-left: calc(100vw / 768 * 160);
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row .input-row .name {
    width: calc(100vw / 768 * 75);
  }

  body[data-size="lg"] .filter-block.t-filter-inline {
    padding: calc(100vw / 768 * 13) calc(100vw / 768 * 20);
  }

  body[data-size="lg"] #index-news .index-news-top .tabs-nav {
    padding: 0 calc(100vw / 768 * 14);
  }

  body[data-size="lg"] #index-news .index-news-top .tabs-nav a {
    padding: calc(100vw / 768 * 5) calc(100vw / 768 * 8);
    margin: 0 calc(100vw / 768 * 8) 0 calc(100vw / 768 * 10);
  }

  body[data-size="lg"] #index-news .news-card .news-card-top .tag::before {
    top: calc(100vw / 768 * 8);
  }

  body[data-size="lg"] #index-quick .index-quick-top {
    letter-spacing: 0.2em;
    padding: calc(100vw / 768 * 44) calc(100vw / 768 * 170) calc(100vw / 768 * 30) calc(100vw / 768 * 223);
  }

  body[data-size="lg"] #index-quick .index-quick-top::before {
    left: 0;
  }

  body[data-size="lg"] #index-more .index-more-top {
    padding-right: 0;
  }

  body[data-size="lg"] #index-resource .index-more-top {
    padding-left: calc(100vw / 768 * 104);
  }

  body[data-size="lg"] #index-social .index-social-top {
    width: calc(100vw / 768 * 260);
    padding: calc(100vw / 768 * 20) calc(100vw / 768 * 16) calc(100vw / 768 * 24);
  }

  body[data-size="lg"] #index-social .index-social-content {
    width: calc(100% - (100vw / 768 * 265));
    padding: calc(100vw / 768 * 10) calc(100vw / 768 * 40);
  }

  #app {
    padding-top: calc(100vw / 768 * 80) !important;
  }
}

@media screen and (max-width: 767px) {
  .m-hide {
    display: none;
  }

  .m-block {
    display: block;
  }

  .wrap {
    padding: 0 calc(100vw / 320 * 10);
  }

  .btn-side {
    width: calc(100vw / 320 * 50);
    height: calc(100vw / 320 * 50);
    right: calc(100vw / 320 * 5);
    box-shadow: 0 calc(100vw / 320 * 1) calc(100vw / 320 * 12) 0 rgba(0, 0, 0, 0.4);
  }

  .btn-side.btn-back {
    bottom: calc(10% + (100vw / 320 * 62));
  }

  #header {
    padding: calc(100vw / 320 * 13) 0;
    border-top-width: calc(100vw / 320 * 3);
  }

  #header .wrap {
    padding: 0 calc(100vw / 320 * 13);
  }

  #header .logo {
    width: calc(100vw / 320 * 212);
  }

  #header .btn-ham {
    width: calc(100vw / 320 * 40);
    height: calc(100vw / 320 * 40);
  }

  #header #tools-menu {
    padding: calc(100vw / 320 * 20) calc(100vw / 320 * 20) calc(100vw / 320 * 30);
    font-size: 1em;
  }

  #header #tools-menu::before {
    height: calc(100vw / 320 * 1);
    width: calc(100% - (100vw / 320 * 40));
    left: calc(100vw / 320 * 20);
  }

  #header #tools-menu li::before {
    height: calc(100vw / 320 * 14);
    width: calc(100vw / 320 * 1);
  }

  #header #tools-menu li a {
    padding: calc(100vw / 320 * 2) calc(100vw / 320 * 6);
  }

  #header #tools-menu li a.sub-arrow::after {
    margin-left: calc(100vw / 320 * 4);
    border-width: calc(100vw / 320 * 6) calc(100vw / 320 * 4);
    margin-top: calc(100vw / 320 * 6);
  }

  #header #tools-menu li a i {
    width: calc(100vw / 320 * 20);
    height: calc(100vw / 320 * 16);
    margin-right: calc(100vw / 320 * 4);
  }

  #header #tools-menu li a i svg {
    width: calc(100vw / 320 * 20);
    height: calc(100vw / 320 * 16);
  }

  #header #tools-menu li .sub a {
    padding: calc(100vw / 320 * 6) calc(100vw / 320 * 40) calc(100vw / 320 * 6) calc(100vw / 320 * 6);
  }

  #header #tools-menu li.setting {
    margin-top: calc(100vw / 320 * 30);
  }

  #header #tools-menu li.setting .setting-name {
    margin-right: calc(100vw / 320 * 4);
  }

  #header #tools-menu li.setting .setting-name i {
    margin-right: calc(100vw / 320 * 4);
  }

  #header #tools-menu li.setting .setting-name i img {
    width: calc(100vw / 320 * 15);
    display: inline-block;
    vertical-align: top;
    margin-top: calc(100vw / 320 * 5);
  }

  #header #tools-menu li.setting a {
    width: calc(100vw / 320 * 40);
    height: calc(100vw / 320 * 40);
    line-height: calc(100vw / 320 * 37);
    border-width: calc(100vw / 320 * 1);
    margin-left: calc(100vw / 320 * 10);
  }

  #header.page-header .logo {
    width: calc(100vw / 320 * 212);
  }

  #menu {
    padding-top: calc(100vw / 320 * 69);
    padding-bottom: calc(100vw / 320 * 178);
    font-size: 1em;
  }

  #menu ul li a {
    padding: calc(100vw / 320 * 16) calc(100vw / 320 * 49) calc(100vw / 320 * 16) calc(100vw / 320 * 22);
  }

  #menu ul li .sub>li {
    border-bottom-width: calc(100vw / 320 * 1);
  }

  #menu ul li .sub>li>a::before {
    width: calc(100vw / 320 * 9);
    height: calc(100vw / 320 * 13);
    left: calc(100vw / 320 * 22);
    top: calc(100vw / 320 * 21);
  }

  #menu ul li .sub>li>a.sub-arrow::after {
    width: calc(100vw / 320 * 25);
    height: calc(100vw / 320 * 25);
    right: calc(100vw / 320 * 16);
    top: calc(100vw / 320 * 16);
  }

  #menu ul li .sub a {
    padding: calc(100vw / 320 * 16) calc(100vw / 320 * 49) calc(100vw / 320 * 16) calc(100vw / 320 * 40);
  }

  #menu ul li .sub .sub li {
    border-top-width: calc(100vw / 320 * 1);
  }

  #menu ul li .sub .sub li a {
    padding-right: calc(100vw / 320 * 49);
  }

  #menu .search-block {
    padding: calc(100vw / 320 * 12);
  }

  #menu .search-block .wrap #S {
    line-height: calc(100vw / 320 * 38);
  }

  #menu .search-block .wrap input {
    border-top-left-radius: calc(100vw / 320 * 50);
    border-bottom-left-radius: calc(100vw / 320 * 50);
    border-width: calc(100vw / 320 * 1);
    width: calc(100% - (100vw / 320 * 100));
    height: calc(100vw / 320 * 40);
    padding: 0 calc(100vw / 320 * 20);
    margin-left: calc(100vw / 320 * 5);
  }

  #menu .search-block .wrap .btn {
    border-top-right-radius: calc(100vw / 320 * 50);
    border-bottom-right-radius: calc(100vw / 320 * 50);
    border-width: calc(100vw / 320 * 1);
    width: calc(100vw / 320 * 90);
  }

  #menu .search-block .wrap .btn i {
    width: calc(100vw / 320 * 20);
    margin-right: calc(100vw / 320 * 4);
  }

  #menu .search-block .wrap .btn i img {
    width: calc(100vw / 320 * 20);
  }

  #menu>ul>li {
    border-bottom-width: calc(100vw / 320 * 1);
  }

  #menu>ul>li>a.sub-arrow::after {
    width: calc(100vw / 320 * 25);
    height: calc(100vw / 320 * 25);
    right: calc(100vw / 320 * 16);
    top: calc(100vw / 320 * 16);
  }

  #footer {
    padding-top: calc(100vw / 320 * 12);
    margin-top: calc(100vw / 320 * 40);
  }

  #footer .wrap {
    padding: 0 calc(100vw / 320 * 12);
  }

  #footer a {
    padding: 0 calc(100vw / 320 * 3);
  }

  #footer .footer-top {
    gap: calc(100vw / 320 * 15) calc(100vw / 320 * 8);
    padding-bottom: calc(100vw / 320 * 12);
  }

  #footer .footer-top .footer-logo {
    width: calc(100vw / 320 * 212);
  }

  #footer .footer-top .footer-info {
    font-size: 0.75em;
  }

  #footer .footer-top .footer-info .footer-menu {
    flex-wrap: wrap;
  }

  #footer .footer-top .footer-info .footer-menu li::before {
    height: calc(100vw / 320 * 12);
    width: calc(100vw / 320 * 1);
  }

  #footer .footer-top .footer-info .footer-menu li a {
    padding: calc(100vw / 320 * 1) calc(100vw / 320 * 8);
  }

  #footer .footer-top .footer-logo-group {
    gap: 0 calc(100vw / 320 * 8);
  }

  #footer .footer-top .footer-logo-group a:first-child {
    width: calc(100vw / 320 * 38);
  }

  #footer .footer-top .footer-logo-group a:nth-child(2) {
    width: calc(100vw / 320 * 87);
  }

  #footer .footer-bottom {
    border-top-width: calc(100vw / 320 * 1);
    padding: calc(100vw / 320 * 20) calc(100vw / 320 * 8) calc(100vw / 320 * 12);
  }

  #footer .footer-bottom li {
    padding-left: calc(100vw / 320 * 8);
    padding-right: calc(100vw / 320 * 5);
  }

  #footer .footer-bottom li::before {
    height: calc(100vw / 320 * 12);
    width: calc(100vw / 320 * 1);
    top: calc(100vw / 320 * 10);
  }

  #footer .footer-bottom li:nth-child(2)::after {
    margin-bottom: calc(100vw / 320 * 8);
  }

  #footer .footer-bottom li p {
    margin-top: calc(100vw / 320 * 4) 0;
    display: block;
  }

  #footer .footer-bottom li p+p {
    margin-left: 0;
  }

  input,
  select {
    border-width: calc(100vw / 320 * 1);
    padding: calc(100vw / 320 * 2) calc(100vw / 320 * 10) 0;
    border-radius: calc(100vw / 320 * 4);
    height: calc(100vw / 320 * 40);
    line-height: calc(100vw / 320 * 40);
  }

  input.datepicker {
    padding: 0 calc(100vw / 320 * 30) 0 calc(100vw / 320 * 20);
    background-position: calc(100% - (100vw / 320 * 10)) center;
    background-size: calc(100vw / 320 * 16) auto;
  }

  select {
    padding: 0 calc(100vw / 320 * 30) 0 calc(100vw / 320 * 20);
    background-position: calc(100% - (100vw / 320 * 10)) center;
    background-size: calc(100vw / 320 * 14) auto;
  }

  textarea {
    height: calc(100vw / 320 * 80);
  }

  .checkbox-item>input+label,
  .radio-item>input+label {
    padding-left: calc(100vw / 320 * 30);
    line-height: calc(100vw / 320 * 20);
  }

  .checkbox-item>input+label::before,
  .radio-item>input+label::before {
    width: calc(100vw / 320 * 20);
    height: calc(100vw / 320 * 20);
  }

  .checkbox-group.group-inline,
  .radio-group.group-inline {
    gap: calc(100vw / 320 * 8);
    flex-direction: column;
  }

  .checkbox-group .checkbox-group,
  .checkbox-group .radio-group,
  .radio-group .checkbox-group,
  .radio-group .radio-group {
    padding-left: calc(100vw / 320 * 30);
  }

  .radio-list {
    border-width: calc(100vw / 320 * 1);
  }

  .radio-list .radio-item {
    border-width: calc(100vw / 320 * 1);
  }

  .radio-list .radio-item input+label {
    display: flex;
    flex-direction: column;
    gap: calc(100vw / 320 * 8);
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 10) calc(100vw / 320 * 12) calc(100vw / 320 * 40);
  }

  .radio-list .radio-item input+label::before {
    left: calc(100vw / 320 * 10);
    top: calc(100vw / 320 * 12);
  }

  .radio-list .radio-item input+label .label-item {
    width: 100% !important;
  }

  .btn {
    border-radius: calc(100vw / 320 * 50);
    padding: 0 calc(100vw / 320 * 12);
  }

  .btn.btn-lg {
    width: 100%;
    display: flex;
    margin: calc(100vw / 320 * 20) 0;
    border-width: calc(100vw / 320 * 1);
    padding: calc(100vw / 320 * 10);
  }

  .btn.btn-lg i {
    width: calc(100vw / 320 * 16);
    height: calc(100vw / 320 * 16);
    margin-right: calc(100vw / 320 * 5);
  }

  .page-container {
    padding-top: calc(100vw / 320 * 13);
    background: none;
  }

  .page-container #page-main .breadcrumbs {
    margin-bottom: calc(100vw / 320 * 30);
    font-size: 0.75em;
  }

  .page-container #page-main .breadcrumbs li a {
    padding: calc(100vw / 320 * 2) calc(100vw / 320 * 4);
    border-radius: calc(100vw / 320 * 4);
    max-width: calc(100vw / 320 * 200);
  }

  .page-container #page-main .breadcrumbs li::before {
    width: calc(100vw / 320 * 6);
    height: calc(100vw / 320 * 10);
    margin: 0 calc(100vw / 320 * 3);
  }

  .page-container #page-main .breadcrumbs li:last-child {
    padding: calc(100vw / 320 * 2) 0;
  }

  .page-container #page-main .breadcrumbs li i {
    margin-top: calc(100vw / 320 * 1);
    width: calc(100vw / 320 * 14);
    height: calc(100vw / 320 * 14);
  }

  .page-container #page-main .breadcrumbs li i svg {
    width: calc(100vw / 320 * 14);
    height: calc(100vw / 320 * 14);
  }

  .page-container #page-main .page-content .page-title {
    padding-left: calc(100vw / 320 * 55);
    margin-bottom: calc(100vw / 320 * 16);
    display: block;
  }

  .page-container #page-main .page-content .page-title::before {
    width: calc(100vw / 320 * 35);
    height: calc(100vw / 320 * 35);
    left: calc(100vw / 320 * 12);
    top: calc(100vw / 320 * 2);
  }

  .page-container #page-main .page-content .page-title .btn {
    display: flex;
    padding: calc(100vw / 320 * 3) calc(100vw / 320 * 20);
    box-shadow: calc(100vw / 320 * 6) calc(100vw / 320 * 6) 0px 0px rgba(0, 0, 0, 0.06);
    margin: calc(100vw / 320 * 16) 0 calc(100vw / 320 * 30) calc(100vw / 320 * -55);
  }

  .page-container #page-main .page-content .page-title .btn i {
    width: calc(100vw / 320 * 45);
    height: calc(100vw / 320 * 45);
    margin-right: calc(100vw / 320 * 2);
  }

  .page-container #page-main .page-content .tabs {
    margin-top: calc(100vw / 320 * 14);
  }

  .page-container #page-main .page-content .tabs .tabs-nav {
    padding: 0 calc(100vw / 320 * 8);
    border-bottom-width: calc(100vw / 320 * 3);
  }

  .page-container #page-main .page-content .tabs .tabs-nav a {
    border-width: calc(100vw / 320 * 1) calc(100vw / 320 * 1) 0 calc(100vw / 320 * 1);
    min-width: calc(100vw / 320 * 75);
    padding: calc(100vw / 320 * 12);
    border-radius: calc(100vw / 320 * 20) calc(100vw / 320 * 20) 0 0;
    margin: 0 calc(100vw / 320 * 1);
  }

  .page-container #page-main .page-content .tabs .tabs-nav a.active::before {
    width: calc(100vw / 320 * 6);
    height: calc(100vw / 320 * 6);
    margin-right: calc(100vw / 320 * 5);
    margin-top: calc(100vw / 320 * 8);
  }

  .page-container #page-main .page-content .tabs .tabs-nav a.active::after {
    border-width: calc(100vw / 320 * 3) 0 0 0;
    border-radius: calc(100vw / 320 * 18) calc(100vw / 320 * 18) 0 0;
  }

  .page-container #page-main .page-content .tabs.tabs-apply {
    margin: calc(100vw / 320 * 30) auto 0;
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-nav a {
    font-size: 0.875em;
    padding: calc(100vw / 320 * 12);
    margin: 0 !important;
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content {
    border-width: calc(100vw / 320 * 2);
    box-shadow: calc(100vw / 320 * 6) calc(100vw / 320 * 6) 0px 0px rgba(0, 0, 0, 0.06);
    padding: calc(100vw / 320 * 24) calc(100vw / 320 * 12) calc(100vw / 320 * 28);
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .top-block {
    margin-bottom: calc(100vw / 320 * 24);
    flex-direction: column;
    justify-content: center;
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .top-block .name {
    font-size: 1.375em;
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .top-block .btn {
    margin-top: calc(100vw / 320 * 12);
    box-shadow: calc(100vw / 320 * 6) calc(100vw / 320 * 6) 0px 0px rgba(0, 0, 0, 0.06);
    padding: calc(100vw / 320 * 10) calc(100vw / 320 * 24);
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .btn {
    padding: calc(100vw / 320 * 9) calc(100vw / 320 * 16);
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content {
    font-size: 0.875em;
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row {
    margin: calc(100vw / 320 * 12) 0;
    gap: calc(100vw / 320 * 5) 0;
    flex-wrap: wrap;
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .name {
    width: 100%;
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row {
    padding-left: 0;
    gap: calc(100vw / 320 * 12);
    flex-wrap: wrap;
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row.code-row input {
    width: 100%;
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row.code-row .img-code {
    width: calc(100vw / 320 * 100);
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row.code-row .btn {
    flex: 1;
  }

  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .checkbox-item,
  .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .radio-item {
    padding: calc(100vw / 320 * 10) 0;
  }

  .page-container #page-main .page-content .news-list .news-item {
    border-bottom-width: calc(100vw / 320 * 1);
  }

  .page-container #page-main .page-content .news-list .news-item.news-img-left .news-text {
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 8) calc(100vw / 320 * 12) calc(100vw / 320 * 154);
    min-height: calc(100vw / 320 * 131);
  }

  .page-container #page-main .page-content .news-list .news-item.news-img-top .news-img {
    width: calc(100vw / 320 * 280);
    height: calc(100vw / 320 * 214);
    left: 50%;
    transform: translateX(-50%);
  }

  .page-container #page-main .page-content .news-list .news-item.news-img-top .news-img img {
    height: calc(100vw / 320 * 214);
  }

  .page-container #page-main .page-content .news-list .news-item.news-img-top .news-img.icon-video::after {
    width: calc(100vw / 320 * 80);
    height: calc(100vw / 320 * 80);
    background-size: calc(100vw / 320 * 48) calc(100vw / 320 * 48);
  }

  .page-container #page-main .page-content .news-list .news-item.news-img-top .news-text {
    padding: calc(100vw / 320 * 232) calc(100vw / 320 * 8) calc(100vw / 320 * 12);
  }

  .page-container #page-main .page-content .news-list .news-item .news-img {
    width: calc(100vw / 320 * 140);
    height: calc(100vw / 320 * 107);
    border-width: calc(100vw / 320 * 1);
    left: calc(100vw / 320 * 8);
    top: calc(100vw / 320 * 12);
  }

  .page-container #page-main .page-content .news-list .news-item .news-img.icon-video::after {
    width: calc(100vw / 320 * 50);
    height: calc(100vw / 320 * 50);
    background-size: calc(100vw / 320 * 32) calc(100vw / 320 * 32);
    border-width: calc(100vw / 320 * 2);
  }

  .page-container #page-main .page-content .news-list .news-item .news-img img {
    height: calc(100vw / 320 * 107);
  }

  .page-container #page-main .page-content .news-list .news-item .news-text {
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 8);
  }

  .page-container #page-main .page-content .news-list .news-item .news-text .news-name {
    margin-bottom: calc(100vw / 320 * 4);
    font-size: 1em;
  }

  .page-container #page-main .page-content .news-list .news-item .news-text p {
    font-size: 0.75em;
  }

  .page-container #page-main .page-content .news-list .news-item .news-text .news-bottom {
    margin-top: calc(100vw / 320 * 10);
    margin-bottom: 0;
  }

  .page-container #page-main .page-content .news-list .news-item .news-text .news-bottom .btn-more::before {
    width: calc(100vw / 320 * 12);
    height: calc(100vw / 320 * 12);
    background-size: auto calc(100vw / 320 * 5);
    margin-top: calc(100vw / 320 * 4);
  }

  .page-container #page-main .page-content .media-list {
    gap: calc(100vw / 320 * 12) 0;
    margin: calc(100vw / 320 * 14) 0 0;
  }

  .page-container #page-main .page-content .media-list .media-item {
    border-width: calc(100vw / 320 * 1);
    box-shadow: calc(100vw / 320 * 6) calc(100vw / 320 * 6) 0px 0px rgba(0, 0, 0, 0.06);
    padding: calc(100vw / 320 * 16);
    width: 100%;
    margin: 0;
  }

  .page-container #page-main .page-content .media-list .media-item .media-img {
    border-width: calc(100vw / 320 * 1);
    margin-bottom: calc(100vw / 320 * 12);
    padding-top: 60%;
  }

  .page-container #page-main .page-content .media-list .media-item .media-img::after {
    width: calc(100vw / 320 * 80);
    height: calc(100vw / 320 * 80);
    background-size: calc(100vw / 320 * 48) calc(100vw / 320 * 48);
    border-width: calc(100vw / 320 * 2);
  }

  .page-container #page-main .page-content .media-list .media-item .media-text .media-name {
    margin-bottom: calc(100vw / 320 * 9);
  }

  .page-container #page-main .page-content .media-list .media-item .media-text .media-tag {
    padding: calc(100vw / 320 * 4) calc(100vw / 320 * 8) calc(100vw / 320 * 5) calc(100vw / 320 * 26);
  }

  .page-container #page-main .page-content .media-list .media-item .media-text .media-tag::before {
    width: calc(100vw / 320 * 12);
    height: calc(100vw / 320 * 14);
    left: calc(100vw / 320 * 8);
  }

  .page-container #page-main .page-content .download-list li+li {
    border-top-width: calc(100vw / 320 * 1);
  }

  .page-container #page-main .page-content .download-list li a {
    padding: calc(100vw / 320 * 12);
    min-height: calc(100vw / 320 * 69);
  }

  .page-container #page-main .page-content .download-list li a .name {
    width: calc(100% - (100vw / 320 * 65));
    padding-left: calc(100vw / 320 * 37);
  }

  .page-container #page-main .page-content .download-list li a .name::before {
    width: calc(100vw / 320 * 25);
    height: calc(100vw / 320 * 20);
  }

  .page-container #page-main .page-content .download-list li a::after {
    width: calc(100vw / 320 * 45);
    height: calc(100vw / 320 * 45);
    margin-left: calc(100vw / 320 * 20);
  }

  .page-container #page-main .page-content .books-list {
    gap: calc(100vw / 320 * 40) 0;
    margin: calc(100vw / 320 * 30) 0;
    padding-right: calc(100vw / 320 * 10);
  }

  .page-container #page-main .page-content .books-list .book-item {
    width: calc(100% / 2);
    margin: 0;
    padding-left: calc(100vw / 320 * 60);
  }

  .page-container #page-main .page-content .books-list .book-item .book-img {
    margin-bottom: calc(100vw / 320 * 14);
  }

  .page-container #page-main .page-content .books-list .book-item .book-text {
    margin-left: calc(100vw / 320 * -15);
    font-size: 0.875em;
  }

  .page-container #page-main .page-content .books-list .book {
    width: calc(100vw / 320 * 70);
    height: calc(100vw / 320 * 96);
  }

  .page-container #page-main .page-content .books-list .book-front {
    transform: rotateY(-34deg) translateZ(calc(100vw / 320 * 6));
  }

  .page-container #page-main .page-content .books-list .book-front li:first-child {
    transform: translateZ(calc(100vw / 320 * 2));
  }

  .page-container #page-main .page-content .books-list .book-front li:first-child::before,
  .page-container #page-main .page-content .books-list .book-front li:first-child::after {
    width: calc(100vw / 320 * 3);
  }

  .page-container #page-main .page-content .books-list .book-front li:first-child::after {
    transform: rotateY(90deg) translateZ(calc(100vw / 320 * -2)) translateX(calc(100vw / 320 * 2));
  }

  .page-container #page-main .page-content .books-list .book-front li:first-child::before {
    transform: rotateY(90deg) translateZ(calc(100vw / 320 * 69)) translateX(calc(100vw / 320 * 2));
  }

  .page-container #page-main .page-content .books-list .book-front li:last-child {
    transform: rotateY(180deg) translateZ(calc(100vw / 320 * 2));
  }

  .page-container #page-main .page-content .books-list .book-front li:last-child::before,
  .page-container #page-main .page-content .books-list .book-front li:last-child::after {
    width: calc(100vw / 320 * 3);
    height: calc(100vw / 320 * 70);
  }

  .page-container #page-main .page-content .books-list .book-front li:last-child::after {
    transform: rotateX(90deg) rotateZ(90deg) translateZ(calc(100vw / 320 * 35)) translateX(calc(100vw / 320 * -2)) translateY(calc(100vw / 320 * -34));
  }

  .page-container #page-main .page-content .books-list .book-front li:last-child::before {
    box-shadow: 0px 0px calc(100vw / 320 * 24) calc(100vw / 320 * 5) #999;
    transform: rotateX(90deg) rotateZ(90deg) translateZ(calc(100vw / 320 * -62)) translateX(calc(100vw / 320 * -2)) translateY(calc(100vw / 320 * -34));
  }

  .page-container #page-main .page-content .books-list .book-back {
    transform: rotateY(-15deg) translateZ(calc(100vw / 320 * -6));
  }

  .page-container #page-main .page-content .books-list .book-back li:first-child {
    transform: translateZ(calc(100vw / 320 * 3));
  }

  .page-container #page-main .page-content .books-list .book-back li:first-child::before,
  .page-container #page-main .page-content .books-list .book-back li:first-child::after {
    width: calc(100vw / 320 * 3);
  }

  .page-container #page-main .page-content .books-list .book-back li:first-child::after {
    transform: rotateY(90deg) translateZ(calc(100vw / 320 * -2)) translateX(calc(100vw / 320 * 2));
  }

  .page-container #page-main .page-content .books-list .book-back li:first-child::before {
    transform: rotateY(90deg) translateZ(calc(100vw / 320 * 69)) translateX(calc(100vw / 320 * 2));
  }

  .page-container #page-main .page-content .books-list .book-back li:last-child {
    transform: translateZ(calc(100vw / 320 * -3));
  }

  .page-container #page-main .page-content .books-list .book-back li:last-child::before,
  .page-container #page-main .page-content .books-list .book-back li:last-child::after {
    width: calc(100vw / 320 * 3);
    height: calc(100vw / 320 * 70);
  }

  .page-container #page-main .page-content .books-list .book-back li:last-child::after {
    transform: rotateX(90deg) rotateZ(90deg) translateZ(calc(100vw / 320 * 35)) translateX(calc(100vw / 320 * 2)) translateY(calc(100vw / 320 * -34));
  }

  .page-container #page-main .page-content .books-list .book-back li:last-child::before {
    box-shadow: calc(100vw / 320 * 10) calc(100vw / 320 * -1) calc(100vw / 320 * 32) calc(100vw / 320 * 10) #999;
    transform: rotateX(90deg) rotateZ(90deg) translateZ(calc(100vw / 320 * -62)) translateX(calc(100vw / 320 * 2)) translateY(calc(100vw / 320 * -34));
  }

  .page-container #page-main .page-content .books-list .book-spine {
    transform: rotateY(60deg) translateX(calc(100vw / 320 * -3)) translateZ(calc(100vw / 320 * -8));
    width: calc(100vw / 320 * 12);
  }

  .page-container #page-main .page-content .books-list .book-spine li:first-child {
    transform: translateZ(calc(100vw / 320 * 2));
  }

  .page-container #page-main .page-content .books-list .book-spine li:first-child::before,
  .page-container #page-main .page-content .books-list .book-spine li:first-child::after {
    width: calc(100vw / 320 * 3);
  }

  .page-container #page-main .page-content .books-list .book-spine li:first-child::after {
    transform: rotateY(90deg) translateZ(calc(100vw / 320 * -2)) translateX(calc(100vw / 320 * 2));
  }

  .page-container #page-main .page-content .books-list .book-spine li:first-child::before {
    transform: rotateY(-90deg) translateZ(calc(100vw / 320 * -8));
  }

  .page-container #page-main .page-content .books-list .book-spine li:last-child {
    transform: translateZ(calc(100vw / 320 * -2));
  }

  .page-container #page-main .page-content .books-list .book-spine li:last-child::before,
  .page-container #page-main .page-content .books-list .book-spine li:last-child::after {
    width: calc(100vw / 320 * 3);
    height: calc(100vw / 320 * 12);
  }

  .page-container #page-main .page-content .books-list .book-spine li:last-child::after {
    transform: rotateX(90deg) rotateZ(90deg) translateZ(calc(100vw / 320 * 6)) translateX(calc(100vw / 320 * 2)) translateY(calc(100vw / 320 * -5));
  }

  .page-container #page-main .page-content .books-list .book-spine li:last-child::before {
    box-shadow: calc(100vw / 320 * 5) calc(100vw / 320 * -1) calc(100vw / 320 * 40) calc(100vw / 320 * 16) rgba(0, 0, 0, 0.2);
    transform: rotateX(90deg) rotateZ(90deg) translateZ(calc(100vw / 320 * -92)) translateX(calc(100vw / 320 * 2)) translateY(calc(100vw / 320 * -5));
  }

  .page-container #page-main .page-content .books-list .book-content li {
    box-shadow: inset 0px calc(100vw / 320 * -1) calc(100vw / 320 * 2) rgba(50, 50, 50, 0.1),
      inset calc(100vw / 320 * -1) 0px calc(100vw / 320 * 1) rgba(150, 150, 150, 0.2);
    border-radius: 0px calc(100vw / 320 * 5) calc(100vw / 320 * 5) 0px;
  }

  .page-container #page-main .page-content .books-list .book-btn {
    border-width: calc(100vw / 320 * 2);
    padding: calc(100vw / 320 * 1) calc(100vw / 320 * 2);
    font-size: 0.75em;
  }

  .page-container #page-main .page-content .faq-list {
    margin-top: calc(100vw / 320 * 30);
  }

  .page-container #page-main .page-content .faq-list .faq-item {
    border-width: calc(100vw / 320 * 1);
    border-radius: calc(100vw / 320 * 10);
    box-shadow: calc(100vw / 320 * 6) calc(100vw / 320 * 6) 0 0 rgba(93, 107, 192, 0.06);
    margin-bottom: calc(100vw / 320 * 16);
  }

  .page-container #page-main .page-content .faq-list .faq-item.active .faq-header {
    border-radius: calc(100vw / 320 * 10) calc(100vw / 320 * 10) 0 0;
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header {
    padding: calc(100vw / 320 * 16) calc(100vw / 320 * 58) calc(100vw / 320 * 16) calc(100vw / 320 * 12);
    border-radius: calc(100vw / 320 * 10);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header::after {
    width: calc(100vw / 320 * 36);
    height: calc(100vw / 320 * 36);
    right: calc(100vw / 320 * 12);
    top: calc(100vw / 320 * 16);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .icon {
    width: calc(100vw / 320 * 35);
    height: calc(100vw / 320 * 35);
    margin-top: 0;
    margin-right: calc(100vw / 320 * 10);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .name {
    width: calc(100% - (100vw / 320 * 45));
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .name .top {
    margin-bottom: calc(100vw / 320 * 5);
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: calc(100vw / 320 * 6);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .name .top .tag {
    font-size: 0.75em;
    padding: calc(100vw / 320 * 4) calc(100vw / 320 * 8);
    border-radius: calc(100vw / 320 * 30);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .name .top .tag i {
    width: calc(100vw / 320 * 10);
    height: calc(100vw / 320 * 10);
    margin-right: calc(100vw / 320 * 5);
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-header .name p {
    font-size: 1em;
    padding-left: 0;
  }

  .page-container #page-main .page-content .faq-list .faq-item .faq-content {
    margin: 0 0 calc(100vw / 320 * 16) calc(100vw / 320 * 20);
    padding: 0 calc(100vw / 320 * 16);
    border-left-width: calc(100vw / 320 * 1);
  }

  .page-container #page-main .page-content .pagination {
    margin-top: calc(100vw / 320 * 42);
    padding: 0;
  }

  .page-container #page-main .page-content .pagination .pagination-num {
    gap: 0 calc(100vw / 320 * 6);
    margin-bottom: calc(100vw / 320 * 23);
    font-size: 0.875em;
  }

  .page-container #page-main .page-content .pagination .pagination-num li a,
  .page-container #page-main .page-content .pagination .pagination-num li span {
    border-width: calc(100vw / 320 * 1);
    border-radius: calc(100vw / 320 * 4);
    line-height: calc(100vw / 320 * 38);
    min-width: calc(100vw / 320 * 40);
    padding: 0 calc(100vw / 320 * 10);
  }

  .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow {
    width: auto;
    padding: 0 calc(100vw / 320 * 10);
  }

  .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-prev {
    border-radius: calc(100vw / 320 * 40) calc(100vw / 320 * 4) calc(100vw / 320 * 4) calc(100vw / 320 * 40);
  }

  .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-prev::before {
    width: calc(100vw / 320 * 8);
    height: calc(100vw / 320 * 11);
    margin-right: calc(100vw / 320 * 5);
    margin-top: calc(100vw / 320 * 14);
  }

  .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-next {
    border-radius: calc(100vw / 320 * 4) calc(100vw / 320 * 40) calc(100vw / 320 * 40) calc(100vw / 320 * 4);
  }

  .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-next::after {
    width: calc(100vw / 320 * 8);
    height: calc(100vw / 320 * 11);
    margin-left: calc(100vw / 320 * 5);
    margin-top: calc(100vw / 320 * 14);
  }

  .page-container #page-main .page-content .pagination .pagination-page {
    font-size: 0.875em;
  }

  .page-container #page-main .page-content .pagination .pagination-page label,
  .page-container #page-main .page-content .pagination .pagination-page span {
    margin: 0 calc(100vw / 320 * 5);
  }

  .page-container #page-main .page-content .pagination .pagination-page input {
    width: calc(100vw / 320 * 100);
    border-width: calc(100vw / 320 * 1);
    border-radius: calc(100vw / 320 * 4);
    padding: calc(100vw / 320 * 2) calc(100vw / 320 * 5) 0;
    line-height: calc(100vw / 320 * 35);
    height: auto;
  }

  .page-container #page-main .page-content .pagination .pagination-page .btn {
    display: block;
    margin-left: 0;
    padding-top: calc(100vw / 320 * 3);
    line-height: calc(100vw / 320 * 37);
    width: 100%;
    margin-top: calc(100vw / 320 * 23);
  }

  .page-container #page-main .page-content .block-content {
    margin-top: calc(100vw / 320 * 14);
    padding: calc(100vw / 320 * 20) calc(100vw / 320 * 12);
  }

  .page-container #page-main .page-content .block-content p {
    font-size: 0.875em;
  }

  .page-container #page-main .page-content .color-block {
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 20);
  }

  .page-container #page-main .page-content table {
    margin-bottom: calc(100vw / 320 * 13);
    font-size: 0.875em;
  }

  .page-container #page-main .page-content table.table-sm .btn {
    padding: calc(100vw / 320 * 8) calc(100vw / 320 * 10);
    width: 100%;
    display: block;
  }

  .page-container #page-main .page-content table.table-sm .btn+.btn {
    margin-top: calc(100vw / 320 * 10);
    margin-left: 0;
  }

  .page-container #page-main .page-content table.table-horizontal {
    border: none;
    font-size: 0.875em;
  }

  .page-container #page-main .page-content table.table-horizontal tbody td {
    padding: calc(100vw / 320 * 10) calc(100vw / 320 * 10) calc(100vw / 320 * 10) calc(100vw / 320 * 130);
    text-align: left;
    display: block;
    position: relative;
    overflow: hidden;
  }

  .page-container #page-main .page-content table.table-horizontal tbody td::before {
    padding: calc(100vw / 320 * 10);
    width: calc(100vw / 320 * 100);
    position: absolute;
    background-color: #5d6bc0;
    color: #fff;
    content: attr(data-name);
    left: 0;
    top: 0;
    height: 100%;
  }

  .page-container #page-main .page-content table.table-horizontal tbody tr {
    display: block;
    margin-bottom: calc(100vw / 320 * 6);
    border: calc(100vw / 320 * 1) solid #5d6bc0;
  }

  .page-container #page-main .page-content table.table-horizontal thead {
    display: none;
  }

  .page-container #page-main .page-content table.table-straight tbody td {
    display: block;
  }

  .page-container #page-main .page-content table.table-straight tbody td.name {
    width: 100%;
  }

  .page-container #page-main .page-content table.table-straight tr {
    border-bottom: none;
  }

  .page-container #page-main .page-content table tbody td {
    padding: calc(100vw / 320 * 8) calc(100vw / 320 * 12);
    border-bottom-width: calc(100vw / 320 * 1);
  }

  .page-container #page-main .page-content table i {
    width: calc(100vw / 320 * 14);
    height: calc(100vw / 320 * 16);
    margin-right: calc(100vw / 320 * 6);
    margin-top: calc(100vw / 320 * 5);
  }

  .page-container #page-main .page-content table .download-list {
    margin: calc(100vw / 320 * -8) calc(100vw / 320 * -12) !important;
  }

  .page-container #page-main .page-content table .download-list li a {
    min-height: calc(100vw / 320 * 50);
    padding: calc(100vw / 320 * 8) calc(100vw / 320 * 12);
  }

  .page-container #page-main .page-content table .download-list li a .name {
    width: calc(100% - (100vw / 320 * 40));
    padding-left: 0;
  }

  .page-container #page-main .page-content table .download-list li a .name::before {
    display: none;
  }

  .page-container #page-main .page-content table .download-list li a::after {
    width: calc(100vw / 320 * 30);
    height: calc(100vw / 320 * 30);
    margin-left: calc(100vw / 320 * 10);
  }

  .page-container #page-main .page-content table .tag-y {
    padding: calc(100vw / 320 * 5) calc(100vw / 320 * 10);
    border-radius: calc(100vw / 320 * 50);
    margin-bottom: calc(100vw / 320 * 4);
  }

  .page-container #page-main .page-content table .tag-y i {
    width: calc(100vw / 320 * 10);
    height: calc(100vw / 320 * 13);
    margin-right: calc(100vw / 320 * 4);
  }

  .page-container #page-main .page-content table .text-limit {
    -webkit-line-clamp: 3;
    min-height: 4.5em;
  }

  .page-container #page-main .page-content .article figure {
    margin: 0 0 calc(100vw / 320 * 16);
  }

  .page-container #page-main .page-content .article p {
    margin-bottom: calc(100vw / 320 * 16);
  }

  .page-container #page-main .page-content .article .h3 {
    font-size: 1.143em;
  }

  .page-container #page-main .page-content .tag-list {
    padding: 0;
    margin-bottom: calc(100vw / 320 * 20);
    margin-top: 0;
  }

  .page-container #page-main .page-content .tag-list .tag-item {
    padding: calc(100vw / 320 * 16) calc(100vw / 320 * 12) 0;
    width: 100% !important;
    border-bottom: none;
    font-size: 0.875em;
  }

  .page-container #page-main .page-content .tag-list .tag-item .tag-name {
    box-shadow: calc(100vw / 320 * 4) calc(100vw / 320 * 4) 0 0 rgba(0, 0, 0, 0.15);
    border-width: calc(100vw / 320 * 1);
    border-radius: 0 calc(100vw / 320 * 50) calc(100vw / 320 * 50) 0;
    padding: calc(100vw / 320 * 2) calc(100vw / 320 * 12) calc(100vw / 320 * 2) calc(100vw / 320 * 8);
    margin-bottom: calc(100vw / 320 * 12);
    font-size: 0.857em;
  }

  .page-container #page-main .page-content .tag-list .tag-item .tag-name::before {
    width: calc(100vw / 320 * 12);
    height: calc(100vw / 320 * 12);
    margin-right: calc(100vw / 320 * 8);
  }

  .page-container #page-main .page-content .tag-list .tag-item.tag-item-line,
  .page-container #page-main .page-content .tag-list .tag-item.m-tag-item-line {
    border-bottom: calc(100vw / 320 * 1) solid #c2c7f7;
    padding-bottom: calc(100vw / 320 * 16);
  }

  .page-container #page-main .page-content .tag-list .tag-item.m-tag-item-col6 {
    width: 50% !important;
  }

  .page-container #page-main .page-content .tag-list .tag-item .download-list li a {
    min-height: calc(100vw / 320 * 48);
  }

  .page-container #page-main .page-content .keyboard-tag {
    margin: calc(100vw / 320 * -7) calc(100vw / 320 * 5) 0;
    width: calc(100vw / 320 * 100);
    border-width: calc(100vw / 320 * 1);
    border-radius: calc(100vw / 320 * 5);
    padding: calc(100vw / 320 * 6) 0;
  }

  .page-container #page-main .page-content . btn-lg w-100 {
    margin-top: calc(100vw / 320 * 25);
  }

  .page-container #page-main .page-content .from-block .input-row {
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 8);
    gap: 0 calc(100vw / 320 * 8);
  }

  .page-container #page-main .page-content .keyboard-list {
    padding-left: 0 !important;
  }

  .page-container #page-main .page-content .keyboard-list li {
    flex-wrap: wrap;
    margin-bottom: calc(100vw / 320 * 24) !important;
  }

  .page-container #page-main .page-content .keyboard-list li .keyboard-text {
    width: calc(100% - (100vw / 320 * 110));
  }

  .page-container #page-main .page-content .keyboard-list li .keyboard-group {
    width: 100%;
    margin-bottom: calc(100vw / 320 * 5);
  }

  .page-container #page-main .page-content .keyboard-list li .keyboard-group+.keyboard-text {
    width: 100% !important;
  }

  .page-container #page-main .page-content .sitemap-list {
    margin-top: calc(100vw / 320 * 20);
    border-bottom-width: calc(100vw / 320 * 1);
  }

  .page-container #page-main .page-content .sitemap-list .sitemap-name {
    padding: calc(100vw / 320 * 5);
  }

  .page-container #page-main .page-content .sitemap-list .sitemap-name::before {
    width: calc(100vw / 320 * 40);
    height: calc(100vw / 320 * 40);
    margin-right: calc(100vw / 320 * 8);
  }

  .page-container #page-main .page-content .sitemap-list .link {
    padding: calc(100vw / 320 * 13) calc(100vw / 320 * 5);
  }

  .page-container #page-main .page-content .sitemap-list .row:nth-child(2n) {
    background-color: transparent;
  }

  .page-container #page-main .page-content .sitemap-list .row:nth-child(2n) .col-12 {
    background-color: #f7f7f7;
  }

  .page-container #page-main .page-content .sitemap-list .row .col {
    padding: calc(100vw / 320 * 16) calc(100vw / 320 * 15);
    border-top-width: calc(100vw / 320 * 1);
  }

  .page-container #page-main .page-content .sitemap-list .row .col-6:nth-child(2n) {
    background-color: #f7f7f7;
  }

  .page-container #page-main .article-main .article-top {
    margin-bottom: calc(100vw / 320 * 14);
  }

  .page-container #page-main .article-main .article-top .article-title {
    font-size: 1.25em;
    margin-bottom: calc(100vw / 320 * 4);
  }

  .page-container #page-main .article-main .article-top .article-sub-title {
    font-size: 1em;
  }

  .page-container #page-main .article-main .article-top .article-tag {
    padding: calc(100vw / 320 * 5) calc(100vw / 320 * 10);
    margin-bottom: calc(100vw / 320 * 8);
    font-size: 0.75em;
  }

  .page-container #page-main .article-main .article-top .article-tag i {
    width: calc(100vw / 320 * 9);
    height: calc(100vw / 320 * 12);
    margin-right: calc(100vw / 320 * 4);
  }

  .page-container #page-main .article-main .article-tag li {
    display: block;
    margin: 0 0 calc(100vw / 320 * 5);
  }

  .page-container #page-main .article-main .article-tag li::before {
    width: calc(100vw / 320 * 14);
    height: calc(100vw / 320 * 14);
    margin-right: calc(100vw / 320 * 6);
    display: inline-block;
    vertical-align: top;
    margin-top: 0.2em;
  }

  .page-container #page-main .article-main .article-tag li::after {
    display: none;
  }

  .page-container #page-main .article-main .article-wrap {
    /*margin-top: calc(100vw / 320 * 10);
    padding-top: calc(100vw / 320 * 10);
    border-top-width: calc(100vw / 320 * 1);*/
  }

  .page-container #page-main .article-main .article-wrap .article-share {
    border-radius: 0 calc(100vw / 320 * 50) calc(100vw / 320 * 50) 0;
    padding: calc(100vw / 320 * 13) calc(100vw / 320 * 16);
    gap: 0 calc(100vw / 320 * 15);
    margin-bottom: calc(100vw / 320 * 10);
  }

  .page-container #page-main .article-main .article-wrap .article-share a {
    width: calc(100vw / 320 * 35);
    height: calc(100vw / 320 * 35);
  }

  .page-container #page-main .article-main .article-wrap .article-content-top {
    border-top-width: calc(100vw / 320 * 2);
    border-bottom-width: calc(100vw / 320 * 2);
    padding: calc(100vw / 320 * 15) calc(100vw / 320 * 12);
  }

  .page-container #page-main .article-main .article-wrap .article-content-top .article-top-name {
    margin-bottom: calc(100vw / 320 * 6);
  }

  .page-container #page-main .article-main .article-wrap .article-content-top .article-top-block {
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 16);
    margin: calc(100vw / 320 * 12) 0;
  }

  .page-container #page-main .article-main .article-wrap .article-content-top .article-top-block .name {
    margin-bottom: calc(100vw / 320 * 4);
  }

  .page-container #page-main .article-main .article-wrap .article-content-top .article-tag {
    padding-left: calc(100vw / 320 * 15);
    padding-right: calc(100vw / 320 * 15);
  }

  .page-container #page-main .article-main .article-wrap .article-content-top+.article {
    padding-top: calc(100vw / 320 * 16);
  }

  .page-container #page-main .article-main .article-wrap .article-content-bottom {
    padding: calc(100vw / 320 * 20);
    flex-direction: column;
  }

  .page-container #page-main .article-main .article-wrap .article-content-bottom .article-bottom-img {
    width: 100%;
    margin-right: 0;
    margin-bottom: calc(100vw / 320 * 12);
  }

  .page-container #page-main .article-main .article-wrap .article-content-bottom .article-bottom-name {
    margin-bottom: calc(100vw / 320 * 8);
    font-size: 1em;
  }

  .page-container #page-main .article-main .article-wrap .article-content-bottom p {
    font-size: 0.875em;
  }

  .page-container #page-main .article-main .article-wrap .template-block {
    /*margin-top: calc(100vw / 320 *15);
    padding-top: calc(100vw / 320 * 15);*/
  }

  .page-container #page-main .article-main .article-wrap .template-block .template-name {
    margin-bottom: calc(100vw / 320 * 12);
  }

  .page-container #page-main .article-main .article-wrap .template-block .template-name::before {
    width: calc(100vw / 320 * 20);
    height: calc(100vw / 320 * 20);
    margin-right: calc(100vw / 320 * 8);
  }

  .page-container #page-main .article-main .article-wrap .template-block .template-name.icon-info::before {
    width: calc(100vw / 320 * 23);
    margin-top: calc(100vw / 320 * 2);
  }

  .page-container #page-main .article-main .article-wrap .template-block .download-list {
    border-top-width: calc(100vw / 320 * 1);
    border-bottom-width: calc(100vw / 320 * 1);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block {
    border-top-width: calc(100vw / 320 * 2);
    border-bottom-width: calc(100vw / 320 * 2);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .col-6+.col-6>.input-row {
    padding-top: 0;
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-group.row {
    width: 100%;
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-item,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .radio-item {
    padding: 0.2em 0 !important;
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-item label,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .radio-item label {
    padding-left: calc(100vw / 320 * 30);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-item label+label,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .radio-item label+label {
    margin-top: calc(100vw / 320 * 8);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>input,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>select,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>textarea,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.row,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.checkbox-group,
  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.radio-group {
    width: 100%;
    padding-left: calc(100vw / 320 * 16);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .radio-group {
    display: flex;
    flex-direction: column;
    gap: calc(100vw / 320 * 8);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .name {
    padding: 0;
    width: 100%;
    text-align: left !important;
    margin-bottom: calc(100vw / 320 * 5);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-sm {
    width: calc(100vw / 320 * 90);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-sm-auto {
    width: calc(100% - (100vw / 320 * 98));
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-md {
    width: 100% !important;
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-lg {
    width: 100% !important;
    margin-top: calc(100vw / 320 * 8);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .ps {
    padding-left: 0 !important;
    padding-top: calc(100vw / 320 * 2);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row {
    gap: calc(100vw / 320 * 8);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row .input-row {
    flex-direction: column;
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row .input-row .name {
    width: calc(100vw / 320 * 65);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row .input-row>.checkbox-group {
    padding-left: 0;
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row .col-4 {
    width: 100%;
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .link i {
    margin-right: calc(100vw / 320 * 5);
  }

  .page-container #page-main .article-main .article-wrap .template-block .from-block>.row {
    border-bottom-width: calc(100vw / 320 * 1);
  }

  .filter-block {
    border-radius: calc(100vw / 320 * 35) calc(100vw / 320 * 35) calc(100vw / 320 * 10) calc(100vw / 320 * 10);
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 20);
    gap: calc(100vw / 320 * 6);
    flex-wrap: wrap;
    margin-bottom: calc(100vw / 320 * 12);
    justify-content: initial;
  }

  .filter-block.filter-align-bottom .btn {
    flex: 1;
    margin-top: calc(100vw / 320 * 16);
  }

  .filter-block.t-filter-inline {
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 15);
    gap: 0 calc(100vw / 320 * 10);
  }

  .filter-block.t-filter-inline .filter-item select {
    width: calc(100% - (100vw / 320 * 88));
    padding-left: calc(100vw / 320 * 10);
  }

  .filter-block.t-filter-inline .filter-item input {
    width: calc(100vw / 320 * 80);
    padding-left: calc(100vw / 320 * 10);
  }

  .filter-block.t-filter-inline .btn {
    flex: 1;
    margin-top: calc(100vw / 320 * 16);
  }

  .filter-block .filter-item {
    flex-wrap: wrap;
    flex: none;
    width: 100%;
    margin-bottom: calc(100vw / 320 * 2);
  }

  .filter-block .filter-item label {
    margin-bottom: calc(100vw / 320 * 5);
  }

  .filter-block label {
    width: 100%;
  }

  .filter-block label.label-text {
    padding: 0 calc(100vw / 320 * 3);
  }

  .filter-block label[class*="icon-"]::before {
    width: calc(100vw / 320 * 18);
    height: calc(100vw / 320 * 16);
    margin-right: calc(100vw / 320 * 6);
    margin-top: calc(100vw / 320 * 3);
  }

  .filter-block label.icon-category::before {
    width: calc(100vw / 320 * 20);
  }

  .filter-block input,
  .filter-block select {
    flex: auto;
    width: calc(100% - (100vw / 320 * 100));
  }

  .filter-block .btn {
    width: calc(100vw / 320 * 80);
    line-height: calc(100vw / 320 * 38);
    padding-top: calc(100vw / 320 * 2);
  }

  .filter-block .btn.btn-sm {
    width: calc(100vw / 320 * 80);
  }

  .filter-block.filter-collapse {
    border-radius: calc(100vw / 320 * 30) calc(100vw / 320 * 30) 0 0;
  }

  .filter-block.filter-collapse .filter-name {
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 24) calc(100vw / 320 * 12) calc(100vw / 320 * 12);
  }

  .filter-block.filter-collapse .filter-name .name {
    font-size: 1em;
    padding: 0 calc(100vw / 320 * 5);
  }

  .filter-block.filter-collapse .filter-name .name::before,
  .filter-block.filter-collapse .filter-name .name::after {
    margin: calc(100vw / 320 * -2) calc(100vw / 320 * 10) 0;
    width: calc(100vw / 320 * 1);
    height: calc(100vw / 320 * 18);
  }

  .filter-block.filter-collapse .btn-collapse::after {
    width: calc(100vw / 320 * 18);
    height: calc(100vw / 320 * 18);
    margin: calc(100vw / 320 * 2) 0 0 calc(100vw / 320 * 5);
  }

  .filter-block.filter-collapse .collapse-content {
    border-top-width: calc(100vw / 320 * 2);
    border-bottom-width: calc(100vw / 320 * 2);
    box-shadow: calc(100vw / 320 * 6) calc(100vw / 320 * 6) 0 0 rgba(0, 0, 0, 0.06);
    font-size: 0.875em;
    padding: calc(100vw / 320 * 4) 0;
  }

  .filter-block.filter-collapse .collapse-content .row {
    padding: 0 calc(100vw / 320 * 16);
    display: block;
  }

  .filter-block.filter-collapse .collapse-content .row .col {
    display: block;
    margin: calc(100vw / 320 * 12) 0;
  }

  .filter-block.filter-collapse .collapse-content .row .col-auto-2 {
    width: 100%;
  }

  .filter-block.filter-collapse .collapse-content .select {
    width: 100%;
    display: block;
    margin: calc(100vw / 320 * 8) 0;
  }

  .filter-block.filter-collapse .collapse-content select,
  .filter-block.filter-collapse .collapse-content input {
    width: 100%;
  }

  .filter-block.filter-collapse .collapse-content . btn-lg w-100 {
    margin-top: calc(100vw / 320 * 12);
    display: flex !important;
    gap: 0 calc(100vw / 320 * 6) !important;
  }

  .filter-block.filter-collapse .collapse-content . btn-lg w-100 .btn {
    width: 100%;
  }

  .popup {
    max-width: calc(100vw / 320 * 950);
    border-radius: calc(100vw / 320 * 10);
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 15);
  }

  .popup .btn-popup-close {
    width: calc(100vw / 320 * 40);
    height: calc(100vw / 320 * 40);
    right: calc(100vw / 320 * -20);
    top: calc(100vw / 320 * -20);
    border-width: calc(100vw / 320 * 1);
  }

  .popup.popup-info .info-name {
    font-size: 1em;
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 15);
    border-radius: calc(100vw / 320 * 10) calc(100vw / 320 * 10) 0 0;
  }

  .popup.popup-info .info-name i {
    width: calc(100vw / 320 * 18);
    height: calc(100vw / 320 * 18);
    margin-right: calc(100vw / 320 * 10);
    margin-top: calc(100vw / 320 * 2);
  }

  .popup.popup-info .info-name i svg {
    width: calc(100vw / 320 * 18);
    height: calc(100vw / 320 * 18);
  }

  .popup.popup-info .info-content {
    font-size: 0.875em;
    padding: calc(100vw / 320 * 25) calc(100vw / 320 * 15) calc(100vw / 320 * 15);
  }

  .popup.popup-info .info-content i {
    width: calc(100vw / 320 * 12);
    height: calc(100vw / 320 * 12);
  }

  .popup.popup-info .info-content a {
    padding: 0 calc(100vw / 320 * 5);
  }

  .popup.popup-info .info-content hr {
    margin-bottom: calc(100vw / 320 * 16);
    border-top-width: calc(100vw / 320 * 2);
  }

  .popup.popup-info .info-content p {
    margin-bottom: calc(100vw / 320 * 16);
  }

  .popup.popup-info .info-content .filter-block {
    font-size: 1.143em;
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 20);
  }

  .popup.popup-info .info-content .filter-block select {
    padding: 0 calc(100vw / 320 * 38) 0 calc(100vw / 320 * 12);
    width: calc(100vw / 320 * 100);
  }

  .popup.popup-info .info-content .filter-block input {
    padding: calc(100vw / 320 * 2) calc(100vw / 320 * 12) 0;
    width: calc(100vw / 320 * 100);
  }

  .popup.popup-info .info-content .radio-list {
    font-size: 1.143em;
  }

  .row .col-6 {
    width: 100%;
  }

  .btn-more::before {
    width: calc(100vw / 320 * 14);
    height: calc(100vw / 320 * 14);
    background-size: auto calc(100vw / 320 * 6);
    margin-right: calc(100vw / 320 * 5);
    margin-top: calc(100vw / 320 * 4);
  }

  #index-banner .swiper-arrow {
    width: calc(100vw / 320 * 30);
    height: calc(100vw / 320 * 30);
    border-width: calc(100vw / 320 * 1);
  }

  #index-banner .swiper-arrow svg {
    width: calc(100vw / 320 * 30);
    height: calc(100vw / 320 * 30);
  }

  #index-banner .swiper-arrow.swiper-button-prev {
    left: calc(100vw / 320 * 12);
  }

  #index-banner .swiper-arrow.swiper-button-next {
    right: calc(100vw / 320 * 12);
  }

  #index-banner .swiper-pagination-bullet {
    border-width: calc(100vw / 320 * 1);
    width: calc(100vw / 320 * 10);
    height: calc(100vw / 320 * 10);
  }

  #index-banner a {
    height: calc(100vw / 320 * 250);
  }

  #index-news {
    padding-top: calc(100vw / 320 * 15);
  }

  #index-news .btn-anchor {
    left: calc(100vw / 320 * 15);
    top: calc(100vw / 320 * 20);
  }

  #index-news .index-news-top {
    margin-bottom: calc(100vw / 320 * 25);
    position: relative;
  }

  #index-news .index-news-top .index-news-title {
    font-size: calc(100vw / 320 * 30);
    padding-left: calc(100vw / 320 * 30);
    margin: calc(100vw / 320 * 25) 0 calc(100vw / 320 * 22) calc(100vw / 320 * 25);
    letter-spacing: 0.12em;
  }

  #index-news .index-news-top .index-news-title::before {
    font-size: calc(100vw / 320 * 50);
  }

  #index-news .index-news-top .tabs-nav {
    padding: 0 calc(100vw / 320 * 10);
    max-width: 100%;
    overflow-x: auto;
    flex: none;
    display: block;
    white-space: nowrap;
    padding-bottom: calc(100vw / 320 * 4);
  }

  #index-news .index-news-top .tabs-nav a {
    display: inline-block;
    font-size: 1em;
    padding: calc(100vw / 320 * 4) calc(100vw / 320 * 8);
    margin: 0 calc(100vw / 320 * 5) 0 calc(100vw / 320 * 10);
    border-radius: calc(100vw / 320 * 12) calc(100vw / 320 * 12) 0 0;
    min-width: calc(100vw / 320 * 60);
  }

  #index-news .index-news-top .tabs-nav a::before {
    width: calc(100vw / 320 * 1);
    height: calc(100vw / 320 * 20);
    left: calc(100vw / 320 * -10);
    bottom: calc(100vw / 320 * 5);
  }

  #index-news .index-news-top .swiper-control {
    position: absolute;
    right: 0;
    top: calc(100vw / 320 * 31);
  }

  #index-news .index-news-top .swiper-control .swiper-arrow {
    display: none;
  }

  #index-news .newsSwiper {
    padding-bottom: calc(100vw / 320 * 15);
    margin-right: calc(100vw / 320 * -30);
  }

  #index-news .newsSwiper .swiper-slide {
    padding: 0 calc(100vw / 320 * 4);
  }

  #index-news .news-card {
    padding: calc(100vw / 320 * 16) calc(100vw / 320 * 12);
    border-radius: calc(100vw / 320 * 10);
  }

  #index-news .news-card::after {
    border-width: calc(100vw / 320 * 16) calc(100vw / 320 * 18);
    bottom: calc(100vw / 320 * -15);
    right: calc(100vw / 320 * 40);
  }

  #index-news .news-card .news-card-top {
    margin-bottom: calc(100vw / 320 * 8);
    flex-direction: column;
    align-items: initial;
  }

  #index-news .news-card .news-card-top .tag {
    width: 100%;
    padding: calc(100vw / 320 * 5) calc(100vw / 320 * 10) calc(100vw / 320 * 5) calc(100vw / 320 * 30);
    border-radius: calc(100vw / 320 * 50);
    max-width: none;
    margin-bottom: calc(100vw / 320 * 4);
  }

  #index-news .news-card .news-card-top .tag::before {
    width: calc(100vw / 320 * 15);
    height: calc(100vw / 320 * 15);
    left: calc(100vw / 320 * 10);
    top: calc(100vw / 320 * 6);
  }

  #index-news .news-card .news-card-top .date {
    padding: calc(100vw / 320 * 4) 0 calc(100vw / 320 * 4) calc(100vw / 320 * 16);
  }

  #index-news .news-card .news-card-top .date::before {
    width: calc(100vw / 320 * 12);
    height: calc(100vw / 320 * 12);
    top: calc(100vw / 320 * 8);
  }

  #index-news .news-card .news-card-text {
    font-size: 0.875em;
  }

  #index-news .news-card .news-card-text p {
    -webkit-line-clamp: 3;
    height: 4.5em;
  }

  #index-quick {
    margin-bottom: calc(100vw / 320 * 30);
  }

  #index-quick .index-quick-top {
    font-size: 0.875em;
    letter-spacing: 0.1em;
    padding: calc(100vw / 320 * 17) 0 calc(100vw / 320 * 21) calc(100vw / 320 * 120);
    text-align: left;
  }

  #index-quick .index-quick-top::before {
    width: calc(100vw / 320 * 113);
    height: calc(100vw / 320 * 73);
    left: 0;
  }

  #index-quick .index-quick-top::after {
    display: none;
  }

  #index-quick .index-quick-content {
    border-radius: calc(100vw / 320 * 50);
    padding: calc(100vw / 320 * 20) calc(100vw / 320 * 9) 0;
    gap: calc(100vw / 320 * 19);
  }

  #index-quick .index-quick-content a {
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 2) calc(100vw / 320 * 12);
    border-radius: calc(100vw / 320 * 60) calc(100vw / 320 * 60) 0 0;
    width: calc(50% - (100vw / 320 * 10));
    font-size: 1em;
  }

  #index-quick .index-quick-content a .icon {
    width: calc(100vw / 320 * 55);
  }

  #index-more {
    padding-bottom: calc(100vw / 320 * 30);
  }

  #index-more .index-more-top {
    margin-bottom: calc(100vw / 320 * 10);
    padding: 0 calc(100vw / 320 * 7) 0 calc(100vw / 320 * 2);
  }

  #index-more .index-more-top .index-more-title::after {
    width: calc(100vw / 320 * 23);
    height: calc(100vw / 320 * 3);
    margin-left: calc(100vw / 320 * 4);
    margin-top: calc(100vw / 320 * 19);
  }

  #index-more .index-more-content {
    border-width: calc(100vw / 320 * 6);
    box-shadow: calc(100vw / 320 * 4) calc(100vw / 320 * 4) 0 0 rgba(0, 0, 0, 0.15);
    border-radius: calc(100vw / 320 * 12) calc(100vw / 320 * 12) 0 0;
  }

  #index-video {
    padding-top: calc(100vw / 320 * 40);
    padding-right: 0;
    margin-bottom: calc(100vw / 320 * 20);
  }

  #index-video::before {
    width: calc(100vw / 320 * 232);
    height: calc(100vw / 320 * 232);
    left: calc(100vw / 320 * -30);
  }

  #index-video .index-more-top .index-more-title::before {
    width: calc(100vw / 320 * 28);
    height: calc(100vw / 320 * 22);
    margin-right: calc(100vw / 320 * 5);
    margin-top: calc(100vw / 320 * 2);
  }

  #index-resource {
    padding: calc(100vw / 320 * 20) 0 0 0;
  }

  #index-resource::before {
    width: calc(100vw / 320 * 89);
    height: calc(100vw / 320 * 92);
    top: 0;
    left: calc(100vw / 320 * -26);
  }

  #index-resource .index-more-top {
    padding-left: calc(100vw / 320 * 67);
  }

  #index-resource .fullSwiper .swiper-slide {
    height: calc(100vw / 320 * 162);
  }

  #index-resource .swiper-arrow {
    width: calc(100vw / 320 * 30);
    height: calc(100vw / 320 * 30);
    border-width: calc(100vw / 320 * 1);
    box-shadow: calc(100vw / 320 * 4) calc(100vw / 320 * 4) 0 0 rgba(0, 0, 0, 0.2);
  }

  #index-resource .swiper-arrow svg {
    width: calc(100vw / 320 * 30);
    height: calc(100vw / 320 * 30);
  }

  #index-resource .swiper-arrow.swiper-prev {
    left: calc(100vw / 320 * -10);
  }

  #index-resource .swiper-arrow.swiper-next {
    right: calc(100vw / 320 * -10);
  }

  #index-social {
    flex-direction: column;
  }

  #index-social .index-social-top {
    width: 100%;
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 20);
    border-radius: 0 0 calc(100vw / 320 * 60) calc(100vw / 320 * 60);
    border-width: 0 calc(100vw / 320 * 1) calc(100vw / 320 * 1);
    box-shadow: calc(100vw / 320 * 4) calc(100vw / 320 * 4) 0 0 rgba(93, 107, 192, 0.15);
    margin-right: 0;
    margin-bottom: calc(100vw / 320 * 20);
    justify-content: center;
  }

  #index-social .index-social-top .icon {
    width: calc(100vw / 320 * 60);
    height: calc(100vw / 320 * 60);
    margin-right: calc(100vw / 320 * 6);
  }

  #index-social .index-social-top .text p {
    letter-spacing: 0.05em;
  }

  #index-social .index-social-top .text p i {
    width: calc(100vw / 320 * 20);
    margin-right: calc(100vw / 320 * 6);
    margin-top: calc(100vw / 320 * -1);
  }

  #index-social .index-social-content {
    width: 100%;
    padding: 0;
  }

  #index-social .index-social-content .swiper-arrow {
    display: none;
  }

  #index-social .index-social-content .socialSwiper {
    margin-right: calc(100vw / 320 * -60);
  }

  #index-social .index-social-content .socialSwiper .swiper-slide {
    padding: calc(100vw / 320 * 5) calc(100vw / 320 * 8);
  }

  #index-social .index-social-content .socialSwiper .swiper-slide a {
    border-width: calc(100vw / 320 * 1);
    box-shadow: calc(100vw / 320 * 4) calc(100vw / 320 * 4) 0 0 rgba(0, 0, 0, 0.15);
    border-radius: calc(100vw / 320 * 8);
  }

  .popup-album .album-info {
    margin-bottom: calc(100vw / 320 * 5);
  }

  .popup-album .album-info .info-item {
    border-width: calc(100vw / 320 * 1);
    border-radius: calc(100vw / 320 * 50);
    padding: calc(100vw / 320 * 5) calc(100vw / 320 * 12);
    margin-right: calc(100vw / 320 * 4);
    margin-bottom: calc(100vw / 320 * 4);
  }

  .popup-album .album-info .info-item i {
    width: calc(100vw / 320 * 12);
    height: calc(100vw / 320 * 13);
    margin-right: calc(100vw / 320 * 6);
    margin-top: calc(100vw / 320 * -2);
  }

  .popup-album .album-content .album {
    margin-top: calc(100vw / 320 * 10);
    border-radius: calc(100vw / 320 * 4);
  }

  body {
    font-size: calc(100vw / 320 * 16);
  }

  body[data-size="sm"] #header #tools-menu li a {
    padding: calc(100vw / 320 * 2) calc(100vw / 320 * 8);
  }

  body[data-size="sm"] #header #tools-menu li.setting .setting-name i img {
    margin-top: calc(100vw / 320 * 1);
  }

  body[data-size="sm"] #menu ul li .sub>li>a::before {
    top: calc(100vw / 320 * 18);
  }

  body[data-size="sm"] #menu ul li .sub>li>a.sub-arrow::after {
    top: calc(100vw / 320 * 10);
  }

  body[data-size="sm"] #menu>ul>li>a.sub-arrow::after {
    top: calc(100vw / 320 * 10);
  }

  body[data-size="sm"] #footer .footer-top .footer-info .footer-menu li a {
    padding: calc(100vw / 768 * 5) calc(100vw / 768 * 15);
  }

  body[data-size="sm"] #footer .footer-bottom {
    padding: calc(100vw / 768 * 20) calc(100vw / 768 * 8);
  }

  body[data-size="sm"] #footer .footer-bottom li::before {
    height: calc(100vw / 320 * 8);
    top: calc(100vw / 320 * 6);
  }

  body[data-size="sm"] .page-container #page-main .page-content .news-list .news-item .news-text .news-bottom .btn-more::before {
    margin-top: calc(100vw / 320 * 2);
  }

  body[data-size="sm"] .page-container #page-main .page-content table i {
    margin-top: calc(100vw / 320 * 1);
  }

  body[data-size="sm"] .filter-block label::before {
    margin-top: calc(100vw / 320 * 1);
  }

  body[data-size="sm"] .btn-more::before {
    margin-top: calc(100vw / 320 * 1);
  }

  body[data-size="sm"] #index-news .index-news-top .tabs-nav a::before {
    bottom: calc(100vw / 320 * 2);
  }

  body[data-size="sm"] #index-news .news-card .news-card-top .tag::before {
    top: calc(100vw / 320 * 4);
  }

  body[data-size="sm"] #index-news .news-card .news-card-top .date::before {
    top: calc(100vw / 320 * 5);
  }

  body[data-size="sm"] #index-quick .index-quick-top {
    letter-spacing: 0.35em;
    padding-left: calc(100vw / 320 * 128);
  }

  body[data-size="sm"] #index-more .index-more-top .index-more-title::after {
    margin-top: calc(100vw / 320 * 12);
  }

  body[data-size="lg"] #header #tools-menu {
    padding: calc(100vw / 320 * 20) calc(100vw / 320 * 10) calc(100vw / 320 * 30);
  }

  body[data-size="lg"] #menu ul li a {
    padding: calc(100vw / 320 * 16) calc(100vw / 320 * 49) calc(100vw / 320 * 16) calc(100vw / 320 * 22);
  }

  body[data-size="lg"] #menu ul li .sub>li>a::before {
    top: calc(100vw / 320 * 21);
  }

  body[data-size="lg"] #menu ul li .sub a {
    padding: calc(100vw / 320 * 16) calc(100vw / 320 * 49) calc(100vw / 320 * 16) calc(100vw / 320 * 40);
  }

  body[data-size="lg"] #menu>ul>li:not(.btn-search)>a {
    padding: calc(100vw / 320 * 16) calc(100vw / 320 * 49) calc(100vw / 320 * 16) calc(100vw / 320 * 22);
  }

  body[data-size="lg"] #footer .footer-top {
    gap: calc(100vw / 768 * 20) calc(100vw / 768 * 4);
  }

  body[data-size="lg"] #footer .footer-top .footer-info .footer-menu li a {
    padding: calc(100vw / 768 * 1) calc(100vw / 768 * 8);
  }

  body[data-size="lg"] #footer .footer-bottom {
    padding: calc(100vw / 768 * 20) calc(100vw / 768 * 8);
  }

  body[data-size="lg"] .page-container #page-main .page-content .news-list .news-item .news-text .news-bottom .btn-more::before {
    margin-top: calc(100vw / 320 * 3);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num {
    gap: 0 calc(100vw / 320 * 6);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a,
  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li span {
    line-height: calc(100vw / 320 * 38);
    min-width: calc(100vw / 320 * 40);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow {
    padding: 0 calc(100vw / 320 * 10);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-prev {
    border-radius: calc(100vw / 320 * 40) calc(100vw / 320 * 4) calc(100vw / 320 * 4) calc(100vw / 320 * 40);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-prev::before {
    margin-top: calc(100vw / 320 * 14);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-next {
    border-radius: calc(100vw / 320 * 4) calc(100vw / 320 * 40) calc(100vw / 320 * 40) calc(100vw / 320 * 4);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-num li a.page-arrow.page-next::after {
    margin-top: calc(100vw / 320 * 14);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page label,
  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page span {
    margin: 0 calc(100vw / 320 * 2);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page input {
    line-height: calc(100vw / 320 * 35);
    width: calc(100vw / 320 * 100);
  }

  body[data-size="lg"] .page-container #page-main .page-content .pagination .pagination-page .btn {
    line-height: calc(100vw / 320 * 37);
  }

  body[data-size="lg"] .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .name {
    width: 100%;
  }

  body[data-size="lg"] .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row {
    padding-left: 0;
  }

  body[data-size="lg"] .page-container #page-main .page-content .tabs.tabs-apply .tabs-content .content .input-row .text-row.code-row input {
    width: 100%;
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .checkbox-group.row {
    width: 100%;
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>input,
  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>select,
  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>textarea,
  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.row,
  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.checkbox-group,
  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row>.radio-group {
    width: 100%;
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .name {
    width: 100%;
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-sm {
    width: calc(100vw / 320 * 100);
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .input-sm-auto {
    width: calc(100% - (100vw / 320 * 108));
  }

  body[data-size="lg"] .page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .row .input-row .name {
    width: calc(100vw / 320 * 75);
  }

  body[data-size="lg"] .filter-block.t-filter-inline {
    padding: calc(100vw / 320 * 12) calc(100vw / 320 * 12);
  }

  body[data-size="lg"] .filter-block.t-filter-inline .filter-item select {
    width: calc(100% - (100vw / 320 * 92));
  }

  body[data-size="lg"] .btn-more::before {
    margin-top: calc(100vw / 320 * 3);
  }

  body[data-size="lg"] #index-news .index-news-top .tabs-nav {
    padding: 0 calc(100vw / 320 * 10);
  }

  body[data-size="lg"] #index-news .index-news-top .tabs-nav a {
    padding: calc(100vw / 320 * 4) calc(100vw / 320 * 8);
    margin: 0 calc(100vw / 320 * 5) 0 calc(100vw / 320 * 10);
  }

  body[data-size="lg"] #index-news .news-card .news-card-top .tag::before {
    top: calc(100vw / 320 * 6);
  }

  body[data-size="lg"] #index-news .news-card .news-card-top .date::before {
    top: calc(100vw / 320 * 7);
  }

  body[data-size="lg"] #index-quick .index-quick-top {
    letter-spacing: 0.15em;
    padding: calc(100vw / 320 * 17) 0 calc(100vw / 320 * 21) calc(100vw / 320 * 120);
  }

  body[data-size="lg"] #index-resource::before {
    left: calc(100vw / 320 * -26);
  }

  body[data-size="lg"] #index-resource .index-more-top {
    padding-left: calc(100vw / 320 * 67);
  }

  body[data-size="lg"] #index-social .index-social-top {
    width: 100%;
    padding: calc(100vw / 320 * 10) calc(100vw / 320 * 20) calc(100vw / 320 * 14);
  }

  body[data-size="lg"] #index-social .index-social-content {
    width: 100%;
    padding: 0;
  }

  #app {
    padding-top: calc(100vw / 320 * 69) !important;
  }
}

.btn-side:hover.btn-top,
.btn-side:focus.btn-top {
  background-color: #d14600;
}

.btn-side:hover.btn-back,
.btn-side:focus.btn-back {
  background-color: #5d6bc0;
}

#header #tools-menu li:hover .sub {
  display: block;
}

#header #tools-menu li a:hover,
#header #tools-menu li a:focus {
  color: #fff;
  background-color: #5d6bc0;
}

#header #tools-menu li a:hover.sub-arrow::after,
#header #tools-menu li a:focus.sub-arrow::after {
  border-top-color: #fff;
}

#header #tools-menu li a:hover i svg,
#header #tools-menu li a:focus i svg {
  fill: #fff;
}

#header #tools-menu li .sub a:hover,
#header #tools-menu li .sub a:focus {
  background-color: #5d6bc0;
  color: #fff;
}

#header #tools-menu li .setting a:not(.active):hover,
#header #tools-menu li .setting a:not(.active):focus {
  background-color: #c2c7f7;
}

#menu ul li a:hover,
#menu ul li a:focus {
  background-color: rgba(255, 255, 255, 0.1);
}

#menu ul li.btn-search a:hover,
#menu ul li.btn-search a:focus {
  background-color: #f7f7f7;
}

#menu ul li.btn-search a:hover::after,
#menu ul li.btn-search a:focus::after {
  background-image: url(/assets/images/template/icon_search_r.svg);
}

#menu ul li.btn-search a:hover.active::after,
#menu ul li.btn-search a:focus.active::after {
  background-image: url(/assets/images/template/icon_close_r.svg);
}

#menu ul li .sub a:hover,
#menu ul li .sub a:focus {
  background-color: #5d6bc0;
  color: #fff;
}

#menu ul li .sub>li>a:hover::before,
#menu ul li .sub>li>a:focus::before {
  background-image: url(/assets/images/template/icon_arrow_w.svg);
}

#menu ul li .sub>li>a:hover.sub-arrow::after,
#menu ul li .sub>li>a:focus.sub-arrow::after {
  background-image: url(/assets/images/template/menu_open.svg);
}

#menu ul li .sub>li>a:hover.sub-arrow.open::after,
#menu ul li .sub>li>a:focus.sub-arrow.open::after {
  background-image: url(/assets/images/template/menu_close.svg);
}

#menu .search-block .wrap .btn:hover,
#menu .search-block .wrap .btn:focus {
  background-color: #d14600;
}

#footer a:hover,
#footer a:focus {
  background-color: #5d6bc0;
  color: #fff;
}

#footer .footer-top .footer-logo-group a:hover,
#footer .footer-top .footer-logo-group a:focus {
  background-color: transparent;
}

.btn-more:hover,
.btn-more:focus {
  color: #5d6bc0;
}

.btn-more:hover::before,
.btn-more:focus::before {
  background-color: #5d6bc0;
}

.popup .btn-popup-close:hover,
.popup .btn-popup-close:focus {
  background-color: #d14600;
}

.popup.popup-info .info-content a:hover,
.popup.popup-info .info-content a:focus {
  background-color: #5d6bc0;
  color: #fff;
  text-decoration: none;
}

.btn:hover,
.btn:focus {
  background-color: #d14600;
}

.btn.btn-lg:hover,
.btn.btn-lg:focus,
.btn.btn-sm:hover,
.btn.btn-sm:focus {
  border-color: #d14600;
}

.btn.btn-outline:hover,
.btn.btn-outline:focus {
  border-color: #d14600;
  color: #d14600;
  background-color: #f7f7f7;
}

.btn.btn-outline-r:hover,
.btn.btn-outline-r:focus {
  color: #fff;
  border-color: #d14600;
  background-color: #d14600;
}

.btn.btn-outline-r:hover .st0,
.btn.btn-outline-r:focus .st0 {
  fill: #fff;
}

.btn.btn-outline-g:hover,
.btn.btn-outline-g:focus {
  color: #fff;
  border-color: #46cbaa;
  background-color: #46cbaa;
}

.btn.btn-outline-b:hover,
.btn.btn-outline-b:focus {
  color: #fff;
  border-color: #5d6bc0;
  background-color: #5d6bc0;
}

.btn.btn-outline-b:hover .st0,
.btn.btn-outline-b:focus .st0 {
  fill: #fff;
}

.btn.btn-r:hover,
.btn.btn-r:focus {
  background-color: #5d6bc0;
}

.checkbox-item>input:focus,
.radio-item>input:focus {
  outline: none !important;
}

.checkbox-item>input:focus+label,
.radio-item>input:focus+label {
  outline: 2px dashed #d14600 !important;
}

.radio-list .radio-item>input:focus+label {
  background-color: #c2c7f7 !important;
}

.radio-list .radio-item>input+label:hover {
  background-color: #c2c7f7 !important;
}

.page-container #page-main .page-content .tabs .tabs-nav a:hover,
.page-container #page-main .page-content .tabs .tabs-nav a:focus {
  position: relative;
  border-style: solid;
  border-color: #5d6bc0;
  background-color: #fff;
  color: #313131;
}

.page-container #page-main .page-content .tabs .tabs-nav a:hover::after,
.page-container #page-main .page-content .tabs .tabs-nav a:focus::after {
  content: "";
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border-width: 3px 0 0 0;
  border-style: solid;
  border-color: #5d6bc0;
  position: absolute;
  border-radius: 28px 28px 0 0;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-nav a:hover,
.page-container #page-main .page-content .tabs.tabs-apply .tabs-nav a:focus {
  position: relative;
  border: none;
  color: #fff;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-nav a:hover::after,
.page-container #page-main .page-content .tabs.tabs-apply .tabs-nav a:focus::after {
  display: none;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-nav a.bg-g3:hover,
.page-container #page-main .page-content .tabs.tabs-apply .tabs-nav a.bg-g3:focus {
  background-color: #46cbaa !important;
}

.page-container #page-main .page-content .tabs.tabs-apply .tabs-nav a.bg-r1:hover,
.page-container #page-main .page-content .tabs.tabs-apply .tabs-nav a.bg-r1:focus {
  background-color: #f58531 !important;
}

.page-container #page-main .page-content .news-list .news-item:hover {
  background-color: #f7f7f7;
}

.page-container #page-main .page-content .news-list .news-item .news-img img {
  transition: all 0.3s;
}

.page-container #page-main .page-content .news-list .news-item .news-img:hover img,
.page-container #page-main .page-content .news-list .news-item .news-img:focus img {
  transform: translateX(-50%) translateY(-50%) scale(1.05, 1.05);
}

.page-container #page-main .page-content .news-list .news-item .news-img:hover.icon-video::after,
.page-container #page-main .page-content .news-list .news-item .news-img:focus.icon-video::after {
  background-color: rgba(93, 107, 192, 0.9);
}

.page-container #page-main .page-content .news-list .news-item .news-text:focus {
  background-color: #f7f7f7;
}

.page-container #page-main .page-content .media-list .media-item:hover,
.page-container #page-main .page-content .media-list .media-item:focus {
  background-color: #f7f7f7;
}

.page-container #page-main .page-content .media-list .media-item:hover .media-img img,
.page-container #page-main .page-content .media-list .media-item:focus .media-img img {
  transform: translateX(-50%) translateY(-50%) scale(1.05, 1.05);
}

.page-container #page-main .page-content .media-list .media-item:hover .media-img::after,
.page-container #page-main .page-content .media-list .media-item:focus .media-img::after {
  background-color: rgba(93, 107, 192, 0.9);
}

.page-container #page-main .page-content .media-list .media-item .media-img img {
  transition: all 0.3s;
}

.page-container #page-main .page-content .download-list li a:hover,
.page-container #page-main .page-content .download-list li a:focus {
  background-color: #f7f7f7;
}

.page-container #page-main .page-content .faq-list .faq-item .faq-header:hover,
.page-container #page-main .page-content .faq-list .faq-item .faq-header:focus {
  background-color: #f7f7f7;
}

.page-container #page-main .page-content .faq-list .faq-item .faq-header:hover .name .top .tag,
.page-container #page-main .page-content .faq-list .faq-item .faq-header:focus .name .top .tag {
  background-color: #5d6bc0;
  color: #fff;
}

.page-container #page-main .page-content .pagination .pagination-num li a:hover,
.page-container #page-main .page-content .pagination .pagination-num li a:focus {
  background-color: #edeffa;
}

.page-container #page-main .page-content .pagination .pagination-num li a.page-arrow:hover,
.page-container #page-main .page-content .pagination .pagination-num li a.page-arrow:focus {
  border-color: #d14600;
  background-color: #d14600;
}

.page-container #page-main .page-content table tbody tr.tr-link:hover {
  background-color: #c2c7f7 !important;
}

.page-container #page-main .page-content table .download-list li a:hover,
.page-container #page-main .page-content table .download-list li a:focus {
  background-color: #c2c7f7;
  color: #5d6bc0 !important;
}

.page-container #page-main .page-content .tag-list .tag-item .download-list li a:hover,
.page-container #page-main .page-content .tag-list .tag-item .download-list li a:focus {
  text-decoration: none;
}

.page-container #page-main .page-content .sitemap-list .sitemap-name:hover,
.page-container #page-main .page-content .sitemap-list .sitemap-name:focus {
  background-color: #5d6bc0;
  color: #fff !important;
}

.page-container #page-main .page-content .sitemap-list .sitemap-name:hover span,
.page-container #page-main .page-content .sitemap-list .sitemap-name:focus span {
  color: #fff !important;
}

.page-container #page-main .page-content .sitemap-list .link:hover,
.page-container #page-main .page-content .sitemap-list .link:focus {
  background-color: #5d6bc0;
  color: #fff !important;
}

.page-container #page-main .page-content .sitemap-list .link:hover span,
.page-container #page-main .page-content .sitemap-list .link:focus span {
  color: #fff !important;
}

.page-container #page-main .article-main .article-wrap .article-share a:hover,
.page-container #page-main .article-main .article-wrap .article-share a:focus {
  opacity: 0.8;
}

.page-container #page-main .article-main .article-wrap .article-share a:hover img,
.page-container #page-main .article-main .article-wrap .article-share a:focus img {
  transform: scale(1.1, 1.1);
}

.page-container #page-main .article-main .article-wrap .article a:hover,
.page-container #page-main .article-main .article-wrap .article a:focus {
  color: #d14600;
}

.page-container #page-main .article-main .article-wrap .article-content-bottom .article-bottom-img img {
  transition: all 0.3s;
}

.page-container #page-main .article-main .article-wrap .article-content-bottom .article-bottom-img:hover img,
.page-container #page-main .article-main .article-wrap .article-content-bottom .article-bottom-img:focus img {
  transform: translateX(-50%) translateY(-50%) scale(1.05, 1.05);
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .link:hover,
.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .link:focus {
  text-decoration: none;
  background-color: #5d6bc0;
  color: #fff;
}

.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .link:hover i svg,
.page-container #page-main .article-main .article-wrap .template-block .from-block .input-row .link:focus i svg {
  fill: #fff;
}

.filter-block.filter-collapse .btn-collapse:hover,
.filter-block.filter-collapse .btn-collapse:focus {
  color: #d14600;
}

.filter-block.filter-collapse .btn-collapse:hover::after,
.filter-block.filter-collapse .btn-collapse:focus::after {
  background-image: url(/assets/images/template/btn_collapse_open_r.svg);
}

.filter-block.filter-collapse.active .btn-collapse:hover::after,
.filter-block.filter-collapse.active .btn-collapse:focus::after {
  background-image: url(/assets/images/template/btn_collapse_close_r.svg);
}

#index-banner .swiper-arrow:hover,
#index-banner .swiper-arrow:focus {
  background-color: #5d6bc0;
  transition: all 0.3s;
}

#index-banner .swiper-arrow:hover svg .st0,
#index-banner .swiper-arrow:focus svg .st0 {
  fill: #fff;
}

#index-banner .swiper-arrow:focus {
  outline: 2px dashed #d14600 !important;
}

#index-banner a img {
  transition: all 0.3s;
}

#index-banner a:hover img,
#index-banner a:focus img {
  transform: scale(1.05, 1.05);
}

#index-banner .swiper-pagination-bullet:focus {
  outline: 2px dashed #d14600 !important;
}

#index-news .btn-anchor:hover,
#index-news .btn-anchor:focus {
  background-color: #5d6bc0;
  color: #fff;
}

#index-news .index-news-top .tabs-nav a:hover,
#index-news .index-news-top .tabs-nav a:focus {
  background-color: #d14600;
  color: #fff;
}

#index-news .index-news-top .swiper-control .swiper-arrow:not(.btn-disabled):hover,
#index-news .index-news-top .swiper-control .swiper-arrow:not(.btn-disabled):focus {
  background-color: #5d6bc0;
}

#index-news .index-news-top .swiper-control .swiper-arrow:not(.btn-disabled):hover .st0,
#index-news .index-news-top .swiper-control .swiper-arrow:not(.btn-disabled):focus .st0 {
  fill: #fff;
}

#index-news .news-card:hover,
#index-news .news-card:focus {
  background-color: #5d6bc0;
}

#index-news .news-card:hover::after,
#index-news .news-card:focus::after {
  border-color: #5d6bc0 #5d6bc0 transparent transparent;
}

#index-news .news-card:hover .news-card-top .tag,
#index-news .news-card:focus .news-card-top .tag {
  background-color: #fff;
  color: #5d6bc0;
}

#index-news .news-card:hover .news-card-top .tag::before,
#index-news .news-card:focus .news-card-top .tag::before {
  background-image: url(/assets/images/template/icon_user_checked_b.svg);
}

#index-news .news-card:hover .news-card-top .date,
#index-news .news-card:focus .news-card-top .date {
  color: #fff;
}

#index-news .news-card:hover .news-card-top .date::before,
#index-news .news-card:focus .news-card-top .date::before {
  background-image: url(/assets/images/template/icon_clock_w.svg);
}

#index-news .news-card:hover .news-card-text,
#index-news .news-card:focus .news-card-text {
  color: #fff;
}

#index-quick .index-quick-content a:hover,
#index-quick .index-quick-content a:focus {
  box-shadow: 0px -9px 14px 0px rgba(245, 133, 49, 0.4);
}

#index-resource .swiper-arrow:hover,
#index-resource .swiper-arrow:focus {
  background: #d14600;
}

#index-social .index-social-top:hover,
#index-social .index-social-top:focus {
  box-shadow: 0px 9px 14px 0px rgba(245, 133, 49, 0.4);
}

#index-social .index-social-content .swiper-arrow:hover,
#index-social .index-social-content .swiper-arrow:focus {
  background-color: #5d6bc0;
}

#index-social .index-social-content .swiper-arrow:hover svg .st0,
#index-social .index-social-content .swiper-arrow:focus svg .st0 {
  fill: #fff;
}

#index-social .index-social-content .socialSwiper .swiper-slide a img {
  transition: all 0.3s;
}

#index-social .index-social-content .socialSwiper .swiper-slide a:hover img,
#index-social .index-social-content .socialSwiper .swiper-slide a:focus img {
  transform: scale(1.1, 1.1);
}

@media screen and (min-width: 1024px) {
  #menu>ul>li:hover>a:not(.search-element) {
    background-color: rgba(255, 255, 255, 0.1);
  }

  #menu>ul>li:hover>.sub {
    display: block;
  }
}

@page {
  size: A4;
  margin: 30px 10px;
}

@media print {
  body {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    page-break-inside: avoid;
    overflow: visible !important;
    height: auto !important;
  }

  #app {
    padding-top: 0 !important;
  }

  #header {
    position: static !important;
    border-bottom: 5px solid #5d6bc0;
  }

  #header #tools-menu {
    display: none !important;
  }

  #header.page-header .logo {
    width: 100%;
  }

  #header.page-header .logo img {
    width: 336px;
  }

  #header.page-header .logo::after {
    right: 0;
  }

  #menu,
  #footer,
  #page-sidebar {
    display: none !important;
  }

  #container {
    background: none !important;
  }

  .btn-side,
  .sr-only {
    display: none !important;
  }

  .page-container {
    background: none !important;
  }

  .page-container #page-main {
    width: 100% !important;
    padding: 0 !important;
  }

  .page-container #page-main .article-main .article-wrap .article-share {
    display: none !important;
  }

  .page-container #page-main .article-main .article-wrap .article-content-bottom {
    margin-top: 20px !important;
  }
}

/***
	create 2024/06/08
	author Kinjen
***/
/* Removed external Google Fonts to satisfy CSP; rely on system fonts */
#header {
  padding-top: 12px;
}

#header #tools-menu li.setting {
  display: flex;
  align-items: center;
}

#header #tools-menu li.setting .setting-name i {
  display: none;
}

#menu ul li {
  flex: 1;
}

#menu ul li .sub {
  width: 100%;
}

#footer .footer-top .footer-info {
  margin-top: 30px;
}

.page-container #page-main {
  width: 100%;
}

.page-container #page-main .article-main .article-tag li::after {
  margin: 0px 7px 0 9px;
}

.page-container #page-main .page-content table thead th {
  text-align: left;
}

.page-container #page-main .page-content .article figure {
  text-align: left;
  max-width: 530px;
}

.page-container #page-main .page-content .article figure figcaption {
  background-color: #edeffa;
  padding: 8px 12px;
  font-size: 0.875em;
  margin-top: 6px;
}

@media screen and (max-width: 1440px) {
  #footer .footer-top .footer-info {
    margin-top: 18px;
  }
}

@media screen and (max-width: 1023px) {
  #header {
    padding-top: calc(100vw / 768 * 11);
    padding-bottom: calc(100vw / 768 * 10);
  }

  #footer .footer-top {
    gap: calc(100vw / 768 * 10) calc(100vw / 768 * 4);
  }

  #footer .footer-top .footer-info {
    margin-top: calc(100vw / 768 * -8);
    margin-bottom: calc(100vw / 768 * 6);
  }

  .page-container #page-main .article-main .article-tag li {
    display: block;
    margin: 0 0 calc(100vw / 768 * 5);
  }

  .page-container #page-main .article-main .article-tag li::before {
    width: calc(100vw / 768 * 14);
    height: calc(100vw / 768 * 14);
    margin-right: calc(100vw / 768 * 6);
    display: inline-block;
    vertical-align: top;
    margin-top: 0.3em;
  }

  .page-container #page-main .article-main .article-tag li::after {
    display: none;
  }

  .page-container #page-main .page-content .article figure {
    max-width: calc(100vw / 768 * 530);
  }

  .page-container #page-main .page-content .article figure figcaption {
    padding: calc(100vw / 768 * 8) calc(100vw / 768 * 12);
    margin-top: calc(100vw / 768 * 6);
  }
}

@media screen and (max-width: 767px) {
  #header {
    padding-top: calc(100vw / 320 * 11);
    padding-bottom: calc(100vw / 320 * 10);
  }

  #footer .footer-top {
    gap: calc(100vw / 320 * 10) calc(100vw / 320 * 4);
  }

  #footer .footer-top .footer-info {
    margin-top: calc(100vw / 320 * -4);
    margin-bottom: calc(100vw / 320 * 6);
  }

  .page-container #page-main .article-main .article-tag li {
    margin: 0 0 calc(100vw / 320 * 5);
  }

  .page-container #page-main .article-main .article-tag li::before {
    width: calc(100vw / 320 * 14);
    height: calc(100vw / 320 * 14);
    margin-right: calc(100vw / 320 * 6);
    margin-top: 0.3em;
  }

  .page-container #page-main .page-content .article figure {
    max-width: none;
    width: 100%;
  }

  .page-container #page-main .page-content .article figure figcaption {
    padding: calc(100vw / 320 * 8) calc(100vw / 320 * 12);
    margin-top: calc(100vw / 320 * 6);
  }

  .page-container #page-main .page-content table.table-horizontal tbody td {
    padding-left: calc(100vw / 320 * 150);
  }

  .page-container #page-main .page-content table.table-horizontal tbody td::before {
    width: calc(100vw / 320 * 120);
  }

  body[data-size="lg"] .page-container #page-main .page-content table.table-horizontal tbody td {
    padding-left: calc(100vw / 320 * 165);
  }

  body[data-size="lg"] .page-container #page-main .page-content table.table-horizontal tbody td::before {
    width: calc(100vw / 320 * 135);
  }
}
</style>
<style>
.v-select {
  width: calc(100% - 253px);
  line-height: 40px;
  height: 40px;
}

.v-select .vs__dropdown-toggle {
  min-height: 40px;
  height: 100%;
}

.v-select .vs__search {
  padding-top: 0;
  padding-bottom: 0;
}

@media screen and (max-width: 1023px) {
  .v-select {
    width: calc(100% - 253px);
    line-height: 40px;
    height: 40px;
  }
}

@media screen and (max-width: 767px) {
  .v-select {
    width: 100%;
    line-height: 40px;
    height: 80px;
  }
}

.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
